import * as Po from "vue";
import { defineComponent as $t, h as Xs, inject as vl, onMounted as dr, onUnmounted as yl, Fragment as Nn, ref as Ve, shallowRef as _l, computed as Ye, watch as Yo, createVNode as Wo, Text as El, createElementBlock as ee, openBlock as X, createElementVNode as _, toDisplayString as j, unref as K, createTextVNode as Lt, renderList as mr, reactive as Zs, normalizeClass as tn, createCommentVNode as Ue, withModifiers as kl, withDirectives as Io, vModelText as $o, normalizeProps as xl, guardReactiveProps as Cl, createBlock as Al } from "vue";
/*!
  * shared v11.3.1
  * (c) 2026 kazuya kawaguchi
  * Released under the MIT License.
  */
function pt(e, t) {
  typeof console < "u" && (console.warn("[intlify] " + e), t && console.warn(t.stack));
}
const es = {};
function Ll(e) {
  es[e] || (es[e] = !0, pt(e));
}
const Ct = typeof window < "u";
let We, qt;
if (process.env.NODE_ENV !== "production") {
  const e = Ct && window.performance;
  e && e.mark && e.measure && e.clearMarks && // @ts-ignore browser compat
  e.clearMeasures && (We = (t) => {
    e.mark(t);
  }, qt = (t, n, o) => {
    e.measure(t, n, o), e.clearMarks(n), e.clearMarks(o);
  });
}
const Tl = /\{([0-9a-zA-Z]+)\}/g;
function ho(e, ...t) {
  return t.length === 1 && se(t[0]) && (t = t[0]), (!t || !t.hasOwnProperty) && (t = {}), e.replace(Tl, (n, o) => t.hasOwnProperty(o) ? t[o] : "");
}
const At = (e, t = !1) => t ? Symbol.for(e) : Symbol(e), Nl = (e, t, n) => Ol({ l: e, k: t, s: n }), Ol = (e) => JSON.stringify(e).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029").replace(/\u0027/g, "\\u0027"), Ae = (e) => typeof e == "number" && isFinite(e), Js = (e) => fr(e) === "[object Date]", Kn = (e) => fr(e) === "[object RegExp]", go = (e) => ie(e) && Object.keys(e).length === 0, Le = Object.assign, Pl = Object.create, le = (e = null) => Pl(e);
let ts;
const Ht = () => ts || (ts = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : le());
function ns(e) {
  return e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/\//g, "&#x2F;").replace(/=/g, "&#x3D;");
}
function os(e) {
  return e.replace(/&(?![a-zA-Z0-9#]{2,6};)/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&apos;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}
function Il(e) {
  return e = e.replace(/(\w+)\s*=\s*"([^"]*)"/g, (o, r, s) => `${r}="${os(s)}"`), e = e.replace(/(\w+)\s*=\s*'([^']*)'/g, (o, r, s) => `${r}='${os(s)}'`), /\s*on\w+\s*=\s*["']?[^"'>]+["']?/gi.test(e) && (process.env.NODE_ENV !== "production" && pt("Potentially dangerous event handlers detected in translation. Consider removing onclick, onerror, etc. from your translation messages."), e = e.replace(/(\s+)(on)(\w+\s*=)/gi, "$1&#111;n$3")), [
    // In href, src, action, formaction attributes
    /(\s+(?:href|src|action|formaction)\s*=\s*["']?)\s*javascript:/gi,
    // In style attributes within url()
    /(style\s*=\s*["'][^"']*url\s*\(\s*)javascript:/gi
  ].forEach((o) => {
    e = e.replace(o, "$1javascript&#58;");
  }), e;
}
const $l = Object.prototype.hasOwnProperty;
function nt(e, t) {
  return $l.call(e, t);
}
const ye = Array.isArray, fe = (e) => typeof e == "function", M = (e) => typeof e == "string", ve = (e) => typeof e == "boolean", se = (e) => e !== null && typeof e == "object", Sl = (e) => se(e) && fe(e.then) && fe(e.catch), Qs = Object.prototype.toString, fr = (e) => Qs.call(e), ie = (e) => fr(e) === "[object Object]", Dl = (e) => e == null ? "" : ye(e) || ie(e) && e.toString === Qs ? JSON.stringify(e, null, 2) : String(e);
function wr(e, t = "") {
  return e.reduce((n, o, r) => r === 0 ? n + o : n + t + o, "");
}
const rs = 2;
function Ml(e, t = 0, n = e.length) {
  const o = e.split(/\r?\n/);
  let r = 0;
  const s = [];
  for (let a = 0; a < o.length; a++)
    if (r += o[a].length + 1, r >= t) {
      for (let i = a - rs; i <= a + rs || n > r; i++) {
        if (i < 0 || i >= o.length)
          continue;
        const l = i + 1;
        s.push(`${l}${" ".repeat(3 - String(l).length)}|  ${o[i]}`);
        const p = o[i].length;
        if (i === a) {
          const y = t - (r - p) + 1, k = Math.max(1, n > r ? p - y : n - t);
          s.push("   |  " + " ".repeat(y) + "^".repeat(k));
        } else if (i > a) {
          if (n > r) {
            const y = Math.max(Math.min(n - r, p), 1);
            s.push("   |  " + "^".repeat(y));
          }
          r += p + 1;
        }
      }
      break;
    }
  return s.join(`
`);
}
function Rl() {
  const e = /* @__PURE__ */ new Map();
  return {
    events: e,
    on(n, o) {
      const r = e.get(n);
      r && r.push(o) || e.set(n, [o]);
    },
    off(n, o) {
      const r = e.get(n);
      r && r.splice(r.indexOf(o) >>> 0, 1);
    },
    emit(n, o) {
      (e.get(n) || []).slice().map((r) => r(o)), (e.get("*") || []).slice().map((r) => r(n, o));
    }
  };
}
const Hn = (e) => !se(e) || ye(e);
function zn(e, t) {
  if (Hn(e) || Hn(t))
    throw new Error("Invalid value");
  const n = [{ src: e, des: t }];
  for (; n.length; ) {
    const { src: o, des: r } = n.pop();
    Object.keys(o).forEach((s) => {
      s !== "__proto__" && (se(o[s]) && !se(r[s]) && (r[s] = Array.isArray(o[s]) ? [] : le()), Hn(r[s]) || Hn(o[s]) ? r[s] = o[s] : n.push({ src: o[s], des: r[s] }));
    });
  }
}
/*!
  * message-compiler v11.3.1
  * (c) 2026 kazuya kawaguchi
  * Released under the MIT License.
  */
function Bl(e, t, n) {
  return { line: e, column: t, offset: n };
}
function qo(e, t, n) {
  return { start: e, end: t };
}
const q = {
  // tokenizer error codes
  EXPECTED_TOKEN: 1,
  INVALID_TOKEN_IN_PLACEHOLDER: 2,
  UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER: 3,
  UNKNOWN_ESCAPE_SEQUENCE: 4,
  INVALID_UNICODE_ESCAPE_SEQUENCE: 5,
  UNBALANCED_CLOSING_BRACE: 6,
  UNTERMINATED_CLOSING_BRACE: 7,
  EMPTY_PLACEHOLDER: 8,
  NOT_ALLOW_NEST_PLACEHOLDER: 9,
  INVALID_LINKED_FORMAT: 10,
  // parser error codes
  MUST_HAVE_MESSAGES_IN_PLURAL: 11,
  UNEXPECTED_EMPTY_LINKED_MODIFIER: 12,
  UNEXPECTED_EMPTY_LINKED_KEY: 13,
  UNEXPECTED_LEXICAL_ANALYSIS: 14,
  // generator error codes
  UNHANDLED_CODEGEN_NODE_TYPE: 15,
  // minifier error codes
  UNHANDLED_MINIFIER_NODE_TYPE: 16
}, Fl = 17, Ul = {
  // tokenizer error messages
  [q.EXPECTED_TOKEN]: "Expected token: '{0}'",
  [q.INVALID_TOKEN_IN_PLACEHOLDER]: "Invalid token in placeholder: '{0}'",
  [q.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER]: "Unterminated single quote in placeholder",
  [q.UNKNOWN_ESCAPE_SEQUENCE]: "Unknown escape sequence: \\{0}",
  [q.INVALID_UNICODE_ESCAPE_SEQUENCE]: "Invalid unicode escape sequence: {0}",
  [q.UNBALANCED_CLOSING_BRACE]: "Unbalanced closing brace",
  [q.UNTERMINATED_CLOSING_BRACE]: "Unterminated closing brace",
  [q.EMPTY_PLACEHOLDER]: "Empty placeholder",
  [q.NOT_ALLOW_NEST_PLACEHOLDER]: "Not allowed nest placeholder",
  [q.INVALID_LINKED_FORMAT]: "Invalid linked format",
  // parser error messages
  [q.MUST_HAVE_MESSAGES_IN_PLURAL]: "Plural must have messages",
  [q.UNEXPECTED_EMPTY_LINKED_MODIFIER]: "Unexpected empty linked modifier",
  [q.UNEXPECTED_EMPTY_LINKED_KEY]: "Unexpected empty linked key",
  [q.UNEXPECTED_LEXICAL_ANALYSIS]: "Unexpected lexical analysis in token: '{0}'",
  // generator error messages
  [q.UNHANDLED_CODEGEN_NODE_TYPE]: "unhandled codegen node type: '{0}'",
  // minimizer error messages
  [q.UNHANDLED_MINIFIER_NODE_TYPE]: "unhandled mimifier node type: '{0}'"
};
function mn(e, t, n = {}) {
  const { domain: o, messages: r, args: s } = n, a = process.env.NODE_ENV !== "production" ? ho((r || Ul)[e] || "", ...s || []) : e, i = new SyntaxError(String(a));
  return i.code = e, t && (i.location = t), i.domain = o, i;
}
function Vl(e) {
  throw e;
}
const Hl = /<\/?[\w\s="/.':;#-\/]+>/, jl = (e) => Hl.test(e), ut = " ", Yl = "\r", Ie = `
`, Wl = "\u2028", ql = "\u2029";
function zl(e) {
  const t = e;
  let n = 0, o = 1, r = 1, s = 0;
  const a = (x) => t[x] === Yl && t[x + 1] === Ie, i = (x) => t[x] === Ie, l = (x) => t[x] === ql, p = (x) => t[x] === Wl, y = (x) => a(x) || i(x) || l(x) || p(x), k = () => n, d = () => o, w = () => r, N = () => s, h = (x) => a(x) || l(x) || p(x) ? Ie : t[x], T = () => h(n), m = () => h(n + s);
  function g() {
    return s = 0, y(n) && (o++, r = 0), a(n) && n++, n++, r++, t[n];
  }
  function C() {
    return a(n + s) && s++, s++, t[n + s];
  }
  function f() {
    n = 0, o = 1, r = 1, s = 0;
  }
  function A(x = 0) {
    s = x;
  }
  function P() {
    const x = n + s;
    for (; x !== n; )
      g();
    s = 0;
  }
  return {
    index: k,
    line: d,
    column: w,
    peekOffset: N,
    charAt: h,
    currentChar: T,
    currentPeek: m,
    next: g,
    peek: C,
    reset: f,
    resetPeek: A,
    skipToPeek: P
  };
}
const yt = void 0, Kl = ".", ss = "'", Gl = "tokenizer";
function Xl(e, t = {}) {
  const n = t.location !== !1, o = zl(e), r = () => o.index(), s = () => Bl(o.line(), o.column(), o.index()), a = s(), i = r(), l = {
    currentType: 13,
    offset: i,
    startLoc: a,
    endLoc: a,
    lastType: 13,
    lastOffset: i,
    lastStartLoc: a,
    lastEndLoc: a,
    braceNest: 0,
    inLinked: !1,
    text: ""
  }, p = () => l, { onError: y } = t;
  function k(c, u, L, ...D) {
    const me = p();
    if (u.column += L, u.offset += L, y) {
      const he = n ? qo(me.startLoc, u) : null, J = mn(c, he, {
        domain: Gl,
        args: D
      });
      y(J);
    }
  }
  function d(c, u, L) {
    c.endLoc = s(), c.currentType = u;
    const D = { type: u };
    return n && (D.loc = qo(c.startLoc, c.endLoc)), L != null && (D.value = L), D;
  }
  const w = (c) => d(
    c,
    13
    /* TokenTypes.EOF */
  );
  function N(c, u) {
    return c.currentChar() === u ? (c.next(), u) : (k(q.EXPECTED_TOKEN, s(), 0, u), "");
  }
  function h(c) {
    let u = "";
    for (; c.currentPeek() === ut || c.currentPeek() === Ie; )
      u += c.currentPeek(), c.peek();
    return u;
  }
  function T(c) {
    const u = h(c);
    return c.skipToPeek(), u;
  }
  function m(c) {
    if (c === yt)
      return !1;
    const u = c.charCodeAt(0);
    return u >= 97 && u <= 122 || // a-z
    u >= 65 && u <= 90 || // A-Z
    u === 95;
  }
  function g(c) {
    if (c === yt)
      return !1;
    const u = c.charCodeAt(0);
    return u >= 48 && u <= 57;
  }
  function C(c, u) {
    const { currentType: L } = u;
    if (L !== 2)
      return !1;
    h(c);
    const D = m(c.currentPeek());
    return c.resetPeek(), D;
  }
  function f(c, u) {
    const { currentType: L } = u;
    if (L !== 2)
      return !1;
    h(c);
    const D = c.currentPeek() === "-" ? c.peek() : c.currentPeek(), me = g(D);
    return c.resetPeek(), me;
  }
  function A(c, u) {
    const { currentType: L } = u;
    if (L !== 2)
      return !1;
    h(c);
    const D = c.currentPeek() === ss;
    return c.resetPeek(), D;
  }
  function P(c, u) {
    const { currentType: L } = u;
    if (L !== 7)
      return !1;
    h(c);
    const D = c.currentPeek() === ".";
    return c.resetPeek(), D;
  }
  function x(c, u) {
    const { currentType: L } = u;
    if (L !== 8)
      return !1;
    h(c);
    const D = m(c.currentPeek());
    return c.resetPeek(), D;
  }
  function z(c, u) {
    const { currentType: L } = u;
    if (!(L === 7 || L === 11))
      return !1;
    h(c);
    const D = c.currentPeek() === ":";
    return c.resetPeek(), D;
  }
  function H(c, u) {
    const { currentType: L } = u;
    if (L !== 9)
      return !1;
    const D = () => {
      const he = c.currentPeek();
      return he === "{" ? m(c.peek()) : he === "@" || he === "|" || he === ":" || he === "." || he === ut || !he ? !1 : he === Ie ? (c.peek(), D()) : Y(c, !1);
    }, me = D();
    return c.resetPeek(), me;
  }
  function F(c) {
    h(c);
    const u = c.currentPeek() === "|";
    return c.resetPeek(), u;
  }
  function Y(c, u = !0) {
    const L = (me = !1, he = "") => {
      const J = c.currentPeek();
      return J === "{" || J === "@" || !J ? me : J === "|" ? !(he === ut || he === Ie) : J === ut ? (c.peek(), L(!0, ut)) : J === Ie ? (c.peek(), L(!0, Ie)) : !0;
    }, D = L();
    return u && c.resetPeek(), D;
  }
  function ne(c, u) {
    const L = c.currentChar();
    return L === yt ? yt : u(L) ? (c.next(), L) : null;
  }
  function Je(c) {
    const u = c.charCodeAt(0);
    return u >= 97 && u <= 122 || // a-z
    u >= 65 && u <= 90 || // A-Z
    u >= 48 && u <= 57 || // 0-9
    u === 95 || // _
    u === 36;
  }
  function W(c) {
    return ne(c, Je);
  }
  function S(c) {
    const u = c.charCodeAt(0);
    return u >= 97 && u <= 122 || // a-z
    u >= 65 && u <= 90 || // A-Z
    u >= 48 && u <= 57 || // 0-9
    u === 95 || // _
    u === 36 || // $
    u === 45;
  }
  function I(c) {
    return ne(c, S);
  }
  function B(c) {
    const u = c.charCodeAt(0);
    return u >= 48 && u <= 57;
  }
  function $(c) {
    return ne(c, B);
  }
  function G(c) {
    const u = c.charCodeAt(0);
    return u >= 48 && u <= 57 || // 0-9
    u >= 65 && u <= 70 || // A-F
    u >= 97 && u <= 102;
  }
  function V(c) {
    return ne(c, G);
  }
  function Z(c) {
    let u = "", L = "";
    for (; u = $(c); )
      L += u;
    return L;
  }
  function de(c) {
    let u = "";
    for (; ; ) {
      const L = c.currentChar();
      if (L === "\\") {
        const D = c.peek();
        D === "{" || D === "}" || D === "@" || D === "|" || D === "\\" ? (u += L + D, c.next(), c.next()) : (c.resetPeek(), u += L, c.next());
      } else {
        if (L === "{" || L === "}" || L === "@" || L === "|" || !L)
          break;
        if (L === ut || L === Ie)
          if (Y(c))
            u += L, c.next();
          else {
            if (F(c))
              break;
            u += L, c.next();
          }
        else
          u += L, c.next();
      }
    }
    return u;
  }
  function we(c) {
    T(c);
    let u = "", L = "";
    for (; u = I(c); )
      L += u;
    const D = c.currentChar();
    if (D && D !== "}" && D !== yt && D !== ut && D !== Ie && D !== "　") {
      const me = xe(c);
      return k(q.INVALID_TOKEN_IN_PLACEHOLDER, s(), 0, L + me), L + me;
    }
    return c.currentChar() === yt && k(q.UNTERMINATED_CLOSING_BRACE, s(), 0), L;
  }
  function ke(c) {
    T(c);
    let u = "";
    return c.currentChar() === "-" ? (c.next(), u += `-${Z(c)}`) : u += Z(c), c.currentChar() === yt && k(q.UNTERMINATED_CLOSING_BRACE, s(), 0), u;
  }
  function Pe(c) {
    return c !== ss && c !== Ie;
  }
  function bt(c) {
    T(c), N(c, "'");
    let u = "", L = "";
    for (; u = ne(c, Pe); )
      u === "\\" ? L += st(c) : L += u;
    const D = c.currentChar();
    return D === Ie || D === yt ? (k(q.UNTERMINATED_SINGLE_QUOTE_IN_PLACEHOLDER, s(), 0), D === Ie && (c.next(), N(c, "'")), L) : (N(c, "'"), L);
  }
  function st(c) {
    const u = c.currentChar();
    switch (u) {
      case "\\":
      case "'":
        return c.next(), `\\${u}`;
      case "u":
        return lt(c, u, 4);
      case "U":
        return lt(c, u, 6);
      default:
        return k(q.UNKNOWN_ESCAPE_SEQUENCE, s(), 0, u), "";
    }
  }
  function lt(c, u, L) {
    N(c, u);
    let D = "";
    for (let me = 0; me < L; me++) {
      const he = V(c);
      if (!he) {
        k(q.INVALID_UNICODE_ESCAPE_SEQUENCE, s(), 0, `\\${u}${D}${c.currentChar()}`);
        break;
      }
      D += he;
    }
    return `\\${u}${D}`;
  }
  function at(c) {
    return c !== "{" && c !== "}" && c !== ut && c !== Ie;
  }
  function xe(c) {
    T(c);
    let u = "", L = "";
    for (; u = ne(c, at); )
      L += u;
    return L;
  }
  function Qe(c) {
    let u = "", L = "";
    for (; u = W(c); )
      L += u;
    return L;
  }
  function vt(c) {
    const u = (L) => {
      const D = c.currentChar();
      return D === "{" || D === "@" || D === "|" || D === "(" || D === ")" || !D || D === ut ? L : (L += D, c.next(), u(L));
    };
    return u("");
  }
  function ct(c) {
    T(c);
    const u = N(
      c,
      "|"
      /* TokenChars.Pipe */
    );
    return T(c), u;
  }
  function En(c, u) {
    let L = null;
    switch (c.currentChar()) {
      case "{":
        return u.braceNest >= 1 && k(q.NOT_ALLOW_NEST_PLACEHOLDER, s(), 0), c.next(), L = d(
          u,
          2,
          "{"
          /* TokenChars.BraceLeft */
        ), T(c), u.braceNest++, L;
      case "}":
        return u.braceNest > 0 && u.currentType === 2 && k(q.EMPTY_PLACEHOLDER, s(), 0), c.next(), L = d(
          u,
          3,
          "}"
          /* TokenChars.BraceRight */
        ), u.braceNest--, u.braceNest > 0 && T(c), u.inLinked && u.braceNest === 0 && (u.inLinked = !1), L;
      case "@":
        return u.braceNest > 0 && k(q.UNTERMINATED_CLOSING_BRACE, s(), 0), L = Mt(c, u) || w(u), u.braceNest = 0, L;
      default: {
        let me = !0, he = !0, J = !0;
        if (F(c))
          return u.braceNest > 0 && k(q.UNTERMINATED_CLOSING_BRACE, s(), 0), L = d(u, 1, ct(c)), u.braceNest = 0, u.inLinked = !1, L;
        if (u.braceNest > 0 && (u.currentType === 4 || u.currentType === 5 || u.currentType === 6))
          return k(q.UNTERMINATED_CLOSING_BRACE, s(), 0), u.braceNest = 0, kn(c, u);
        if (me = C(c, u))
          return L = d(u, 4, we(c)), T(c), L;
        if (he = f(c, u))
          return L = d(u, 5, ke(c)), T(c), L;
        if (J = A(c, u))
          return L = d(u, 6, bt(c)), T(c), L;
        if (!me && !he && !J)
          return L = d(u, 12, xe(c)), k(q.INVALID_TOKEN_IN_PLACEHOLDER, s(), 0, L.value), T(c), L;
        break;
      }
    }
    return L;
  }
  function Mt(c, u) {
    const { currentType: L } = u;
    let D = null;
    const me = c.currentChar();
    switch ((L === 7 || L === 8 || L === 11 || L === 9) && (me === Ie || me === ut) && k(q.INVALID_LINKED_FORMAT, s(), 0), me) {
      case "@":
        return c.next(), D = d(
          u,
          7,
          "@"
          /* TokenChars.LinkedAlias */
        ), u.inLinked = !0, D;
      case ".":
        return T(c), c.next(), d(
          u,
          8,
          "."
          /* TokenChars.LinkedDot */
        );
      case ":":
        return T(c), c.next(), d(
          u,
          9,
          ":"
          /* TokenChars.LinkedDelimiter */
        );
      default:
        return F(c) ? (D = d(u, 1, ct(c)), u.braceNest = 0, u.inLinked = !1, D) : P(c, u) || z(c, u) ? (T(c), Mt(c, u)) : x(c, u) ? (T(c), d(u, 11, Qe(c))) : H(c, u) ? (T(c), me === "{" ? En(c, u) || D : d(u, 10, vt(c))) : (L === 7 && k(q.INVALID_LINKED_FORMAT, s(), 0), u.braceNest = 0, u.inLinked = !1, kn(c, u));
    }
  }
  function kn(c, u) {
    let L = {
      type: 13
      /* TokenTypes.EOF */
    };
    if (u.braceNest > 0)
      return En(c, u) || w(u);
    if (u.inLinked)
      return Mt(c, u) || w(u);
    switch (c.currentChar()) {
      case "{":
        return En(c, u) || w(u);
      case "}":
        return k(q.UNBALANCED_CLOSING_BRACE, s(), 0), c.next(), d(
          u,
          3,
          "}"
          /* TokenChars.BraceRight */
        );
      case "@":
        return Mt(c, u) || w(u);
      default: {
        if (F(c))
          return L = d(u, 1, ct(c)), u.braceNest = 0, u.inLinked = !1, L;
        if (Y(c))
          return d(u, 0, de(c));
        break;
      }
    }
    return L;
  }
  function Oo() {
    const { currentType: c, offset: u, startLoc: L, endLoc: D } = l;
    return l.lastType = c, l.lastOffset = u, l.lastStartLoc = L, l.lastEndLoc = D, l.offset = r(), l.startLoc = s(), o.currentChar() === yt ? d(
      l,
      13
      /* TokenTypes.EOF */
    ) : kn(o, l);
  }
  return {
    nextToken: Oo,
    currentOffset: r,
    currentPosition: s,
    context: p
  };
}
const Zl = "parser", Jl = /(?:\\\\|\\'|\\u([0-9a-fA-F]{4})|\\U([0-9a-fA-F]{6}))/g, Ql = /\\([\\@{}|])/g;
function ec(e, t) {
  return t;
}
function tc(e, t, n) {
  switch (e) {
    case "\\\\":
      return "\\";
    case "\\'":
      return "'";
    default: {
      const o = parseInt(t || n, 16);
      return o <= 55295 || o >= 57344 ? String.fromCodePoint(o) : "�";
    }
  }
}
function nc(e = {}) {
  const t = e.location !== !1, { onError: n } = e;
  function o(m, g, C, f, ...A) {
    const P = m.currentPosition();
    if (P.offset += f, P.column += f, n) {
      const x = t ? qo(C, P) : null, z = mn(g, x, {
        domain: Zl,
        args: A
      });
      n(z);
    }
  }
  function r(m, g, C) {
    const f = { type: m };
    return t && (f.start = g, f.end = g, f.loc = { start: C, end: C }), f;
  }
  function s(m, g, C, f) {
    t && (m.end = g, m.loc && (m.loc.end = C));
  }
  function a(m, g) {
    const C = m.context(), f = r(3, C.offset, C.startLoc);
    return f.value = g.replace(Ql, ec), s(f, m.currentOffset(), m.currentPosition()), f;
  }
  function i(m, g) {
    const C = m.context(), { lastOffset: f, lastStartLoc: A } = C, P = r(5, f, A);
    return P.index = parseInt(g, 10), m.nextToken(), s(P, m.currentOffset(), m.currentPosition()), P;
  }
  function l(m, g) {
    const C = m.context(), { lastOffset: f, lastStartLoc: A } = C, P = r(4, f, A);
    return P.key = g, m.nextToken(), s(P, m.currentOffset(), m.currentPosition()), P;
  }
  function p(m, g) {
    const C = m.context(), { lastOffset: f, lastStartLoc: A } = C, P = r(9, f, A);
    return P.value = g.replace(Jl, tc), m.nextToken(), s(P, m.currentOffset(), m.currentPosition()), P;
  }
  function y(m) {
    const g = m.nextToken(), C = m.context(), { lastOffset: f, lastStartLoc: A } = C, P = r(8, f, A);
    return g.type !== 11 ? (o(m, q.UNEXPECTED_EMPTY_LINKED_MODIFIER, C.lastStartLoc, 0), P.value = "", s(P, f, A), {
      nextConsumeToken: g,
      node: P
    }) : (g.value == null && o(m, q.UNEXPECTED_LEXICAL_ANALYSIS, C.lastStartLoc, 0, dt(g)), P.value = g.value || "", s(P, m.currentOffset(), m.currentPosition()), {
      node: P
    });
  }
  function k(m, g) {
    const C = m.context(), f = r(7, C.offset, C.startLoc);
    return f.value = g, s(f, m.currentOffset(), m.currentPosition()), f;
  }
  function d(m) {
    const g = m.context(), C = r(6, g.offset, g.startLoc);
    let f = m.nextToken();
    if (f.type === 8) {
      const A = y(m);
      C.modifier = A.node, f = A.nextConsumeToken || m.nextToken();
    }
    switch (f.type !== 9 && o(m, q.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, dt(f)), f = m.nextToken(), f.type === 2 && (f = m.nextToken()), f.type) {
      case 10:
        f.value == null && o(m, q.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, dt(f)), C.key = k(m, f.value || "");
        break;
      case 4:
        f.value == null && o(m, q.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, dt(f)), C.key = l(m, f.value || "");
        break;
      case 5:
        f.value == null && o(m, q.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, dt(f)), C.key = i(m, f.value || "");
        break;
      case 6:
        f.value == null && o(m, q.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, dt(f)), C.key = p(m, f.value || "");
        break;
      default: {
        o(m, q.UNEXPECTED_EMPTY_LINKED_KEY, g.lastStartLoc, 0);
        const A = m.context(), P = r(7, A.offset, A.startLoc);
        return P.value = "", s(P, A.offset, A.startLoc), C.key = P, s(C, A.offset, A.startLoc), {
          nextConsumeToken: f,
          node: C
        };
      }
    }
    return s(C, m.currentOffset(), m.currentPosition()), {
      node: C
    };
  }
  function w(m) {
    const g = m.context(), C = g.currentType === 1 ? m.currentOffset() : g.offset, f = g.currentType === 1 ? g.endLoc : g.startLoc, A = r(2, C, f);
    A.items = [];
    let P = null;
    do {
      const H = P || m.nextToken();
      switch (P = null, H.type) {
        case 0:
          H.value == null && o(m, q.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, dt(H)), A.items.push(a(m, H.value || ""));
          break;
        case 5:
          H.value == null && o(m, q.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, dt(H)), A.items.push(i(m, H.value || ""));
          break;
        case 4:
          H.value == null && o(m, q.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, dt(H)), A.items.push(l(m, H.value || ""));
          break;
        case 6:
          H.value == null && o(m, q.UNEXPECTED_LEXICAL_ANALYSIS, g.lastStartLoc, 0, dt(H)), A.items.push(p(m, H.value || ""));
          break;
        case 7: {
          const F = d(m);
          A.items.push(F.node), P = F.nextConsumeToken || null;
          break;
        }
      }
    } while (g.currentType !== 13 && g.currentType !== 1);
    const x = g.currentType === 1 ? g.lastOffset : m.currentOffset(), z = g.currentType === 1 ? g.lastEndLoc : m.currentPosition();
    return s(A, x, z), A;
  }
  function N(m, g, C, f) {
    const A = m.context();
    let P = f.items.length === 0;
    const x = r(1, g, C);
    x.cases = [], x.cases.push(f);
    do {
      const z = w(m);
      P || (P = z.items.length === 0), x.cases.push(z);
    } while (A.currentType !== 13);
    return P && o(m, q.MUST_HAVE_MESSAGES_IN_PLURAL, C, 0), s(x, m.currentOffset(), m.currentPosition()), x;
  }
  function h(m) {
    const g = m.context(), { offset: C, startLoc: f } = g, A = w(m);
    return g.currentType === 13 ? A : N(m, C, f, A);
  }
  function T(m) {
    const g = Xl(m, Le({}, e)), C = g.context(), f = r(0, C.offset, C.startLoc);
    return t && f.loc && (f.loc.source = m), f.body = h(g), e.onCacheKey && (f.cacheKey = e.onCacheKey(m)), C.currentType !== 13 && o(g, q.UNEXPECTED_LEXICAL_ANALYSIS, C.lastStartLoc, 0, m[C.offset] || ""), s(f, g.currentOffset(), g.currentPosition()), f;
  }
  return { parse: T };
}
function dt(e) {
  if (e.type === 13)
    return "EOF";
  const t = (e.value || "").replace(/\r?\n/gu, "\\n");
  return t.length > 10 ? t.slice(0, 9) + "…" : t;
}
function oc(e, t = {}) {
  const n = {
    ast: e,
    helpers: /* @__PURE__ */ new Set()
  };
  return { context: () => n, helper: (s) => (n.helpers.add(s), s) };
}
function as(e, t) {
  for (let n = 0; n < e.length; n++)
    pr(e[n], t);
}
function pr(e, t) {
  switch (e.type) {
    case 1:
      as(e.cases, t), t.helper(
        "plural"
        /* HelperNameMap.PLURAL */
      );
      break;
    case 2:
      as(e.items, t);
      break;
    case 6: {
      pr(e.key, t), t.helper(
        "linked"
        /* HelperNameMap.LINKED */
      ), t.helper(
        "type"
        /* HelperNameMap.TYPE */
      );
      break;
    }
    case 5:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "list"
        /* HelperNameMap.LIST */
      );
      break;
    case 4:
      t.helper(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      ), t.helper(
        "named"
        /* HelperNameMap.NAMED */
      );
      break;
  }
}
function rc(e, t = {}) {
  const n = oc(e);
  n.helper(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  ), e.body && pr(e.body, n);
  const o = n.context();
  e.helpers = Array.from(o.helpers);
}
function sc(e) {
  const t = e.body;
  return t.type === 2 ? is(t) : t.cases.forEach((n) => is(n)), e;
}
function is(e) {
  if (e.items.length === 1) {
    const t = e.items[0];
    (t.type === 3 || t.type === 9) && (e.static = t.value, delete t.value);
  } else {
    const t = [];
    for (let n = 0; n < e.items.length; n++) {
      const o = e.items[n];
      if (!(o.type === 3 || o.type === 9) || o.value == null)
        break;
      t.push(o.value);
    }
    if (t.length === e.items.length) {
      e.static = wr(t);
      for (let n = 0; n < e.items.length; n++) {
        const o = e.items[n];
        (o.type === 3 || o.type === 9) && delete o.value;
      }
    }
  }
}
const ac = "minifier";
function en(e) {
  switch (e.t = e.type, e.type) {
    case 0: {
      const t = e;
      en(t.body), t.b = t.body, delete t.body;
      break;
    }
    case 1: {
      const t = e, n = t.cases;
      for (let o = 0; o < n.length; o++)
        en(n[o]);
      t.c = n, delete t.cases;
      break;
    }
    case 2: {
      const t = e, n = t.items;
      for (let o = 0; o < n.length; o++)
        en(n[o]);
      t.i = n, delete t.items, t.static && (t.s = t.static, delete t.static);
      break;
    }
    case 3:
    case 9:
    case 8:
    case 7: {
      const t = e;
      t.value && (t.v = t.value, delete t.value);
      break;
    }
    case 6: {
      const t = e;
      en(t.key), t.k = t.key, delete t.key, t.modifier && (en(t.modifier), t.m = t.modifier, delete t.modifier);
      break;
    }
    case 5: {
      const t = e;
      t.i = t.index, delete t.index;
      break;
    }
    case 4: {
      const t = e;
      t.k = t.key, delete t.key;
      break;
    }
    default:
      if (process.env.NODE_ENV !== "production")
        throw mn(q.UNHANDLED_MINIFIER_NODE_TYPE, null, {
          domain: ac,
          args: [e.type]
        });
  }
  delete e.type;
}
const ic = "parser";
function lc(e, t) {
  const { filename: n, breakLineCode: o, needIndent: r } = t, s = t.location !== !1, a = {
    filename: n,
    code: "",
    column: 1,
    line: 1,
    offset: 0,
    map: void 0,
    breakLineCode: o,
    needIndent: r,
    indentLevel: 0
  };
  s && e.loc && (a.source = e.loc.source);
  const i = () => a;
  function l(h, T) {
    a.code += h;
  }
  function p(h, T = !0) {
    const m = T ? o : "";
    l(r ? m + "  ".repeat(h) : m);
  }
  function y(h = !0) {
    const T = ++a.indentLevel;
    h && p(T);
  }
  function k(h = !0) {
    const T = --a.indentLevel;
    h && p(T);
  }
  function d() {
    p(a.indentLevel);
  }
  return {
    context: i,
    push: l,
    indent: y,
    deindent: k,
    newline: d,
    helper: (h) => `_${h}`,
    needIndent: () => a.needIndent
  };
}
function cc(e, t) {
  const { helper: n } = e;
  e.push(`${n(
    "linked"
    /* HelperNameMap.LINKED */
  )}(`), sn(e, t.key), t.modifier ? (e.push(", "), sn(e, t.modifier), e.push(", _type")) : e.push(", undefined, _type"), e.push(")");
}
function uc(e, t) {
  const { helper: n, needIndent: o } = e;
  e.push(`${n(
    "normalize"
    /* HelperNameMap.NORMALIZE */
  )}([`), e.indent(o());
  const r = t.items.length;
  for (let s = 0; s < r && (sn(e, t.items[s]), s !== r - 1); s++)
    e.push(", ");
  e.deindent(o()), e.push("])");
}
function dc(e, t) {
  const { helper: n, needIndent: o } = e;
  if (t.cases.length > 1) {
    e.push(`${n(
      "plural"
      /* HelperNameMap.PLURAL */
    )}([`), e.indent(o());
    const r = t.cases.length;
    for (let s = 0; s < r && (sn(e, t.cases[s]), s !== r - 1); s++)
      e.push(", ");
    e.deindent(o()), e.push("])");
  }
}
function mc(e, t) {
  t.body ? sn(e, t.body) : e.push("null");
}
function sn(e, t) {
  const { helper: n } = e;
  switch (t.type) {
    case 0:
      mc(e, t);
      break;
    case 1:
      dc(e, t);
      break;
    case 2:
      uc(e, t);
      break;
    case 6:
      cc(e, t);
      break;
    case 8:
      e.push(JSON.stringify(t.value), t);
      break;
    case 7:
      e.push(JSON.stringify(t.value), t);
      break;
    case 5:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "list"
        /* HelperNameMap.LIST */
      )}(${t.index}))`, t);
      break;
    case 4:
      e.push(`${n(
        "interpolate"
        /* HelperNameMap.INTERPOLATE */
      )}(${n(
        "named"
        /* HelperNameMap.NAMED */
      )}(${JSON.stringify(t.key)}))`, t);
      break;
    case 9:
      e.push(JSON.stringify(t.value), t);
      break;
    case 3:
      e.push(JSON.stringify(t.value), t);
      break;
    default:
      if (process.env.NODE_ENV !== "production")
        throw mn(q.UNHANDLED_CODEGEN_NODE_TYPE, null, {
          domain: ic,
          args: [t.type]
        });
  }
}
const fc = (e, t = {}) => {
  const n = M(t.mode) ? t.mode : "normal", o = M(t.filename) ? t.filename : "message.intl";
  t.sourceMap;
  const r = t.breakLineCode != null ? t.breakLineCode : n === "arrow" ? ";" : `
`, s = t.needIndent ? t.needIndent : n !== "arrow", a = e.helpers || [], i = lc(e, {
    filename: o,
    breakLineCode: r,
    needIndent: s
  });
  i.push(n === "normal" ? "function __msg__ (ctx) {" : "(ctx) => {"), i.indent(s), a.length > 0 && (i.push(`const { ${wr(a.map((y) => `${y}: _${y}`), ", ")} } = ctx`), i.newline()), i.push("return "), sn(i, e), i.deindent(s), i.push("}"), delete e.helpers;
  const { code: l, map: p } = i.context();
  return {
    ast: e,
    code: l,
    map: p ? p.toJSON() : void 0
    // eslint-disable-line @typescript-eslint/no-explicit-any
  };
};
function wc(e, t = {}) {
  const n = Le({}, t), o = !!n.jit, r = !!n.minify, s = n.optimize == null ? !0 : n.optimize, i = nc(n).parse(e);
  return o ? (s && sc(i), r && en(i), { ast: i, code: "" }) : (rc(i, n), fc(i, n));
}
/*!
  * core-base v11.3.1
  * (c) 2026 kazuya kawaguchi
  * Released under the MIT License.
  */
function pc() {
  typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (Ht().__INTLIFY_PROD_DEVTOOLS__ = !1), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (Ht().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1);
}
function it(e) {
  return se(e) && hr(e) === 0 && (nt(e, "b") || nt(e, "body"));
}
const ea = ["b", "body"];
function hc(e) {
  return St(e, ea);
}
const ta = ["c", "cases"];
function gc(e) {
  return St(e, ta, []);
}
const na = ["s", "static"];
function bc(e) {
  return St(e, na);
}
const oa = ["i", "items"];
function vc(e) {
  return St(e, oa, []);
}
const ra = ["t", "type"];
function hr(e) {
  return St(e, ra);
}
const sa = ["v", "value"];
function jn(e, t) {
  const n = St(e, sa);
  if (n != null)
    return n;
  throw Cn(t);
}
const aa = ["m", "modifier"];
function yc(e) {
  return St(e, aa);
}
const ia = ["k", "key"];
function _c(e) {
  const t = St(e, ia);
  if (t)
    return t;
  throw Cn(
    6
    /* NodeTypes.Linked */
  );
}
function St(e, t, n) {
  for (let o = 0; o < t.length; o++) {
    const r = t[o];
    if (nt(e, r) && e[r] != null)
      return e[r];
  }
  return n;
}
const la = [
  ...ea,
  ...ta,
  ...na,
  ...oa,
  ...ia,
  ...aa,
  ...sa,
  ...ra
];
function Cn(e) {
  return new Error(`unhandled node type: ${e}`);
}
function So(e) {
  return (n) => Ec(n, e);
}
function Ec(e, t) {
  const n = hc(t);
  if (n == null)
    throw Cn(
      0
      /* NodeTypes.Resource */
    );
  if (hr(n) === 1) {
    const s = gc(n);
    return e.plural(s.reduce((a, i) => [
      ...a,
      ls(e, i)
    ], []));
  } else
    return ls(e, n);
}
function ls(e, t) {
  const n = bc(t);
  if (n != null)
    return e.type === "text" ? n : e.normalize([n]);
  {
    const o = vc(t).reduce((r, s) => [...r, zo(e, s)], []);
    return e.normalize(o);
  }
}
function zo(e, t) {
  const n = hr(t);
  switch (n) {
    case 3:
      return jn(t, n);
    case 9:
      return jn(t, n);
    case 4: {
      const o = t;
      if (nt(o, "k") && o.k)
        return e.interpolate(e.named(o.k));
      if (nt(o, "key") && o.key)
        return e.interpolate(e.named(o.key));
      throw Cn(n);
    }
    case 5: {
      const o = t;
      if (nt(o, "i") && Ae(o.i))
        return e.interpolate(e.list(o.i));
      if (nt(o, "index") && Ae(o.index))
        return e.interpolate(e.list(o.index));
      throw Cn(n);
    }
    case 6: {
      const o = t, r = yc(o), s = _c(o);
      return e.linked(zo(e, s), r ? zo(e, r) : void 0, e.type);
    }
    case 7:
      return jn(t, n);
    case 8:
      return jn(t, n);
    default:
      throw new Error(`unhandled node on format message part: ${n}`);
  }
}
const kc = "Detected HTML in '{source}' message. Recommend not using HTML messages to avoid XSS.";
function xc(e, t) {
  t && jl(e) && pt(ho(kc, { source: e }));
}
const Cc = (e) => e;
let Yn = le();
function Ac(e, t = {}) {
  let n = !1;
  const o = t.onError || Vl;
  return t.onError = (r) => {
    n = !0, o(r);
  }, { ...wc(e, t), detectError: n };
}
// @__NO_SIDE_EFFECTS__
function Lc(e, t) {
  if (!__INTLIFY_DROP_MESSAGE_COMPILER__ && M(e)) {
    const n = ve(t.warnHtmlMessage) ? t.warnHtmlMessage : !0;
    process.env.NODE_ENV !== "production" && xc(e, n);
    const r = (t.onCacheKey || Cc)(e), s = Yn[r];
    if (s)
      return s;
    const { ast: a, detectError: i } = Ac(e, {
      ...t,
      location: process.env.NODE_ENV !== "production",
      jit: !0
    }), l = So(a);
    return i ? l : Yn[r] = l;
  } else {
    if (process.env.NODE_ENV !== "production" && !it(e))
      return pt(`the message that is resolve with key '${t.key}' is not supported for jit compilation`), () => e;
    const n = e.cacheKey;
    if (n) {
      const o = Yn[n];
      return o || (Yn[n] = So(e));
    } else
      return So(e);
  }
}
let An = null;
function Tc(e) {
  An = e;
}
function Nc(e, t, n) {
  An && An.emit("i18n:init", {
    timestamp: Date.now(),
    i18n: e,
    version: t,
    meta: n
  });
}
const Oc = /* @__PURE__ */ Pc("function:translate");
function Pc(e) {
  return (t) => An && An.emit(e, t);
}
const $e = {
  INVALID_ARGUMENT: Fl,
  // 17
  INVALID_DATE_ARGUMENT: 18,
  INVALID_ISO_DATE_ARGUMENT: 19,
  NOT_SUPPORT_NON_STRING_MESSAGE: 20,
  NOT_SUPPORT_LOCALE_PROMISE_VALUE: 21,
  NOT_SUPPORT_LOCALE_ASYNC_FUNCTION: 22,
  NOT_SUPPORT_LOCALE_TYPE: 23
}, Ic = 24;
function _t(e) {
  return mn(e, null, process.env.NODE_ENV !== "production" ? { messages: $c } : void 0);
}
const $c = {
  [$e.INVALID_ARGUMENT]: "Invalid arguments",
  [$e.INVALID_DATE_ARGUMENT]: "The date provided is an invalid Date object.Make sure your Date represents a valid date.",
  [$e.INVALID_ISO_DATE_ARGUMENT]: "The argument provided is not a valid ISO date string",
  [$e.NOT_SUPPORT_NON_STRING_MESSAGE]: "Not support non-string message",
  [$e.NOT_SUPPORT_LOCALE_PROMISE_VALUE]: "cannot support promise value",
  [$e.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION]: "cannot support async function",
  [$e.NOT_SUPPORT_LOCALE_TYPE]: "cannot support locale type"
};
function gr(e, t) {
  return t.locale != null ? cs(t.locale) : cs(e.locale);
}
let Do;
function cs(e) {
  if (M(e))
    return e;
  if (fe(e)) {
    if (e.resolvedOnce && Do != null)
      return Do;
    if (e.constructor.name === "Function") {
      const t = e();
      if (Sl(t))
        throw _t($e.NOT_SUPPORT_LOCALE_PROMISE_VALUE);
      return Do = t;
    } else
      throw _t($e.NOT_SUPPORT_LOCALE_ASYNC_FUNCTION);
  } else
    throw _t($e.NOT_SUPPORT_LOCALE_TYPE);
}
function Sc(e, t, n) {
  return [.../* @__PURE__ */ new Set([
    n,
    ...ye(t) ? t : se(t) ? Object.keys(t) : M(t) ? [t] : [n]
  ])];
}
function Ko(e, t, n) {
  const o = M(n) ? n : Gn, r = e;
  r.__localeChainCache || (r.__localeChainCache = /* @__PURE__ */ new Map());
  let s = r.__localeChainCache.get(o);
  if (!s) {
    s = [];
    let a = [n];
    for (; ye(a); )
      a = us(s, a, t);
    const i = ye(t) || !ie(t) ? t : t.default ? t.default : null;
    a = M(i) ? [i] : i, ye(a) && us(s, a, !1), r.__localeChainCache.set(o, s);
  }
  return s;
}
function us(e, t, n) {
  let o = !0;
  for (let r = 0; r < t.length && ve(o); r++) {
    const s = t[r];
    M(s) && (o = Dc(e, t[r], n));
  }
  return o;
}
function Dc(e, t, n) {
  let o;
  const r = t.split("-");
  do {
    const s = r.join("-");
    o = Mc(e, s, n), r.splice(-1, 1);
  } while (r.length && o === !0);
  return o;
}
function Mc(e, t, n) {
  let o = !1;
  if (!e.includes(t) && (o = !0, t)) {
    o = t[t.length - 1] !== "!";
    const r = t.replace(/!/g, "");
    e.push(r), (ye(n) || ie(n)) && n[r] && (o = n[r]);
  }
  return o;
}
const Dt = [];
Dt[
  0
  /* States.BEFORE_PATH */
] = {
  w: [
    0
    /* States.BEFORE_PATH */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
Dt[
  1
  /* States.IN_PATH */
] = {
  w: [
    1
    /* States.IN_PATH */
  ],
  ".": [
    2
    /* States.BEFORE_IDENT */
  ],
  "[": [
    4
    /* States.IN_SUB_PATH */
  ],
  o: [
    7
    /* States.AFTER_PATH */
  ]
};
Dt[
  2
  /* States.BEFORE_IDENT */
] = {
  w: [
    2
    /* States.BEFORE_IDENT */
  ],
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ]
};
Dt[
  3
  /* States.IN_IDENT */
] = {
  i: [
    3,
    0
    /* Actions.APPEND */
  ],
  0: [
    3,
    0
    /* Actions.APPEND */
  ],
  w: [
    1,
    1
    /* Actions.PUSH */
  ],
  ".": [
    2,
    1
    /* Actions.PUSH */
  ],
  "[": [
    4,
    1
    /* Actions.PUSH */
  ],
  o: [
    7,
    1
    /* Actions.PUSH */
  ]
};
Dt[
  4
  /* States.IN_SUB_PATH */
] = {
  "'": [
    5,
    0
    /* Actions.APPEND */
  ],
  '"': [
    6,
    0
    /* Actions.APPEND */
  ],
  "[": [
    4,
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ],
  "]": [
    1,
    3
    /* Actions.PUSH_SUB_PATH */
  ],
  o: 8,
  l: [
    4,
    0
    /* Actions.APPEND */
  ]
};
Dt[
  5
  /* States.IN_SINGLE_QUOTE */
] = {
  "'": [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    5,
    0
    /* Actions.APPEND */
  ]
};
Dt[
  6
  /* States.IN_DOUBLE_QUOTE */
] = {
  '"': [
    4,
    0
    /* Actions.APPEND */
  ],
  o: 8,
  l: [
    6,
    0
    /* Actions.APPEND */
  ]
};
const Rc = /^\s?(?:true|false|-?[\d.]+|'[^']*'|"[^"]*")\s?$/;
function Bc(e) {
  return Rc.test(e);
}
function Fc(e) {
  const t = e.charCodeAt(0), n = e.charCodeAt(e.length - 1);
  return t === n && (t === 34 || t === 39) ? e.slice(1, -1) : e;
}
function Uc(e) {
  if (e == null)
    return "o";
  switch (e.charCodeAt(0)) {
    case 91:
    case 93:
    case 46:
    case 34:
    case 39:
      return e;
    case 95:
    case 36:
    case 45:
      return "i";
    case 9:
    case 10:
    case 13:
    case 160:
    case 65279:
    case 8232:
    case 8233:
      return "w";
  }
  return "i";
}
function Vc(e) {
  const t = e.trim();
  return e.charAt(0) === "0" && isNaN(parseInt(e)) ? !1 : Bc(t) ? Fc(t) : "*" + t;
}
function Hc(e) {
  const t = [];
  let n = -1, o = 0, r = 0, s, a, i, l, p, y, k;
  const d = [];
  d[
    0
    /* Actions.APPEND */
  ] = () => {
    a === void 0 ? a = i : a += i;
  }, d[
    1
    /* Actions.PUSH */
  ] = () => {
    a !== void 0 && (t.push(a), a = void 0);
  }, d[
    2
    /* Actions.INC_SUB_PATH_DEPTH */
  ] = () => {
    d[
      0
      /* Actions.APPEND */
    ](), r++;
  }, d[
    3
    /* Actions.PUSH_SUB_PATH */
  ] = () => {
    if (r > 0)
      r--, o = 4, d[
        0
        /* Actions.APPEND */
      ]();
    else {
      if (r = 0, a === void 0 || (a = Vc(a), a === !1))
        return !1;
      d[
        1
        /* Actions.PUSH */
      ]();
    }
  };
  function w() {
    const N = e[n + 1];
    if (o === 5 && N === "'" || o === 6 && N === '"')
      return n++, i = "\\" + N, d[
        0
        /* Actions.APPEND */
      ](), !0;
  }
  for (; o !== null; )
    if (n++, s = e[n], !(s === "\\" && w())) {
      if (l = Uc(s), k = Dt[o], p = k[l] || k.l || 8, p === 8 || (o = p[0], p[1] !== void 0 && (y = d[p[1]], y && (i = s, y() === !1))))
        return;
      if (o === 7)
        return t;
    }
}
const ds = /* @__PURE__ */ new Map();
function jc(e, t) {
  return se(e) ? e[t] : null;
}
function Yc(e, t) {
  if (!se(e))
    return null;
  let n = ds.get(t);
  if (n || (n = Hc(t), n && ds.set(t, n)), !n)
    return null;
  const o = n.length;
  let r = e, s = 0;
  for (; s < o; ) {
    const a = n[s];
    if (la.includes(a) && it(r) || !se(r) || !nt(r, a))
      return null;
    const i = r[a];
    if (i === void 0 || fe(r))
      return null;
    r = i, s++;
  }
  return r;
}
const Ce = {
  NOT_FOUND_KEY: 1,
  FALLBACK_TO_TRANSLATE: 2,
  CANNOT_FORMAT_NUMBER: 3,
  FALLBACK_TO_NUMBER_FORMAT: 4,
  CANNOT_FORMAT_DATE: 5,
  FALLBACK_TO_DATE_FORMAT: 6,
  EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER: 7,
  INVALID_NUMBER_ARGUMENT: 8,
  INVALID_DATE_ARGUMENT: 9
}, Qt = 10, Wc = {
  [Ce.NOT_FOUND_KEY]: "Not found '{key}' key in '{locale}' locale messages.",
  [Ce.FALLBACK_TO_TRANSLATE]: "Fall back to translate '{key}' key with '{target}' locale.",
  [Ce.CANNOT_FORMAT_NUMBER]: "Cannot format a number value due to not supported Intl.NumberFormat.",
  [Ce.FALLBACK_TO_NUMBER_FORMAT]: "Fall back to number format '{key}' key with '{target}' locale.",
  [Ce.CANNOT_FORMAT_DATE]: "Cannot format a date value due to not supported Intl.DateTimeFormat.",
  [Ce.FALLBACK_TO_DATE_FORMAT]: "Fall back to datetime format '{key}' key with '{target}' locale.",
  [Ce.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER]: "This project is using Custom Message Compiler, which is an experimental feature. It may receive breaking changes or be removed in the future.",
  [Ce.INVALID_NUMBER_ARGUMENT]: "Invalid argument for number formatting: expected a number but received '{value}'.",
  [Ce.INVALID_DATE_ARGUMENT]: "Invalid argument for datetime formatting: expected a Date, number, or ISO string but received '{value}'."
};
function Et(e, ...t) {
  return ho(Wc[e], ...t);
}
const qc = "11.3.1", bo = -1, Gn = "en-US", an = "", ms = (e) => `${e.charAt(0).toLocaleUpperCase()}${e.substr(1)}`;
function zc() {
  return {
    upper: (e, t) => t === "text" && M(e) ? e.toUpperCase() : t === "vnode" && se(e) && "__v_isVNode" in e ? e.children.toUpperCase() : e,
    lower: (e, t) => t === "text" && M(e) ? e.toLowerCase() : t === "vnode" && se(e) && "__v_isVNode" in e ? e.children.toLowerCase() : e,
    capitalize: (e, t) => t === "text" && M(e) ? ms(e) : t === "vnode" && se(e) && "__v_isVNode" in e ? ms(e.children) : e
  };
}
let ca;
function Kc(e) {
  ca = e;
}
let ua;
function Gc(e) {
  ua = e;
}
let da;
function Xc(e) {
  da = e;
}
let ma = null;
const Zc = /* @__NO_SIDE_EFFECTS__ */ (e) => {
  ma = e;
}, Jc = /* @__NO_SIDE_EFFECTS__ */ () => ma;
let fa = null;
const fs = (e) => {
  fa = e;
}, Qc = () => fa;
let ws = 0;
function eu(e = {}) {
  const t = fe(e.onWarn) ? e.onWarn : pt, n = M(e.version) ? e.version : qc, o = M(e.locale) || fe(e.locale) ? e.locale : Gn, r = fe(o) ? Gn : o, s = ye(e.fallbackLocale) || ie(e.fallbackLocale) || M(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : r, a = ie(e.messages) ? e.messages : Mo(r), i = ie(e.datetimeFormats) ? e.datetimeFormats : Mo(r), l = ie(e.numberFormats) ? e.numberFormats : Mo(r), p = Le(le(), e.modifiers, zc()), y = e.pluralRules || le(), k = fe(e.missing) ? e.missing : null, d = ve(e.missingWarn) || Kn(e.missingWarn) ? e.missingWarn : !0, w = ve(e.fallbackWarn) || Kn(e.fallbackWarn) ? e.fallbackWarn : !0, N = !!e.fallbackFormat, h = !!e.unresolving, T = fe(e.postTranslation) ? e.postTranslation : null, m = ie(e.processor) ? e.processor : null, g = ve(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, C = !!e.escapeParameter, f = fe(e.messageCompiler) ? e.messageCompiler : ca;
  process.env.NODE_ENV !== "production" && fe(e.messageCompiler) && Ll(Et(Ce.EXPERIMENTAL_CUSTOM_MESSAGE_COMPILER));
  const A = fe(e.messageResolver) ? e.messageResolver : ua || jc, P = fe(e.localeFallbacker) ? e.localeFallbacker : da || Sc, x = se(e.fallbackContext) ? e.fallbackContext : void 0, z = e, H = se(z.__datetimeFormatters) ? z.__datetimeFormatters : /* @__PURE__ */ new Map(), F = se(z.__numberFormatters) ? z.__numberFormatters : /* @__PURE__ */ new Map(), Y = se(z.__meta) ? z.__meta : {};
  ws++;
  const ne = {
    version: n,
    cid: ws,
    locale: o,
    fallbackLocale: s,
    messages: a,
    modifiers: p,
    pluralRules: y,
    missing: k,
    missingWarn: d,
    fallbackWarn: w,
    fallbackFormat: N,
    unresolving: h,
    postTranslation: T,
    processor: m,
    warnHtmlMessage: g,
    escapeParameter: C,
    messageCompiler: f,
    messageResolver: A,
    localeFallbacker: P,
    fallbackContext: x,
    onWarn: t,
    __meta: Y
  };
  return ne.datetimeFormats = i, ne.numberFormats = l, ne.__datetimeFormatters = H, ne.__numberFormatters = F, process.env.NODE_ENV !== "production" && (ne.__v_emitter = z.__v_emitter != null ? z.__v_emitter : void 0), (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) && Nc(ne, n, Y), ne;
}
const Mo = (e) => ({ [e]: le() });
function vo(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function wa(e, t) {
  return e instanceof RegExp ? e.test(t) : e;
}
function br(e, t, n, o, r) {
  const { missing: s, onWarn: a } = e;
  if (process.env.NODE_ENV !== "production") {
    const i = e.__v_emitter;
    i && i.emit("missing", {
      locale: n,
      key: t,
      type: r,
      groupId: `${r}:${t}`
    });
  }
  if (s !== null) {
    const i = s(e, n, t, r);
    return M(i) ? i : t;
  } else
    return process.env.NODE_ENV !== "production" && wa(o, t) && a(Et(Ce.NOT_FOUND_KEY, { key: t, locale: n })), t;
}
function xn(e, t, n) {
  const o = e;
  o.__localeChainCache = /* @__PURE__ */ new Map(), e.localeFallbacker(e, n, t);
}
function pa(e, t) {
  return e === t ? !1 : e.split("-")[0] === t.split("-")[0];
}
function tu(e, t) {
  const n = t.indexOf(e);
  if (n === -1)
    return !1;
  for (let o = n + 1; o < t.length; o++)
    if (pa(e, t[o]))
      return !0;
  return !1;
}
const ps = typeof Intl < "u", ha = {
  dateTimeFormat: ps && typeof Intl.DateTimeFormat < "u",
  numberFormat: ps && typeof Intl.NumberFormat < "u"
};
function hs(e, ...t) {
  const { datetimeFormats: n, unresolving: o, fallbackLocale: r, onWarn: s, localeFallbacker: a } = e, { __datetimeFormatters: i } = e;
  if (process.env.NODE_ENV !== "production" && !ha.dateTimeFormat)
    return s(Et(Ce.CANNOT_FORMAT_DATE)), an;
  if (!M(t[0]) && !Js(t[0]) && !Ae(t[0]))
    return process.env.NODE_ENV !== "production" && s(Et(Ce.INVALID_DATE_ARGUMENT, {
      value: String(t[0])
    })), an;
  const [l, p, y, k] = Go(...t), d = ve(y.missingWarn) ? y.missingWarn : e.missingWarn, w = ve(y.fallbackWarn) ? y.fallbackWarn : e.fallbackWarn, N = !!y.part, h = gr(e, y), T = a(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    r,
    h
  );
  if (!M(l) || l === "")
    return new Intl.DateTimeFormat(h.replace(/!/g, ""), k).format(p);
  let m = {}, g, C = null, f = h, A = null;
  const P = "datetime format";
  for (let H = 0; H < T.length; H++) {
    if (g = A = T[H], process.env.NODE_ENV !== "production" && h !== g && vo(w, l) && s(Et(Ce.FALLBACK_TO_DATE_FORMAT, {
      key: l,
      target: g
    })), process.env.NODE_ENV !== "production" && h !== g) {
      const F = e.__v_emitter;
      F && F.emit("fallback", {
        type: P,
        key: l,
        from: f,
        to: A,
        groupId: `${P}:${l}`
      });
    }
    if (m = n[g] || {}, C = m[l], ie(C))
      break;
    br(e, l, g, d, P), f = A;
  }
  if (!ie(C) || !M(g))
    return o ? bo : l;
  let x = `${g}__${l}`;
  go(k) || (x = `${x}__${JSON.stringify(k)}`);
  let z = i.get(x);
  return z || (z = new Intl.DateTimeFormat(g, Le({}, C, k)), i.set(x, z)), N ? z.formatToParts(p) : z.format(p);
}
const ga = [
  "localeMatcher",
  "weekday",
  "era",
  "year",
  "month",
  "day",
  "hour",
  "minute",
  "second",
  "timeZoneName",
  "formatMatcher",
  "hour12",
  "timeZone",
  "dateStyle",
  "timeStyle",
  "calendar",
  "dayPeriod",
  "numberingSystem",
  "hourCycle",
  "fractionalSecondDigits"
];
function Go(...e) {
  const [t, n, o, r] = e, s = le();
  let a = le(), i;
  if (M(t)) {
    const l = t.match(/(\d{4}-\d{2}-\d{2})(T|\s)?(.*)/);
    if (!l)
      throw _t($e.INVALID_ISO_DATE_ARGUMENT);
    const p = l[3] ? l[3].trim().startsWith("T") ? `${l[1].trim()}${l[3].trim()}` : `${l[1].trim()}T${l[3].trim()}` : l[1].trim();
    i = new Date(p);
    try {
      i.toISOString();
    } catch {
      throw _t($e.INVALID_ISO_DATE_ARGUMENT);
    }
  } else if (Js(t)) {
    if (isNaN(t.getTime()))
      throw _t($e.INVALID_DATE_ARGUMENT);
    i = t;
  } else if (Ae(t))
    i = t;
  else
    throw _t($e.INVALID_ARGUMENT);
  return M(n) ? s.key = n : ie(n) && Object.keys(n).forEach((l) => {
    ga.includes(l) ? a[l] = n[l] : s[l] = n[l];
  }), M(o) ? s.locale = o : ie(o) && (a = o), ie(r) && (a = r), [s.key || "", i, s, a];
}
function gs(e, t, n) {
  const o = e;
  for (const r in n) {
    const s = `${t}__${r}`;
    o.__datetimeFormatters.has(s) && o.__datetimeFormatters.delete(s);
  }
}
function bs(e, ...t) {
  const { numberFormats: n, unresolving: o, fallbackLocale: r, onWarn: s, localeFallbacker: a } = e, { __numberFormatters: i } = e;
  if (process.env.NODE_ENV !== "production" && !ha.numberFormat)
    return s(Et(Ce.CANNOT_FORMAT_NUMBER)), an;
  if (!Ae(t[0]))
    return process.env.NODE_ENV !== "production" && s(Et(Ce.INVALID_NUMBER_ARGUMENT, {
      value: String(t[0])
    })), an;
  const [l, p, y, k] = Xo(...t), d = ve(y.missingWarn) ? y.missingWarn : e.missingWarn, w = ve(y.fallbackWarn) ? y.fallbackWarn : e.fallbackWarn, N = !!y.part, h = gr(e, y), T = a(
    e,
    // eslint-disable-line @typescript-eslint/no-explicit-any
    r,
    h
  );
  if (!M(l) || l === "")
    return new Intl.NumberFormat(h.replace(/!/g, ""), k).format(p);
  let m = {}, g, C = null, f = h, A = null;
  const P = "number format";
  for (let H = 0; H < T.length; H++) {
    if (g = A = T[H], process.env.NODE_ENV !== "production" && h !== g && vo(w, l) && s(Et(Ce.FALLBACK_TO_NUMBER_FORMAT, {
      key: l,
      target: g
    })), process.env.NODE_ENV !== "production" && h !== g) {
      const F = e.__v_emitter;
      F && F.emit("fallback", {
        type: P,
        key: l,
        from: f,
        to: A,
        groupId: `${P}:${l}`
      });
    }
    if (m = n[g] || {}, C = m[l], ie(C))
      break;
    br(e, l, g, d, P), f = A;
  }
  if (!ie(C) || !M(g))
    return o ? bo : l;
  let x = `${g}__${l}`;
  go(k) || (x = `${x}__${JSON.stringify(k)}`);
  let z = i.get(x);
  return z || (z = new Intl.NumberFormat(g, Le({}, C, k)), i.set(x, z)), N ? z.formatToParts(p) : z.format(p);
}
const ba = [
  "localeMatcher",
  "style",
  "currency",
  "currencyDisplay",
  "currencySign",
  "useGrouping",
  "minimumIntegerDigits",
  "minimumFractionDigits",
  "maximumFractionDigits",
  "minimumSignificantDigits",
  "maximumSignificantDigits",
  "compactDisplay",
  "notation",
  "signDisplay",
  "unit",
  "unitDisplay",
  "roundingMode",
  "roundingPriority",
  "roundingIncrement",
  "trailingZeroDisplay"
];
function Xo(...e) {
  const [t, n, o, r] = e, s = le();
  let a = le();
  if (!Ae(t))
    throw _t($e.INVALID_ARGUMENT);
  const i = t;
  return M(n) ? s.key = n : ie(n) && Object.keys(n).forEach((l) => {
    ba.includes(l) ? a[l] = n[l] : s[l] = n[l];
  }), M(o) ? s.locale = o : ie(o) && (a = o), ie(r) && (a = r), [s.key || "", i, s, a];
}
function vs(e, t, n) {
  const o = e;
  for (const r in n) {
    const s = `${t}__${r}`;
    o.__numberFormatters.has(s) && o.__numberFormatters.delete(s);
  }
}
const nu = (e) => e, ou = (e) => "", ru = "text", su = (e) => e.length === 0 ? "" : wr(e), au = Dl;
function Ro(e, t) {
  return e = Math.abs(e), t === 2 ? e === 1 ? 0 : 1 : Math.min(e, 2);
}
function iu(e) {
  var n, o;
  const t = Ae(e.pluralIndex) ? e.pluralIndex : -1;
  return Ae((n = e.named) == null ? void 0 : n.count) ? e.named.count : Ae((o = e.named) == null ? void 0 : o.n) ? e.named.n : t;
}
function lu(e = {}) {
  var m, g, C, f;
  const t = e.locale, n = iu(e), o = M(t) && fe((m = e.pluralRules) == null ? void 0 : m[t]) ? e.pluralRules[t] : Ro, r = o === Ro ? void 0 : Ro, s = (A) => A[o(n, A.length, r)], a = e.list || [], i = (A) => a[A], l = e.named || le();
  Ae(e.pluralIndex) && (l.count || (l.count = e.pluralIndex), l.n || (l.n = e.pluralIndex));
  const p = (A) => l[A];
  function y(A, P) {
    const x = fe(e.messages) ? e.messages(A, !!P) : se(e.messages) ? e.messages[A] : !1;
    return x || (e.parent ? e.parent.message(A) : ou);
  }
  const k = (A) => e.modifiers ? e.modifiers[A] : nu, d = fe((g = e.processor) == null ? void 0 : g.normalize) ? e.processor.normalize : su, w = fe((C = e.processor) == null ? void 0 : C.interpolate) ? e.processor.interpolate : au, N = M((f = e.processor) == null ? void 0 : f.type) ? e.processor.type : ru, T = {
    list: i,
    named: p,
    plural: s,
    linked: (A, ...P) => {
      const [x, z] = P;
      let H = "text", F = "";
      P.length === 1 ? se(x) ? (F = x.modifier || F, H = x.type || H) : M(x) && (F = x || F) : P.length === 2 && (M(x) && (F = x || F), M(z) && (H = z || H));
      const Y = y(A, !0)(T), ne = Y === "" || Y === void 0 ? A : Y, Je = (
        // The message in vnode resolved with linked are returned as an array by processor.nomalize
        H === "vnode" && ye(ne) && F ? ne[0] : ne
      );
      return F ? k(F)(Je, H) : Je;
    },
    message: y,
    type: N,
    interpolate: w,
    normalize: d,
    values: Le(le(), a, l)
  };
  return T;
}
const ys = () => "", tt = (e) => fe(e);
function _s(e, ...t) {
  const { fallbackFormat: n, postTranslation: o, unresolving: r, messageCompiler: s, fallbackLocale: a, messages: i } = e, [l, p] = Zo(...t), y = ve(p.missingWarn) ? p.missingWarn : e.missingWarn, k = ve(p.fallbackWarn) ? p.fallbackWarn : e.fallbackWarn, d = ve(p.escapeParameter) ? p.escapeParameter : e.escapeParameter, w = !!p.resolvedMessage, N = M(p.default) || ve(p.default) ? ve(p.default) ? s ? l : () => l : p.default : n ? s ? l : () => l : null, h = n || N != null && (M(N) || fe(N)), T = gr(e, p);
  d && cu(p);
  let [m, g, C] = w ? [
    l,
    T,
    i[T] || le()
  ] : va(e, l, T, a, k, y), f = m, A = l;
  if (!w && !(M(f) || it(f) || tt(f)) && h && (f = N, A = f), !w && (!(M(f) || it(f) || tt(f)) || !M(g)))
    return r ? bo : l;
  if (process.env.NODE_ENV !== "production" && M(f) && e.messageCompiler == null)
    return pt(`The message format compilation is not supported in this build. Because message compiler isn't included. You need to pre-compilation all message format. So translate function return '${l}'.`), l;
  let P = !1;
  const x = () => {
    P = !0;
  }, z = tt(f) ? f : ya(e, l, g, f, A, x);
  if (P)
    return f;
  const H = fu(e, g, C, p), F = lu(H), Y = uu(e, z, F);
  let ne = o ? o(Y, l) : Y;
  if (d && M(ne) && (ne = Il(ne)), process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
    const Je = {
      timestamp: Date.now(),
      key: M(l) ? l : tt(f) ? f.key : "",
      locale: g || (tt(f) ? f.locale : ""),
      format: M(f) ? f : tt(f) ? f.source : "",
      message: ne
    };
    Je.meta = Le({}, e.__meta, /* @__PURE__ */ Jc() || {}), Oc(Je);
  }
  return ne;
}
function cu(e) {
  ye(e.list) ? e.list = e.list.map((t) => M(t) ? ns(t) : t) : se(e.named) && Object.keys(e.named).forEach((t) => {
    M(e.named[t]) && (e.named[t] = ns(e.named[t]));
  });
}
function va(e, t, n, o, r, s) {
  const { messages: a, onWarn: i, messageResolver: l, localeFallbacker: p } = e, y = p(e, o, n);
  let k = le(), d, w = null, N = n, h = null;
  const T = "translate";
  for (let m = 0; m < y.length; m++) {
    if (d = h = y[m], process.env.NODE_ENV !== "production" && n !== d && !pa(n, d) && vo(r, t) && i(Et(Ce.FALLBACK_TO_TRANSLATE, {
      key: t,
      target: d
    })), process.env.NODE_ENV !== "production" && n !== d) {
      const A = e.__v_emitter;
      A && A.emit("fallback", {
        type: T,
        key: t,
        from: N,
        to: h,
        groupId: `${T}:${t}`
      });
    }
    k = a[d] || le();
    let g = null, C, f;
    if (process.env.NODE_ENV !== "production" && Ct && (g = window.performance.now(), C = "intlify-message-resolve-start", f = "intlify-message-resolve-end", We && We(C)), (w = l(k, t)) === null && (w = k[t]), process.env.NODE_ENV !== "production" && Ct) {
      const A = window.performance.now(), P = e.__v_emitter;
      P && g && w && P.emit("message-resolve", {
        type: "message-resolve",
        key: t,
        message: w,
        time: A - g,
        groupId: `${T}:${t}`
      }), C && f && We && qt && (We(f), qt("intlify message resolve", C, f));
    }
    if (M(w) || it(w) || tt(w))
      break;
    if (!tu(d, y)) {
      const A = br(
        e,
        // eslint-disable-line @typescript-eslint/no-explicit-any
        t,
        d,
        s,
        T
      );
      A !== t && (w = A);
    }
    N = h;
  }
  return [w, d, k];
}
function ya(e, t, n, o, r, s) {
  const { messageCompiler: a, warnHtmlMessage: i } = e;
  if (tt(o)) {
    const d = o;
    return d.locale = d.locale || n, d.key = d.key || t, d;
  }
  if (a == null) {
    const d = () => o;
    return d.locale = n, d.key = t, d;
  }
  let l = null, p, y;
  process.env.NODE_ENV !== "production" && Ct && (l = window.performance.now(), p = "intlify-message-compilation-start", y = "intlify-message-compilation-end", We && We(p));
  const k = a(o, du(e, n, r, o, i, s));
  if (process.env.NODE_ENV !== "production" && Ct) {
    const d = window.performance.now(), w = e.__v_emitter;
    w && l && w.emit("message-compilation", {
      type: "message-compilation",
      message: o,
      time: d - l,
      groupId: `translate:${t}`
    }), p && y && We && qt && (We(y), qt("intlify message compilation", p, y));
  }
  return k.locale = n, k.key = t, k.source = o, k;
}
function uu(e, t, n) {
  let o = null, r, s;
  process.env.NODE_ENV !== "production" && Ct && (o = window.performance.now(), r = "intlify-message-evaluation-start", s = "intlify-message-evaluation-end", We && We(r));
  const a = t(n);
  if (process.env.NODE_ENV !== "production" && Ct) {
    const i = window.performance.now(), l = e.__v_emitter;
    l && o && l.emit("message-evaluation", {
      type: "message-evaluation",
      value: a,
      time: i - o,
      groupId: `translate:${t.key}`
    }), r && s && We && qt && (We(s), qt("intlify message evaluation", r, s));
  }
  return a;
}
function Zo(...e) {
  const [t, n, o] = e, r = le();
  if (!M(t) && !Ae(t) && !tt(t) && !it(t))
    throw _t($e.INVALID_ARGUMENT);
  const s = Ae(t) ? String(t) : (tt(t), t);
  return Ae(n) ? r.plural = n : M(n) ? r.default = n : ie(n) && !go(n) ? r.named = n : ye(n) && (r.list = n), Ae(o) ? r.plural = o : M(o) ? r.default = o : ie(o) && Le(r, o), [s, r];
}
function du(e, t, n, o, r, s) {
  return {
    locale: t,
    key: n,
    warnHtmlMessage: r,
    onError: (a) => {
      if (s && s(a), process.env.NODE_ENV !== "production") {
        const i = mu(o), l = a.location && i && Ml(i, a.location.start.offset, a.location.end.offset), p = e.__v_emitter;
        p && i && p.emit("compile-error", {
          message: i,
          error: a.message,
          start: a.location && a.location.start.offset,
          end: a.location && a.location.end.offset,
          groupId: `translate:${n}`
        });
        const y = `Message compilation error: ${a.message}`;
        throw new SyntaxError(l ? `${y}
${l}` : y);
      }
      throw a;
    },
    onCacheKey: (a) => Nl(t, n, a)
  };
}
function mu(e) {
  if (M(e))
    return e;
  if (e.loc && e.loc.source)
    return e.loc.source;
}
function fu(e, t, n, o) {
  const { modifiers: r, pluralRules: s, messageResolver: a, fallbackLocale: i, fallbackWarn: l, missingWarn: p, fallbackContext: y } = e, d = {
    locale: t,
    modifiers: r,
    pluralRules: s,
    messages: (w, N) => {
      let h = a(n, w);
      if (h == null && (y || N)) {
        const [T, , m] = va(
          y || e,
          // NOTE: if has fallbackContext, fallback to root, else if use linked, fallback to local context
          w,
          t,
          i,
          l,
          p
        );
        h = T ?? a(m, w);
      }
      if (M(h) || it(h)) {
        let T = !1;
        const g = ya(e, w, t, h, w, () => {
          T = !0;
        });
        return T ? ys : g;
      } else return tt(h) ? h : ys;
    }
  };
  return e.processor && (d.processor = e.processor), o.list && (d.list = o.list), o.named && (d.named = o.named), Ae(o.plural) && (d.pluralIndex = o.plural), d;
}
pc();
/*!
  * vue-i18n v11.3.1
  * (c) 2026 kazuya kawaguchi
  * Released under the MIT License.
  */
const wu = "11.3.1";
function pu() {
  typeof __VUE_I18N_FULL_INSTALL__ != "boolean" && (Ht().__VUE_I18N_FULL_INSTALL__ = !0), typeof __VUE_I18N_LEGACY_API__ != "boolean" && (Ht().__VUE_I18N_LEGACY_API__ = !0), typeof __INTLIFY_DROP_MESSAGE_COMPILER__ != "boolean" && (Ht().__INTLIFY_DROP_MESSAGE_COMPILER__ = !1), typeof __INTLIFY_PROD_DEVTOOLS__ != "boolean" && (Ht().__INTLIFY_PROD_DEVTOOLS__ = !1);
}
const Oe = {
  // composer module errors
  UNEXPECTED_RETURN_TYPE: Ic,
  // 24
  // legacy module errors
  INVALID_ARGUMENT: 25,
  // i18n module errors
  MUST_BE_CALL_SETUP_TOP: 26,
  NOT_INSTALLED: 27,
  // directive module errors
  REQUIRED_VALUE: 28,
  INVALID_VALUE: 29,
  // vue-devtools errors
  CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN: 30,
  NOT_INSTALLED_WITH_PROVIDE: 31,
  // unexpected error
  UNEXPECTED_ERROR: 32,
  // not compatible legacy vue-i18n constructor
  NOT_COMPATIBLE_LEGACY_VUE_I18N: 33,
  // Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly
  NOT_AVAILABLE_COMPOSITION_IN_LEGACY: 34
};
function Ln(e, ...t) {
  return mn(e, null, process.env.NODE_ENV !== "production" ? { messages: hu, args: t } : void 0);
}
const hu = {
  [Oe.UNEXPECTED_RETURN_TYPE]: "Unexpected return type in composer",
  [Oe.INVALID_ARGUMENT]: "Invalid argument",
  [Oe.MUST_BE_CALL_SETUP_TOP]: "Must be called at the top of a `setup` function",
  [Oe.NOT_INSTALLED]: "Need to install with `app.use` function",
  [Oe.UNEXPECTED_ERROR]: "Unexpected error",
  [Oe.REQUIRED_VALUE]: "Required in value: {0}",
  [Oe.INVALID_VALUE]: "Invalid value",
  [Oe.CANNOT_SETUP_VUE_DEVTOOLS_PLUGIN]: "Cannot setup vue-devtools plugin",
  [Oe.NOT_INSTALLED_WITH_PROVIDE]: "Need to install with `provide` function",
  [Oe.NOT_COMPATIBLE_LEGACY_VUE_I18N]: "Not compatible legacy VueI18n.",
  [Oe.NOT_AVAILABLE_COMPOSITION_IN_LEGACY]: "Not available Compostion API in Legacy API mode. Please make sure that the legacy API mode is working properly"
}, Jo = /* @__PURE__ */ At("__translateVNode"), Qo = /* @__PURE__ */ At("__datetimeParts"), er = /* @__PURE__ */ At("__numberParts"), tr = /* @__PURE__ */ At("__enableEmitter"), nr = /* @__PURE__ */ At("__disableEmitter"), gu = At("__setPluralRules"), _a = /* @__PURE__ */ At("__injectWithOption"), or = /* @__PURE__ */ At("__dispose"), wt = {
  FALLBACK_TO_ROOT: Qt,
  // 10
  NOT_FOUND_PARENT_SCOPE: Qt + 1,
  IGNORE_OBJ_FLATTEN: Qt + 2,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  DEPRECATE_LEGACY_MODE: Qt + 3,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE: Qt + 4,
  // duplicate `useI18n` calling
  DUPLICATE_USE_I18N_CALLING: Qt + 5
}, bu = {
  [wt.FALLBACK_TO_ROOT]: "Fall back to {type} '{key}' with root locale.",
  [wt.NOT_FOUND_PARENT_SCOPE]: "Not found parent scope. use the global scope.",
  [wt.IGNORE_OBJ_FLATTEN]: "Ignore object flatten: '{key}' key has an string value",
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  [wt.DEPRECATE_LEGACY_MODE]: `Legacy API mode has been deprecated in v11. Use Composition API mode instead.
About how to use the Composition API mode, see https://vue-i18n.intlify.dev/guide/advanced/composition.html`,
  /**
   * @deprecated will be removed at vue-i18n v12
   */
  [wt.DEPRECATE_TRANSLATE_CUSTOME_DIRECTIVE]: "'v-t' has been deprecated in v11. Use translate APIs ('t' or '$t') instead.",
  [wt.DUPLICATE_USE_I18N_CALLING]: "Duplicate `useI18n` calling by local scope. Please don't call it on local scope, due to it does not work properly in component."
};
function Xn(e, ...t) {
  return ho(bu[e], ...t);
}
function Tn(e) {
  if (!se(e) || it(e))
    return e;
  for (const t in e)
    if (nt(e, t))
      if (!t.includes("."))
        se(e[t]) && Tn(e[t]);
      else {
        const n = t.split("."), o = n.length - 1;
        let r = e, s = !1;
        for (let a = 0; a < o; a++) {
          if (n[a] === "__proto__")
            throw new Error(`unsafe key: ${n[a]}`);
          if (n[a] in r || (r[n[a]] = le()), !se(r[n[a]])) {
            process.env.NODE_ENV !== "production" && pt(Xn(wt.IGNORE_OBJ_FLATTEN, {
              key: n[a]
            })), s = !0;
            break;
          }
          r = r[n[a]];
        }
        if (s || (it(r) ? la.includes(n[o]) || delete e[t] : (r[n[o]] = e[t], delete e[t])), !it(r)) {
          const a = r[n[o]];
          se(a) && Tn(a);
        }
      }
  return e;
}
function Ea(e, t) {
  const { messages: n, __i18n: o, messageResolver: r, flatJson: s } = t, a = ie(n) ? n : ye(o) ? le() : { [e]: le() };
  if (ye(o) && o.forEach((i) => {
    if ("locale" in i && "resource" in i) {
      const { locale: l, resource: p } = i;
      l ? (a[l] = a[l] || le(), zn(p, a[l])) : zn(p, a);
    } else
      M(i) && zn(JSON.parse(i), a);
  }), r == null && s)
    for (const i in a)
      nt(a, i) && Tn(a[i]);
  return a;
}
function ka(e) {
  return e.type;
}
function vu(e, t, n) {
  let o = se(t.messages) ? t.messages : le();
  "__i18nGlobal" in n && (o = Ea(e.locale.value, {
    messages: o,
    __i18n: n.__i18nGlobal
  }));
  const r = Object.keys(o);
  r.length && r.forEach((s) => {
    e.mergeLocaleMessage(s, o[s]);
  });
  {
    if (se(t.datetimeFormats)) {
      const s = Object.keys(t.datetimeFormats);
      s.length && s.forEach((a) => {
        e.mergeDateTimeFormat(a, t.datetimeFormats[a]);
      });
    }
    if (se(t.numberFormats)) {
      const s = Object.keys(t.numberFormats);
      s.length && s.forEach((a) => {
        e.mergeNumberFormat(a, t.numberFormats[a]);
      });
    }
  }
}
function Es(e) {
  return Wo(El, null, e, 0);
}
function vr() {
  const e = "currentInstance";
  return e in Po ? Po[e] : Po.getCurrentInstance();
}
const ks = "__INTLIFY_META__", xs = () => [], yu = () => !1;
let Cs = 0;
function As(e) {
  return (t, n, o, r) => e(n, o, vr() || void 0, r);
}
const _u = /* @__NO_SIDE_EFFECTS__ */ () => {
  const e = vr();
  let t = null;
  return e && (t = ka(e)[ks]) ? { [ks]: t } : null;
};
function Eu(e = {}) {
  const { __root: t, __injectWithOption: n } = e, o = t === void 0, r = e.flatJson, s = Ct ? Ve : _l;
  let a = ve(e.inheritLocale) ? e.inheritLocale : !0;
  const i = s(
    // prettier-ignore
    t && a ? t.locale.value : M(e.locale) ? e.locale : Gn
  ), l = s(
    // prettier-ignore
    t && a ? t.fallbackLocale.value : M(e.fallbackLocale) || ye(e.fallbackLocale) || ie(e.fallbackLocale) || e.fallbackLocale === !1 ? e.fallbackLocale : i.value
  ), p = s(Ea(i.value, e)), y = s(ie(e.datetimeFormats) ? e.datetimeFormats : { [i.value]: {} }), k = s(ie(e.numberFormats) ? e.numberFormats : { [i.value]: {} });
  let d = t ? t.missingWarn : ve(e.missingWarn) || Kn(e.missingWarn) ? e.missingWarn : !0, w = t ? t.fallbackWarn : ve(e.fallbackWarn) || Kn(e.fallbackWarn) ? e.fallbackWarn : !0, N = t ? t.fallbackRoot : ve(e.fallbackRoot) ? e.fallbackRoot : !0, h = !!e.fallbackFormat, T = fe(e.missing) ? e.missing : null, m = fe(e.missing) ? As(e.missing) : null, g = fe(e.postTranslation) ? e.postTranslation : null, C = t ? t.warnHtmlMessage : ve(e.warnHtmlMessage) ? e.warnHtmlMessage : !0, f = !!e.escapeParameter;
  const A = t ? t.modifiers : ie(e.modifiers) ? e.modifiers : {};
  let P = e.pluralRules || t && t.pluralRules, x;
  x = (() => {
    o && fs(null);
    const E = {
      version: wu,
      locale: i.value,
      fallbackLocale: l.value,
      messages: p.value,
      modifiers: A,
      pluralRules: P,
      missing: m === null ? void 0 : m,
      missingWarn: d,
      fallbackWarn: w,
      fallbackFormat: h,
      unresolving: !0,
      postTranslation: g === null ? void 0 : g,
      warnHtmlMessage: C,
      escapeParameter: f,
      messageResolver: e.messageResolver,
      messageCompiler: e.messageCompiler,
      __meta: { framework: "vue" }
    };
    E.datetimeFormats = y.value, E.numberFormats = k.value, E.__datetimeFormatters = ie(x) ? x.__datetimeFormatters : void 0, E.__numberFormatters = ie(x) ? x.__numberFormatters : void 0, process.env.NODE_ENV !== "production" && (E.__v_emitter = ie(x) ? x.__v_emitter : void 0);
    const O = eu(E);
    return o && fs(O), O;
  })(), xn(x, i.value, l.value);
  function H() {
    return [
      i.value,
      l.value,
      p.value,
      y.value,
      k.value
    ];
  }
  const F = Ye({
    get: () => i.value,
    set: (E) => {
      x.locale = E, i.value = E;
    }
  }), Y = Ye({
    get: () => l.value,
    set: (E) => {
      x.fallbackLocale = E, l.value = E, xn(x, i.value, E);
    }
  }), ne = Ye(() => p.value), Je = /* @__PURE__ */ Ye(() => y.value), W = /* @__PURE__ */ Ye(() => k.value);
  function S() {
    return fe(g) ? g : null;
  }
  function I(E) {
    g = E, x.postTranslation = E;
  }
  function B() {
    return T;
  }
  function $(E) {
    E !== null && (m = As(E)), T = E, x.missing = m;
  }
  function G(E, O) {
    return E !== "translate" || !O.resolvedMessage;
  }
  const V = (E, O, Q, pe, Rt, Bt) => {
    H();
    let et;
    try {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, o || (x.fallbackContext = t ? Qc() : void 0), et = E(x);
    } finally {
      process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__, o || (x.fallbackContext = void 0);
    }
    if (Q !== "translate exists" && // for not `te` (e.g `t`)
    Ae(et) && et === bo || Q === "translate exists" && !et) {
      const [Ft, bl] = O();
      if (process.env.NODE_ENV !== "production" && t && M(Ft) && G(Q, bl) && (N && (vo(w, Ft) || wa(d, Ft)) && pt(Xn(wt.FALLBACK_TO_ROOT, {
        key: Ft,
        type: Q
      })), process.env.NODE_ENV !== "production")) {
        const { __v_emitter: Qr } = x;
        Qr && N && Qr.emit("fallback", {
          type: Q,
          key: Ft,
          to: "global",
          groupId: `${Q}:${Ft}`
        });
      }
      return t && N ? pe(t) : Rt(Ft);
    } else {
      if (Bt(et))
        return et;
      throw Ln(Oe.UNEXPECTED_RETURN_TYPE);
    }
  };
  function Z(...E) {
    return V((O) => Reflect.apply(_s, null, [O, ...E]), () => Zo(...E), "translate", (O) => Reflect.apply(O.t, O, [...E]), (O) => O, (O) => M(O));
  }
  function de(...E) {
    const [O, Q, pe] = E;
    if (pe && !se(pe))
      throw Ln(Oe.INVALID_ARGUMENT);
    return Z(O, Q, Le({ resolvedMessage: !0 }, pe || {}));
  }
  function we(...E) {
    return V((O) => Reflect.apply(hs, null, [O, ...E]), () => Go(...E), "datetime format", (O) => Reflect.apply(O.d, O, [...E]), () => an, (O) => M(O) || ye(O));
  }
  function ke(...E) {
    return V((O) => Reflect.apply(bs, null, [O, ...E]), () => Xo(...E), "number format", (O) => Reflect.apply(O.n, O, [...E]), () => an, (O) => M(O) || ye(O));
  }
  function Pe(E) {
    return E.map((O) => M(O) || Ae(O) || ve(O) ? Es(String(O)) : O);
  }
  const st = {
    normalize: Pe,
    interpolate: (E) => E,
    type: "vnode"
  };
  function lt(...E) {
    return V((O) => {
      let Q;
      const pe = O;
      try {
        pe.processor = st, Q = Reflect.apply(_s, null, [pe, ...E]);
      } finally {
        pe.processor = null;
      }
      return Q;
    }, () => Zo(...E), "translate", (O) => O[Jo](...E), (O) => [Es(O)], (O) => ye(O));
  }
  function at(...E) {
    return V((O) => Reflect.apply(bs, null, [O, ...E]), () => Xo(...E), "number format", (O) => O[er](...E), xs, (O) => M(O) || ye(O));
  }
  function xe(...E) {
    return V((O) => Reflect.apply(hs, null, [O, ...E]), () => Go(...E), "datetime format", (O) => O[Qo](...E), xs, (O) => M(O) || ye(O));
  }
  function Qe(E) {
    P = E, x.pluralRules = P;
  }
  function vt(E, O) {
    return V(() => {
      if (!E)
        return !1;
      const Q = M(O) ? O : i.value, pe = M(O) ? [Q] : Ko(x, l.value, Q);
      for (let Rt = 0; Rt < pe.length; Rt++) {
        const Bt = Mt(pe[Rt]);
        let et = x.messageResolver(Bt, E);
        if (et === null && (et = Bt[E]), it(et) || tt(et) || M(et))
          return !0;
      }
      return !1;
    }, () => [E], "translate exists", (Q) => Reflect.apply(Q.te, Q, [E, O]), yu, (Q) => ve(Q));
  }
  function ct(E) {
    let O = null;
    const Q = Ko(x, l.value, i.value);
    for (let pe = 0; pe < Q.length; pe++) {
      const Rt = p.value[Q[pe]] || {}, Bt = x.messageResolver(Rt, E);
      if (Bt != null) {
        O = Bt;
        break;
      }
    }
    return O;
  }
  function En(E) {
    const O = ct(E);
    return O ?? (t ? t.tm(E) || {} : {});
  }
  function Mt(E) {
    return p.value[E] || {};
  }
  function kn(E, O) {
    if (r) {
      const Q = { [E]: O };
      for (const pe in Q)
        nt(Q, pe) && Tn(Q[pe]);
      O = Q[E];
    }
    p.value[E] = O, x.messages = p.value;
  }
  function Oo(E, O) {
    p.value[E] = p.value[E] || {};
    const Q = { [E]: O };
    if (r)
      for (const pe in Q)
        nt(Q, pe) && Tn(Q[pe]);
    O = Q[E], zn(O, p.value[E]), x.messages = p.value;
  }
  function c(E) {
    return y.value[E] || {};
  }
  function u(E, O) {
    y.value[E] = O, x.datetimeFormats = y.value, gs(x, E, O);
  }
  function L(E, O) {
    y.value[E] = Le(y.value[E] || {}, O), x.datetimeFormats = y.value, gs(x, E, O);
  }
  function D(E) {
    return k.value[E] || {};
  }
  function me(E, O) {
    k.value[E] = O, x.numberFormats = k.value, vs(x, E, O);
  }
  function he(E, O) {
    k.value[E] = Le(k.value[E] || {}, O), x.numberFormats = k.value, vs(x, E, O);
  }
  Cs++, t && Ct && (Yo(t.locale, (E) => {
    a && (i.value = E, x.locale = E, xn(x, i.value, l.value));
  }), Yo(t.fallbackLocale, (E) => {
    a && (l.value = E, x.fallbackLocale = E, xn(x, i.value, l.value));
  }));
  const J = {
    id: Cs,
    locale: F,
    fallbackLocale: Y,
    get inheritLocale() {
      return a;
    },
    set inheritLocale(E) {
      a = E, E && t && (i.value = t.locale.value, l.value = t.fallbackLocale.value, xn(x, i.value, l.value));
    },
    get availableLocales() {
      return Object.keys(p.value).sort();
    },
    messages: ne,
    get modifiers() {
      return A;
    },
    get pluralRules() {
      return P || {};
    },
    get isGlobal() {
      return o;
    },
    get missingWarn() {
      return d;
    },
    set missingWarn(E) {
      d = E, x.missingWarn = d;
    },
    get fallbackWarn() {
      return w;
    },
    set fallbackWarn(E) {
      w = E, x.fallbackWarn = w;
    },
    get fallbackRoot() {
      return N;
    },
    set fallbackRoot(E) {
      N = E;
    },
    get fallbackFormat() {
      return h;
    },
    set fallbackFormat(E) {
      h = E, x.fallbackFormat = h;
    },
    get warnHtmlMessage() {
      return C;
    },
    set warnHtmlMessage(E) {
      C = E, x.warnHtmlMessage = E;
    },
    get escapeParameter() {
      return f;
    },
    set escapeParameter(E) {
      f = E, x.escapeParameter = E;
    },
    t: Z,
    getLocaleMessage: Mt,
    setLocaleMessage: kn,
    mergeLocaleMessage: Oo,
    getPostTranslationHandler: S,
    setPostTranslationHandler: I,
    getMissingHandler: B,
    setMissingHandler: $,
    [gu]: Qe
  };
  return J.datetimeFormats = Je, J.numberFormats = W, J.rt = de, J.te = vt, J.tm = En, J.d = we, J.n = ke, J.getDateTimeFormat = c, J.setDateTimeFormat = u, J.mergeDateTimeFormat = L, J.getNumberFormat = D, J.setNumberFormat = me, J.mergeNumberFormat = he, J[_a] = n, J[Jo] = lt, J[Qo] = xe, J[er] = at, process.env.NODE_ENV !== "production" && (J[tr] = (E) => {
    x.__v_emitter = E;
  }, J[nr] = () => {
    x.__v_emitter = void 0;
  }), J;
}
function Ls(e, t) {
}
const yr = {
  tag: {
    type: [String, Object]
  },
  locale: {
    type: String
  },
  scope: {
    type: String,
    // NOTE: avoid https://github.com/microsoft/rushstack/issues/1050
    validator: (e) => e === "parent" || e === "global",
    default: "parent"
    /* ComponentI18nScope */
  },
  i18n: {
    type: Object
  }
};
function ku({ slots: e }, t) {
  return t.length === 1 && t[0] === "default" ? (e.default ? e.default() : []).reduce((o, r) => [
    ...o,
    // prettier-ignore
    ...r.type === Nn ? r.children : [r]
  ], []) : t.reduce((n, o) => {
    const r = e[o];
    return r && (n[o] = r()), n;
  }, le());
}
function xa() {
  return Nn;
}
Le({
  keypath: {
    type: String,
    required: !0
  },
  plural: {
    type: [Number, String],
    validator: (e) => Ae(e) || !isNaN(e)
  }
}, yr);
function xu(e) {
  return ye(e) && !M(e[0]);
}
function Ca(e, t, n, o) {
  const { slots: r, attrs: s } = t;
  return () => {
    const a = { part: !0 };
    let i = le();
    e.locale && (a.locale = e.locale), M(e.format) ? a.key = e.format : se(e.format) && (M(e.format.key) && (a.key = e.format.key), i = Object.keys(e.format).reduce((d, w) => n.includes(w) ? Le(le(), d, { [w]: e.format[w] }) : d, le()));
    const l = o(e.value, a, i);
    let p = [a.key];
    ye(l) ? p = l.map((d, w) => {
      const N = r[d.type], h = N ? N({ [d.type]: d.value, index: w, parts: l }) : [d.value];
      return xu(h) && (h[0].key = `${d.type}-${w}`), h;
    }) : M(l) && (p = [l]);
    const y = Le(le(), s), k = M(e.tag) || se(e.tag) ? e.tag : xa();
    return Xs(k, y, p);
  };
}
Le({
  value: {
    type: Number,
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, yr);
const Cu = /* @__PURE__ */ At("global-vue-i18n");
function fn(e = {}) {
  const t = vr();
  if (t == null)
    throw Ln(Oe.MUST_BE_CALL_SETUP_TOP);
  if (!t.isCE && t.appContext.app != null && !t.appContext.app.__VUE_I18N_SYMBOL__)
    throw Ln(Oe.NOT_INSTALLED);
  const n = Au(t), o = Tu(n), r = ka(t), s = Lu(e, r);
  if (s === "global")
    return vu(o, e, r), o;
  if (s === "parent") {
    let l = Nu(n, t, e.__useComponent);
    return l == null && (process.env.NODE_ENV !== "production" && pt(Xn(wt.NOT_FOUND_PARENT_SCOPE)), l = o), l;
  }
  const a = n;
  let i = a.__getInstance(t);
  if (i == null) {
    const l = Le({}, e);
    "__i18n" in r && (l.__i18n = r.__i18n), o && (l.__root = o), i = Eu(l), a.__composerExtend && (i[or] = a.__composerExtend(i)), Pu(a, t, i), a.__setInstance(t, i);
  } else
    process.env.NODE_ENV !== "production" && s === "local" && pt(Xn(wt.DUPLICATE_USE_I18N_CALLING));
  return i;
}
function Au(e) {
  const t = vl(e.isCE ? Cu : e.appContext.app.__VUE_I18N_SYMBOL__);
  if (!t)
    throw Ln(e.isCE ? Oe.NOT_INSTALLED_WITH_PROVIDE : Oe.UNEXPECTED_ERROR);
  return t;
}
function Lu(e, t) {
  return go(e) ? "__i18n" in t ? "local" : "global" : e.useScope ? e.useScope : "local";
}
function Tu(e) {
  return e.mode === "composition" ? e.global : e.global.__composer;
}
function Nu(e, t, n = !1) {
  let o = null;
  const r = t.root;
  let s = Ou(t, n);
  for (; s != null; ) {
    const a = e;
    if (e.mode === "composition")
      o = a.__getInstance(s);
    else if (__VUE_I18N_LEGACY_API__) {
      const i = a.__getInstance(s);
      i != null && (o = i.__composer, n && o && !o[_a] && (o = null));
    }
    if (o != null || r === s)
      break;
    s = s.parent;
  }
  return o;
}
function Ou(e, t = !1) {
  return e == null ? null : t && e.vnode.ctx || e.parent;
}
function Pu(e, t, n) {
  let o = null;
  dr(() => {
    if (process.env.NODE_ENV !== "production") {
      t.__VUE_I18N__ = n, o = Rl();
      const r = n;
      r[tr] && r[tr](o), o.on("*", Ls);
    }
  }, t), yl(() => {
    const r = n;
    process.env.NODE_ENV !== "production" && (o && o.off("*", Ls), r[nr] && r[nr](), delete t.__VUE_I18N__), e.__deleteInstance(t);
    const s = r[or];
    s && (s(), delete r[or]);
  }, t);
}
Le({
  value: {
    type: [Number, Date],
    required: !0
  },
  format: {
    type: [String, Object]
  }
}, yr);
pu();
Kc(Lc);
Gc(Yc);
Xc(Ko);
if (process.env.NODE_ENV !== "production" || __INTLIFY_PROD_DEVTOOLS__) {
  const e = Ht();
  e.__INTLIFY__ = !0, Tc(e.__INTLIFY_DEVTOOLS_GLOBAL_HOOK__);
}
process.env.NODE_ENV;
function Iu(e) {
  const t = Ve([]), n = Ve(!1), o = Ve(null), r = async () => {
    n.value = !0, o.value = null;
    try {
      t.value = await e.getWeeklyReport();
    } catch (i) {
      o.value = i.message || "無法載入營收報表";
    } finally {
      n.value = !1;
    }
  }, s = Ye(() => t.value.reduce((i, l) => i + parseFloat(l.total_amount), 0)), a = Ye(() => t.value.reduce((i, l) => i + l.order_count, 0));
  return {
    reports: t,
    isLoading: n,
    reportError: o,
    fetchWeeklyData: r,
    weeklyTotalRevenue: s,
    weeklyTotalOrders: a
  };
}
const $u = { class: "p-6 max-w-4xl mx-auto bg-gray-50" }, Su = { class: "mb-8" }, Du = { class: "text-3xl font-black text-gray-900" }, Mu = { class: "text-gray-700" }, Ru = { class: "grid grid-cols-1 md:grid-cols-2 gap-4 mb-8" }, Bu = { class: "bg-blue-700 p-6 rounded-3xl text-white shadow-xl" }, Fu = { class: "text-blue-100 font-medium" }, Uu = { class: "text-4xl font-black mt-2" }, Vu = { class: "bg-white p-6 rounded-3xl border border-gray-100 shadow-sm" }, Hu = { class: "text-gray-700 font-medium" }, ju = { class: "text-4xl font-black mt-2 text-gray-700" }, Yu = { class: "text-lg" }, Wu = {
  key: 0,
  class: "text-center py-20"
}, qu = { class: "mt-4 text-blue-700 font-bold" }, zu = {
  key: 1,
  class: "bg-red-50 text-red-700 p-4 rounded-2xl border border-red-100"
}, Ku = {
  key: 2,
  class: "bg-white rounded-3xl shadow-sm border border-gray-100 overflow-hidden"
}, Gu = { class: "w-full text-left" }, Xu = { class: "bg-gray-50 border-b border-gray-100" }, Zu = { class: "px-6 py-4 text-gray-700 font-bold" }, Ju = { class: "px-6 py-4 text-gray-700 font-bold" }, Qu = { class: "px-6 py-4 text-gray-700 font-bold text-right" }, ed = { class: "divide-y divide-gray-50" }, td = { class: "px-6 py-4 font-medium text-gray-700" }, nd = { class: "px-6 py-4 text-gray-700" }, od = { class: "px-6 py-4 text-right font-bold text-blue-700" }, hb = /* @__PURE__ */ $t({
  __name: "RevenueReportPage",
  props: {
    revenueApi: {}
  },
  setup(e) {
    const { t, locale: n } = fn(), o = e, {
      reports: r,
      isLoading: s,
      reportError: a,
      fetchWeeklyData: i,
      weeklyTotalRevenue: l,
      weeklyTotalOrders: p
    } = Iu(o.revenueApi);
    return dr(() => {
      i();
    }), (y, k) => (X(), ee("div", $u, [
      _("header", Su, [
        _("h1", Du, j(K(t)("report.title")), 1),
        _("p", Mu, j(K(t)("report.subtitle")), 1)
      ]),
      _("div", Ru, [
        _("div", Bu, [
          _("p", Fu, j(K(t)("report.weeklyRevenue")), 1),
          _("h2", Uu, "$ " + j(K(l).toLocaleString()), 1)
        ]),
        _("div", Vu, [
          _("p", Hu, j(K(t)("report.weeklyOrders")), 1),
          _("h2", ju, [
            Lt(j(K(p)) + " ", 1),
            _("span", Yu, j(K(t)("report.orderUnit")), 1)
          ])
        ])
      ]),
      K(s) ? (X(), ee("div", Wu, [
        k[0] || (k[0] = _("div", { class: "inline-block animate-spin rounded-full h-8 w-8 border-4 border-blue-700 border-t-transparent" }, null, -1)),
        _("p", qu, j(K(t)("common.calculating")), 1)
      ])) : K(a) ? (X(), ee("div", zu, j(K(a)), 1)) : (X(), ee("div", Ku, [
        _("table", Gu, [
          _("thead", Xu, [
            _("tr", null, [
              _("th", Zu, j(K(t)("report.dateCol")), 1),
              _("th", Ju, j(K(t)("report.ordersCol")), 1),
              _("th", Qu, j(K(t)("report.revenueCol")), 1)
            ])
          ]),
          _("tbody", ed, [
            (X(!0), ee(Nn, null, mr(K(r), (d) => (X(), ee("tr", {
              key: d.report_date,
              class: "hover:bg-gray-50 transition"
            }, [
              _("td", td, j(new Date(d.report_date).toLocaleDateString(K(n))), 1),
              _("td", nd, j(d.order_count) + " " + j(K(t)("report.orderUnit")), 1),
              _("td", od, " $ " + j(parseFloat(d.total_amount).toLocaleString()), 1)
            ]))), 128))
          ])
        ])
      ]))
    ]));
  }
});
function rd(e) {
  const t = Ve(null), n = Ve(null), o = Ve(!1), r = Ve(null);
  return {
    paymentInfo: t,
    isLoading: o,
    paymentError: r,
    fetchPaymentInfo: async () => {
      o.value = !0, r.value = null;
      try {
        t.value = await e.getMerchantPaymentInfo();
      } catch (y) {
        r.value = y.message || "無法載入金流資訊";
      } finally {
        o.value = !1;
      }
    },
    fetchPaymentInfoPaginated: async (y) => {
      o.value = !0, r.value = null;
      try {
        const k = await e.getMerchantPaymentInfoPaginated(y);
        let d = {
          data: [],
          total: 0,
          page: (y == null ? void 0 : y.page) || 1,
          limit: (y == null ? void 0 : y.limit) || 10
        };
        if (Array.isArray(k))
          d = {
            data: k,
            total: Number(k.total ?? k.length),
            page: (y == null ? void 0 : y.page) || 1,
            limit: (y == null ? void 0 : y.limit) || 10
          };
        else if (k && typeof k == "object" && "data" in k) {
          const w = k;
          d = {
            data: Array.isArray(w.data) ? w.data : [],
            total: Number(w.total ?? 0),
            page: Number(w.page || (y == null ? void 0 : y.page) || 1),
            limit: Number(w.limit || (y == null ? void 0 : y.limit) || 10)
          };
        }
        return t.value = d.data, n.value = d, d;
      } catch (k) {
        throw r.value = k.message || "無法載入金流資訊", k;
      } finally {
        o.value = !1;
      }
    },
    createInvoice: async (y) => await e.createInvoice(y),
    queryCompanyName: async (y) => await e.queryCompanyName(y),
    voidPayment: async (y) => await e.voidPayment(y)
  };
}
var _r = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Er(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Aa = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(_r, function() {
    var n = 1e3, o = 6e4, r = 36e5, s = "millisecond", a = "second", i = "minute", l = "hour", p = "day", y = "week", k = "month", d = "quarter", w = "year", N = "date", h = "Invalid Date", T = /^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/, m = /\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g, g = { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(W) {
      var S = ["th", "st", "nd", "rd"], I = W % 100;
      return "[" + W + (S[(I - 20) % 10] || S[I] || S[0]) + "]";
    } }, C = function(W, S, I) {
      var B = String(W);
      return !B || B.length >= S ? W : "" + Array(S + 1 - B.length).join(I) + W;
    }, f = { s: C, z: function(W) {
      var S = -W.utcOffset(), I = Math.abs(S), B = Math.floor(I / 60), $ = I % 60;
      return (S <= 0 ? "+" : "-") + C(B, 2, "0") + ":" + C($, 2, "0");
    }, m: function W(S, I) {
      if (S.date() < I.date()) return -W(I, S);
      var B = 12 * (I.year() - S.year()) + (I.month() - S.month()), $ = S.clone().add(B, k), G = I - $ < 0, V = S.clone().add(B + (G ? -1 : 1), k);
      return +(-(B + (I - $) / (G ? $ - V : V - $)) || 0);
    }, a: function(W) {
      return W < 0 ? Math.ceil(W) || 0 : Math.floor(W);
    }, p: function(W) {
      return { M: k, y: w, w: y, d: p, D: N, h: l, m: i, s: a, ms: s, Q: d }[W] || String(W || "").toLowerCase().replace(/s$/, "");
    }, u: function(W) {
      return W === void 0;
    } }, A = "en", P = {};
    P[A] = g;
    var x = "$isDayjsObject", z = function(W) {
      return W instanceof ne || !(!W || !W[x]);
    }, H = function W(S, I, B) {
      var $;
      if (!S) return A;
      if (typeof S == "string") {
        var G = S.toLowerCase();
        P[G] && ($ = G), I && (P[G] = I, $ = G);
        var V = S.split("-");
        if (!$ && V.length > 1) return W(V[0]);
      } else {
        var Z = S.name;
        P[Z] = S, $ = Z;
      }
      return !B && $ && (A = $), $ || !B && A;
    }, F = function(W, S) {
      if (z(W)) return W.clone();
      var I = typeof S == "object" ? S : {};
      return I.date = W, I.args = arguments, new ne(I);
    }, Y = f;
    Y.l = H, Y.i = z, Y.w = function(W, S) {
      return F(W, { locale: S.$L, utc: S.$u, x: S.$x, $offset: S.$offset });
    };
    var ne = function() {
      function W(I) {
        this.$L = H(I.locale, null, !0), this.parse(I), this.$x = this.$x || I.x || {}, this[x] = !0;
      }
      var S = W.prototype;
      return S.parse = function(I) {
        this.$d = function(B) {
          var $ = B.date, G = B.utc;
          if ($ === null) return /* @__PURE__ */ new Date(NaN);
          if (Y.u($)) return /* @__PURE__ */ new Date();
          if ($ instanceof Date) return new Date($);
          if (typeof $ == "string" && !/Z$/i.test($)) {
            var V = $.match(T);
            if (V) {
              var Z = V[2] - 1 || 0, de = (V[7] || "0").substring(0, 3);
              return G ? new Date(Date.UTC(V[1], Z, V[3] || 1, V[4] || 0, V[5] || 0, V[6] || 0, de)) : new Date(V[1], Z, V[3] || 1, V[4] || 0, V[5] || 0, V[6] || 0, de);
            }
          }
          return new Date($);
        }(I), this.init();
      }, S.init = function() {
        var I = this.$d;
        this.$y = I.getFullYear(), this.$M = I.getMonth(), this.$D = I.getDate(), this.$W = I.getDay(), this.$H = I.getHours(), this.$m = I.getMinutes(), this.$s = I.getSeconds(), this.$ms = I.getMilliseconds();
      }, S.$utils = function() {
        return Y;
      }, S.isValid = function() {
        return this.$d.toString() !== h;
      }, S.isSame = function(I, B) {
        var $ = F(I);
        return this.startOf(B) <= $ && $ <= this.endOf(B);
      }, S.isAfter = function(I, B) {
        return F(I) < this.startOf(B);
      }, S.isBefore = function(I, B) {
        return this.endOf(B) < F(I);
      }, S.$g = function(I, B, $) {
        return Y.u(I) ? this[B] : this.set($, I);
      }, S.unix = function() {
        return Math.floor(this.valueOf() / 1e3);
      }, S.valueOf = function() {
        return this.$d.getTime();
      }, S.startOf = function(I, B) {
        var $ = this, G = !!Y.u(B) || B, V = Y.p(I), Z = function(at, xe) {
          var Qe = Y.w($.$u ? Date.UTC($.$y, xe, at) : new Date($.$y, xe, at), $);
          return G ? Qe : Qe.endOf(p);
        }, de = function(at, xe) {
          return Y.w($.toDate()[at].apply($.toDate("s"), (G ? [0, 0, 0, 0] : [23, 59, 59, 999]).slice(xe)), $);
        }, we = this.$W, ke = this.$M, Pe = this.$D, bt = "set" + (this.$u ? "UTC" : "");
        switch (V) {
          case w:
            return G ? Z(1, 0) : Z(31, 11);
          case k:
            return G ? Z(1, ke) : Z(0, ke + 1);
          case y:
            var st = this.$locale().weekStart || 0, lt = (we < st ? we + 7 : we) - st;
            return Z(G ? Pe - lt : Pe + (6 - lt), ke);
          case p:
          case N:
            return de(bt + "Hours", 0);
          case l:
            return de(bt + "Minutes", 1);
          case i:
            return de(bt + "Seconds", 2);
          case a:
            return de(bt + "Milliseconds", 3);
          default:
            return this.clone();
        }
      }, S.endOf = function(I) {
        return this.startOf(I, !1);
      }, S.$set = function(I, B) {
        var $, G = Y.p(I), V = "set" + (this.$u ? "UTC" : ""), Z = ($ = {}, $[p] = V + "Date", $[N] = V + "Date", $[k] = V + "Month", $[w] = V + "FullYear", $[l] = V + "Hours", $[i] = V + "Minutes", $[a] = V + "Seconds", $[s] = V + "Milliseconds", $)[G], de = G === p ? this.$D + (B - this.$W) : B;
        if (G === k || G === w) {
          var we = this.clone().set(N, 1);
          we.$d[Z](de), we.init(), this.$d = we.set(N, Math.min(this.$D, we.daysInMonth())).$d;
        } else Z && this.$d[Z](de);
        return this.init(), this;
      }, S.set = function(I, B) {
        return this.clone().$set(I, B);
      }, S.get = function(I) {
        return this[Y.p(I)]();
      }, S.add = function(I, B) {
        var $, G = this;
        I = Number(I);
        var V = Y.p(B), Z = function(ke) {
          var Pe = F(G);
          return Y.w(Pe.date(Pe.date() + Math.round(ke * I)), G);
        };
        if (V === k) return this.set(k, this.$M + I);
        if (V === w) return this.set(w, this.$y + I);
        if (V === p) return Z(1);
        if (V === y) return Z(7);
        var de = ($ = {}, $[i] = o, $[l] = r, $[a] = n, $)[V] || 1, we = this.$d.getTime() + I * de;
        return Y.w(we, this);
      }, S.subtract = function(I, B) {
        return this.add(-1 * I, B);
      }, S.format = function(I) {
        var B = this, $ = this.$locale();
        if (!this.isValid()) return $.invalidDate || h;
        var G = I || "YYYY-MM-DDTHH:mm:ssZ", V = Y.z(this), Z = this.$H, de = this.$m, we = this.$M, ke = $.weekdays, Pe = $.months, bt = $.meridiem, st = function(xe, Qe, vt, ct) {
          return xe && (xe[Qe] || xe(B, G)) || vt[Qe].slice(0, ct);
        }, lt = function(xe) {
          return Y.s(Z % 12 || 12, xe, "0");
        }, at = bt || function(xe, Qe, vt) {
          var ct = xe < 12 ? "AM" : "PM";
          return vt ? ct.toLowerCase() : ct;
        };
        return G.replace(m, function(xe, Qe) {
          return Qe || function(vt) {
            switch (vt) {
              case "YY":
                return String(B.$y).slice(-2);
              case "YYYY":
                return Y.s(B.$y, 4, "0");
              case "M":
                return we + 1;
              case "MM":
                return Y.s(we + 1, 2, "0");
              case "MMM":
                return st($.monthsShort, we, Pe, 3);
              case "MMMM":
                return st(Pe, we);
              case "D":
                return B.$D;
              case "DD":
                return Y.s(B.$D, 2, "0");
              case "d":
                return String(B.$W);
              case "dd":
                return st($.weekdaysMin, B.$W, ke, 2);
              case "ddd":
                return st($.weekdaysShort, B.$W, ke, 3);
              case "dddd":
                return ke[B.$W];
              case "H":
                return String(Z);
              case "HH":
                return Y.s(Z, 2, "0");
              case "h":
                return lt(1);
              case "hh":
                return lt(2);
              case "a":
                return at(Z, de, !0);
              case "A":
                return at(Z, de, !1);
              case "m":
                return String(de);
              case "mm":
                return Y.s(de, 2, "0");
              case "s":
                return String(B.$s);
              case "ss":
                return Y.s(B.$s, 2, "0");
              case "SSS":
                return Y.s(B.$ms, 3, "0");
              case "Z":
                return V;
            }
            return null;
          }(xe) || V.replace(":", "");
        });
      }, S.utcOffset = function() {
        return 15 * -Math.round(this.$d.getTimezoneOffset() / 15);
      }, S.diff = function(I, B, $) {
        var G, V = this, Z = Y.p(B), de = F(I), we = (de.utcOffset() - this.utcOffset()) * o, ke = this - de, Pe = function() {
          return Y.m(V, de);
        };
        switch (Z) {
          case w:
            G = Pe() / 12;
            break;
          case k:
            G = Pe();
            break;
          case d:
            G = Pe() / 3;
            break;
          case y:
            G = (ke - we) / 6048e5;
            break;
          case p:
            G = (ke - we) / 864e5;
            break;
          case l:
            G = ke / r;
            break;
          case i:
            G = ke / o;
            break;
          case a:
            G = ke / n;
            break;
          default:
            G = ke;
        }
        return $ ? G : Y.a(G);
      }, S.daysInMonth = function() {
        return this.endOf(k).$D;
      }, S.$locale = function() {
        return P[this.$L];
      }, S.locale = function(I, B) {
        if (!I) return this.$L;
        var $ = this.clone(), G = H(I, B, !0);
        return G && ($.$L = G), $;
      }, S.clone = function() {
        return Y.w(this.$d, this);
      }, S.toDate = function() {
        return new Date(this.valueOf());
      }, S.toJSON = function() {
        return this.isValid() ? this.toISOString() : null;
      }, S.toISOString = function() {
        return this.$d.toISOString();
      }, S.toString = function() {
        return this.$d.toUTCString();
      }, W;
    }(), Je = ne.prototype;
    return F.prototype = Je, [["$ms", s], ["$s", a], ["$m", i], ["$H", l], ["$W", p], ["$M", k], ["$y", w], ["$D", N]].forEach(function(W) {
      Je[W[1]] = function(S) {
        return this.$g(S, W[0], W[1]);
      };
    }), F.extend = function(W, S) {
      return W.$i || (W(S, ne, F), W.$i = !0), F;
    }, F.locale = H, F.isDayjs = z, F.unix = function(W) {
      return F(1e3 * W);
    }, F.en = P[A], F.Ls = P, F.p = {}, F;
  });
})(Aa);
var sd = Aa.exports;
const La = /* @__PURE__ */ Er(sd);
var Ta = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(_r, function() {
    var n = "minute", o = /[+-]\d\d(?::?\d\d)?/g, r = /([+-]|\d\d)/g;
    return function(s, a, i) {
      var l = a.prototype;
      i.utc = function(h) {
        var T = { date: h, utc: !0, args: arguments };
        return new a(T);
      }, l.utc = function(h) {
        var T = i(this.toDate(), { locale: this.$L, utc: !0 });
        return h ? T.add(this.utcOffset(), n) : T;
      }, l.local = function() {
        return i(this.toDate(), { locale: this.$L, utc: !1 });
      };
      var p = l.parse;
      l.parse = function(h) {
        h.utc && (this.$u = !0), this.$utils().u(h.$offset) || (this.$offset = h.$offset), p.call(this, h);
      };
      var y = l.init;
      l.init = function() {
        if (this.$u) {
          var h = this.$d;
          this.$y = h.getUTCFullYear(), this.$M = h.getUTCMonth(), this.$D = h.getUTCDate(), this.$W = h.getUTCDay(), this.$H = h.getUTCHours(), this.$m = h.getUTCMinutes(), this.$s = h.getUTCSeconds(), this.$ms = h.getUTCMilliseconds();
        } else y.call(this);
      };
      var k = l.utcOffset;
      l.utcOffset = function(h, T) {
        var m = this.$utils().u;
        if (m(h)) return this.$u ? 0 : m(this.$offset) ? k.call(this) : this.$offset;
        if (typeof h == "string" && (h = function(A) {
          A === void 0 && (A = "");
          var P = A.match(o);
          if (!P) return null;
          var x = ("" + P[0]).match(r) || ["-", 0, 0], z = x[0], H = 60 * +x[1] + +x[2];
          return H === 0 ? 0 : z === "+" ? H : -H;
        }(h), h === null)) return this;
        var g = Math.abs(h) <= 16 ? 60 * h : h;
        if (g === 0) return this.utc(T);
        var C = this.clone();
        if (T) return C.$offset = g, C.$u = !1, C;
        var f = this.$u ? this.toDate().getTimezoneOffset() : -1 * this.utcOffset();
        return (C = this.local().add(g + f, n)).$offset = g, C.$x.$localOffset = f, C;
      };
      var d = l.format;
      l.format = function(h) {
        var T = h || (this.$u ? "YYYY-MM-DDTHH:mm:ss[Z]" : "");
        return d.call(this, T);
      }, l.valueOf = function() {
        var h = this.$utils().u(this.$offset) ? 0 : this.$offset + (this.$x.$localOffset || this.$d.getTimezoneOffset());
        return this.$d.valueOf() - 6e4 * h;
      }, l.isUTC = function() {
        return !!this.$u;
      }, l.toISOString = function() {
        return this.toDate().toISOString();
      }, l.toString = function() {
        return this.toDate().toUTCString();
      };
      var w = l.toDate;
      l.toDate = function(h) {
        return h === "s" && this.$offset ? i(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate() : w.call(this);
      };
      var N = l.diff;
      l.diff = function(h, T, m) {
        if (h && this.$u === h.$u) return N.call(this, h, T, m);
        var g = this.local(), C = i(h).local();
        return N.call(g, C, T, m);
      };
    };
  });
})(Ta);
var ad = Ta.exports;
const id = /* @__PURE__ */ Er(ad);
var Na = { exports: {} };
(function(e, t) {
  (function(n, o) {
    e.exports = o();
  })(_r, function() {
    var n = { year: 0, month: 1, day: 2, hour: 3, minute: 4, second: 5 }, o = {};
    return function(r, s, a) {
      var i, l = function(d, w, N) {
        N === void 0 && (N = {});
        var h = new Date(d), T = function(m, g) {
          g === void 0 && (g = {});
          var C = g.timeZoneName || "short", f = m + "|" + C, A = o[f];
          return A || (A = new Intl.DateTimeFormat("en-US", { hour12: !1, timeZone: m, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", second: "2-digit", timeZoneName: C }), o[f] = A), A;
        }(w, N);
        return T.formatToParts(h);
      }, p = function(d, w) {
        for (var N = l(d, w), h = [], T = 0; T < N.length; T += 1) {
          var m = N[T], g = m.type, C = m.value, f = n[g];
          f >= 0 && (h[f] = parseInt(C, 10));
        }
        var A = h[3], P = A === 24 ? 0 : A, x = h[0] + "-" + h[1] + "-" + h[2] + " " + P + ":" + h[4] + ":" + h[5] + ":000", z = +d;
        return (a.utc(x).valueOf() - (z -= z % 1e3)) / 6e4;
      }, y = s.prototype;
      y.tz = function(d, w) {
        d === void 0 && (d = i);
        var N, h = this.utcOffset(), T = this.toDate(), m = T.toLocaleString("en-US", { timeZone: d }), g = Math.round((T - new Date(m)) / 1e3 / 60), C = 15 * -Math.round(T.getTimezoneOffset() / 15) - g;
        if (!Number(C)) N = this.utcOffset(0, w);
        else if (N = a(m, { locale: this.$L }).$set("millisecond", this.$ms).utcOffset(C, !0), w) {
          var f = N.utcOffset();
          N = N.add(h - f, "minute");
        }
        return N.$x.$timezone = d, N;
      }, y.offsetName = function(d) {
        var w = this.$x.$timezone || a.tz.guess(), N = l(this.valueOf(), w, { timeZoneName: d }).find(function(h) {
          return h.type.toLowerCase() === "timezonename";
        });
        return N && N.value;
      };
      var k = y.startOf;
      y.startOf = function(d, w) {
        if (!this.$x || !this.$x.$timezone) return k.call(this, d, w);
        var N = a(this.format("YYYY-MM-DD HH:mm:ss:SSS"), { locale: this.$L });
        return k.call(N, d, w).tz(this.$x.$timezone, !0);
      }, a.tz = function(d, w, N) {
        var h = N && w, T = N || w || i, m = p(+a(), T);
        if (typeof d != "string") return a(d).tz(T);
        var g = function(P, x, z) {
          var H = P - 60 * x * 1e3, F = p(H, z);
          if (x === F) return [H, x];
          var Y = p(H -= 60 * (F - x) * 1e3, z);
          return F === Y ? [H, F] : [P - 60 * Math.min(F, Y) * 1e3, Math.max(F, Y)];
        }(a.utc(d, h).valueOf(), m, T), C = g[0], f = g[1], A = a(C).utcOffset(f);
        return A.$x.$timezone = T, A;
      }, a.tz.guess = function() {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
      }, a.tz.setDefault = function(d) {
        i = d;
      };
    };
  });
})(Na);
var ld = Na.exports;
const cd = /* @__PURE__ */ Er(ld);
La.extend(id);
La.extend(cd);
/*!
* sweetalert2 v11.26.17
* Released under the MIT License.
*/
function Oa(e, t, n) {
  if (typeof e == "function" ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
  throw new TypeError("Private element is not present on this object");
}
function ud(e, t) {
  if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function Ts(e, t) {
  return e.get(Oa(e, t));
}
function dd(e, t, n) {
  ud(e, t), t.set(e, n);
}
function md(e, t, n) {
  return e.set(Oa(e, t), n), n;
}
const fd = 100, R = {}, wd = () => {
  R.previousActiveElement instanceof HTMLElement ? (R.previousActiveElement.focus(), R.previousActiveElement = null) : document.body && document.body.focus();
}, pd = (e) => new Promise((t) => {
  if (!e)
    return t();
  const n = window.scrollX, o = window.scrollY;
  R.restoreFocusTimeout = setTimeout(() => {
    wd(), t();
  }, fd), window.scrollTo(n, o);
}), Pa = "swal2-", hd = ["container", "shown", "height-auto", "iosfix", "popup", "modal", "no-backdrop", "no-transition", "toast", "toast-shown", "show", "hide", "close", "title", "html-container", "actions", "confirm", "deny", "cancel", "footer", "icon", "icon-content", "image", "input", "file", "range", "select", "radio", "checkbox", "label", "textarea", "inputerror", "input-label", "validation-message", "progress-steps", "active-progress-step", "progress-step", "progress-step-line", "loader", "loading", "styled", "top", "top-start", "top-end", "top-left", "top-right", "center", "center-start", "center-end", "center-left", "center-right", "bottom", "bottom-start", "bottom-end", "bottom-left", "bottom-right", "grow-row", "grow-column", "grow-fullscreen", "rtl", "timer-progress-bar", "timer-progress-bar-container", "scrollbar-measure", "icon-success", "icon-warning", "icon-info", "icon-question", "icon-error", "draggable", "dragging"], b = hd.reduce(
  (e, t) => (e[t] = Pa + t, e),
  /** @type {SwalClasses} */
  {}
), gd = ["success", "warning", "info", "question", "error"], Zn = gd.reduce(
  (e, t) => (e[t] = Pa + t, e),
  /** @type {SwalIcons} */
  {}
), Ia = "SweetAlert2:", kr = (e) => e.charAt(0).toUpperCase() + e.slice(1), Me = (e) => {
  console.warn(`${Ia} ${typeof e == "object" ? e.join(" ") : e}`);
}, Gt = (e) => {
  console.error(`${Ia} ${e}`);
}, Ns = [], bd = (e) => {
  Ns.includes(e) || (Ns.push(e), Me(e));
}, $a = (e, t = null) => {
  bd(`"${e}" is deprecated and will be removed in the next major release.${t ? ` Use "${t}" instead.` : ""}`);
}, yo = (e) => typeof e == "function" ? e() : e, xr = (e) => e && typeof e.toPromise == "function", On = (e) => xr(e) ? e.toPromise() : Promise.resolve(e), Cr = (e) => e && Promise.resolve(e) === e, Be = () => document.body.querySelector(`.${b.container}`), Pn = (e) => {
  const t = Be();
  return t ? t.querySelector(e) : null;
}, Ke = (e) => Pn(`.${e}`), ae = () => Ke(b.popup), wn = () => Ke(b.icon), vd = () => Ke(b["icon-content"]), Sa = () => Ke(b.title), Ar = () => Ke(b["html-container"]), Da = () => Ke(b.image), Lr = () => Ke(b["progress-steps"]), _o = () => Ke(b["validation-message"]), ht = () => (
  /** @type {HTMLButtonElement} */
  Pn(`.${b.actions} .${b.confirm}`)
), pn = () => (
  /** @type {HTMLButtonElement} */
  Pn(`.${b.actions} .${b.cancel}`)
), Xt = () => (
  /** @type {HTMLButtonElement} */
  Pn(`.${b.actions} .${b.deny}`)
), yd = () => Ke(b["input-label"]), hn = () => Pn(`.${b.loader}`), In = () => Ke(b.actions), Ma = () => Ke(b.footer), Eo = () => Ke(b["timer-progress-bar"]), Tr = () => Ke(b.close), _d = `
  a[href],
  area[href],
  input:not([disabled]),
  select:not([disabled]),
  textarea:not([disabled]),
  button:not([disabled]),
  iframe,
  object,
  embed,
  [tabindex="0"],
  [contenteditable],
  audio[controls],
  video[controls],
  summary
`, Nr = () => {
  const e = ae();
  if (!e)
    return [];
  const t = e.querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])'), n = Array.from(t).sort((s, a) => {
    const i = parseInt(s.getAttribute("tabindex") || "0"), l = parseInt(a.getAttribute("tabindex") || "0");
    return i > l ? 1 : i < l ? -1 : 0;
  }), o = e.querySelectorAll(_d), r = Array.from(o).filter((s) => s.getAttribute("tabindex") !== "-1");
  return [...new Set(n.concat(r))].filter((s) => He(s));
}, Or = () => kt(document.body, b.shown) && !kt(document.body, b["toast-shown"]) && !kt(document.body, b["no-backdrop"]), ko = () => {
  const e = ae();
  return e ? kt(e, b.toast) : !1;
}, Ed = () => {
  const e = ae();
  return e ? e.hasAttribute("data-loading") : !1;
}, Ge = (e, t) => {
  if (e.textContent = "", t) {
    const n = new DOMParser().parseFromString(t, "text/html"), o = n.querySelector("head");
    o && Array.from(o.childNodes).forEach((s) => {
      e.appendChild(s);
    });
    const r = n.querySelector("body");
    r && Array.from(r.childNodes).forEach((s) => {
      s instanceof HTMLVideoElement || s instanceof HTMLAudioElement ? e.appendChild(s.cloneNode(!0)) : e.appendChild(s);
    });
  }
}, kt = (e, t) => {
  if (!t)
    return !1;
  const n = t.split(/\s+/);
  for (let o = 0; o < n.length; o++)
    if (!e.classList.contains(n[o]))
      return !1;
  return !0;
}, kd = (e, t) => {
  Array.from(e.classList).forEach((n) => {
    !Object.values(b).includes(n) && !Object.values(Zn).includes(n) && !Object.values(t.showClass || {}).includes(n) && e.classList.remove(n);
  });
}, qe = (e, t, n) => {
  if (kd(e, t), !t.customClass)
    return;
  const o = t.customClass[
    /** @type {keyof SweetAlertCustomClass} */
    n
  ];
  if (o) {
    if (typeof o != "string" && !o.forEach) {
      Me(`Invalid type of customClass.${n}! Expected string or iterable object, got "${typeof o}"`);
      return;
    }
    oe(e, o);
  }
}, xo = (e, t) => {
  if (!t)
    return null;
  switch (t) {
    case "select":
    case "textarea":
    case "file":
      return e.querySelector(`.${b.popup} > .${b[t]}`);
    case "checkbox":
      return e.querySelector(`.${b.popup} > .${b.checkbox} input`);
    case "radio":
      return e.querySelector(`.${b.popup} > .${b.radio} input:checked`) || e.querySelector(`.${b.popup} > .${b.radio} input:first-child`);
    case "range":
      return e.querySelector(`.${b.popup} > .${b.range} input`);
    default:
      return e.querySelector(`.${b.popup} > .${b.input}`);
  }
}, Ra = (e) => {
  if (e.focus(), e.type !== "file") {
    const t = e.value;
    e.value = "", e.value = t;
  }
}, Ba = (e, t, n) => {
  !e || !t || (typeof t == "string" && (t = t.split(/\s+/).filter(Boolean)), t.forEach((o) => {
    Array.isArray(e) ? e.forEach((r) => {
      n ? r.classList.add(o) : r.classList.remove(o);
    }) : n ? e.classList.add(o) : e.classList.remove(o);
  }));
}, oe = (e, t) => {
  Ba(e, t, !0);
}, ot = (e, t) => {
  Ba(e, t, !1);
}, Tt = (e, t) => {
  const n = Array.from(e.children);
  for (let o = 0; o < n.length; o++) {
    const r = n[o];
    if (r instanceof HTMLElement && kt(r, t))
      return r;
  }
}, Yt = (e, t, n) => {
  n === `${parseInt(`${n}`)}` && (n = parseInt(n)), n || parseInt(`${n}`) === 0 ? e.style.setProperty(t, typeof n == "number" ? `${n}px` : (
    /** @type {string} */
    n
  )) : e.style.removeProperty(t);
}, Te = (e, t = "flex") => {
  e && (e.style.display = t);
}, Se = (e) => {
  e && (e.style.display = "none");
}, Pr = (e, t = "block") => {
  e && new MutationObserver(() => {
    $n(e, e.innerHTML, t);
  }).observe(e, {
    childList: !0,
    subtree: !0
  });
}, Os = (e, t, n, o) => {
  const r = e.querySelector(t);
  r && r.style.setProperty(n, o);
}, $n = (e, t, n = "flex") => {
  t ? Te(e, n) : Se(e);
}, He = (e) => !!(e && (e.offsetWidth || e.offsetHeight || e.getClientRects().length)), xd = () => !He(ht()) && !He(Xt()) && !He(pn()), rr = (e) => e.scrollHeight > e.clientHeight, Cd = (e, t) => {
  let n = (
    /** @type {HTMLElement | null} */
    e
  );
  for (; n && n !== t; ) {
    if (rr(n))
      return !0;
    n = n.parentElement;
  }
  return !1;
}, Fa = (e) => {
  const t = window.getComputedStyle(e), n = parseFloat(t.getPropertyValue("animation-duration") || "0"), o = parseFloat(t.getPropertyValue("transition-duration") || "0");
  return n > 0 || o > 0;
}, Ir = (e, t = !1) => {
  const n = Eo();
  n && He(n) && (t && (n.style.transition = "none", n.style.width = "100%"), setTimeout(() => {
    n.style.transition = `width ${e / 1e3}s linear`, n.style.width = "0%";
  }, 10));
}, Ad = () => {
  const e = Eo();
  if (!e)
    return;
  const t = parseInt(window.getComputedStyle(e).width);
  e.style.removeProperty("transition"), e.style.width = "100%";
  const n = parseInt(window.getComputedStyle(e).width), o = t / n * 100;
  e.style.width = `${o}%`;
}, Ld = () => typeof window > "u" || typeof document > "u", Td = `
 <div aria-labelledby="${b.title}" aria-describedby="${b["html-container"]}" class="${b.popup}" tabindex="-1">
   <button type="button" class="${b.close}"></button>
   <ul class="${b["progress-steps"]}"></ul>
   <div class="${b.icon}"></div>
   <img class="${b.image}" />
   <h2 class="${b.title}" id="${b.title}"></h2>
   <div class="${b["html-container"]}" id="${b["html-container"]}"></div>
   <input class="${b.input}" id="${b.input}" />
   <input type="file" class="${b.file}" />
   <div class="${b.range}">
     <input type="range" />
     <output></output>
   </div>
   <select class="${b.select}" id="${b.select}"></select>
   <div class="${b.radio}"></div>
   <label class="${b.checkbox}">
     <input type="checkbox" id="${b.checkbox}" />
     <span class="${b.label}"></span>
   </label>
   <textarea class="${b.textarea}" id="${b.textarea}"></textarea>
   <div class="${b["validation-message"]}" id="${b["validation-message"]}"></div>
   <div class="${b.actions}">
     <div class="${b.loader}"></div>
     <button type="button" class="${b.confirm}"></button>
     <button type="button" class="${b.deny}"></button>
     <button type="button" class="${b.cancel}"></button>
   </div>
   <div class="${b.footer}"></div>
   <div class="${b["timer-progress-bar-container"]}">
     <div class="${b["timer-progress-bar"]}"></div>
   </div>
 </div>
`.replace(/(^|\n)\s*/g, ""), Nd = () => {
  const e = Be();
  return e ? (e.remove(), ot([document.documentElement, document.body], [
    b["no-backdrop"],
    b["toast-shown"],
    // @ts-ignore: 'has-column' is not defined in swalClasses but may be set dynamically
    b["has-column"]
  ]), !0) : !1;
}, Ut = () => {
  R.currentInstance && R.currentInstance.resetValidationMessage();
}, Od = () => {
  const e = ae();
  if (!e)
    return;
  const t = Tt(e, b.input), n = Tt(e, b.file), o = e.querySelector(`.${b.range} input`), r = e.querySelector(`.${b.range} output`), s = Tt(e, b.select), a = e.querySelector(`.${b.checkbox} input`), i = Tt(e, b.textarea);
  t && (t.oninput = Ut), n && (n.onchange = Ut), s && (s.onchange = Ut), a && (a.onchange = Ut), i && (i.oninput = Ut), o && r && (o.oninput = () => {
    Ut(), r.value = o.value;
  }, o.onchange = () => {
    Ut(), r.value = o.value;
  });
}, Pd = (e) => {
  if (typeof e == "string") {
    const t = document.querySelector(e);
    if (!t)
      throw new Error(`Target element "${e}" not found`);
    return (
      /** @type {HTMLElement} */
      t
    );
  }
  return e;
}, Id = (e) => {
  const t = ae();
  t && (t.setAttribute("role", e.toast ? "alert" : "dialog"), t.setAttribute("aria-live", e.toast ? "polite" : "assertive"), e.toast || t.setAttribute("aria-modal", "true"));
}, $d = (e) => {
  window.getComputedStyle(e).direction === "rtl" && (oe(Be(), b.rtl), R.isRTL = !0);
}, Sd = (e) => {
  const t = Nd();
  if (Ld()) {
    Gt("SweetAlert2 requires document to initialize");
    return;
  }
  const n = document.createElement("div");
  n.className = b.container, t && oe(n, b["no-transition"]), Ge(n, Td), n.dataset.swal2Theme = e.theme;
  const o = Pd(e.target || "body");
  o.appendChild(n), e.topLayer && (n.setAttribute("popover", ""), n.showPopover()), Id(e), $d(o), Od();
}, $r = (e, t) => {
  e instanceof HTMLElement ? t.appendChild(e) : typeof e == "object" ? Dd(e, t) : e && Ge(t, e);
}, Dd = (e, t) => {
  "jquery" in e ? Md(t, e) : Ge(t, e.toString());
}, Md = (e, t) => {
  if (e.textContent = "", 0 in t)
    for (let n = 0; n in t; n++)
      e.appendChild(t[n].cloneNode(!0));
  else
    e.appendChild(t.cloneNode(!0));
}, Rd = (e, t) => {
  const n = In(), o = hn();
  !n || !o || (!t.showConfirmButton && !t.showDenyButton && !t.showCancelButton ? Se(n) : Te(n), qe(n, t, "actions"), Bd(n, o, t), Ge(o, t.loaderHtml || ""), qe(o, t, "loader"));
};
function Bd(e, t, n) {
  const o = ht(), r = Xt(), s = pn();
  !o || !r || !s || (Fo(o, "confirm", n), Fo(r, "deny", n), Fo(s, "cancel", n), Fd(o, r, s, n), n.reverseButtons && (n.toast ? (e.insertBefore(s, o), e.insertBefore(r, o)) : (e.insertBefore(s, t), e.insertBefore(r, t), e.insertBefore(o, t))));
}
function Fd(e, t, n, o) {
  if (!o.buttonsStyling) {
    ot([e, t, n], b.styled);
    return;
  }
  oe([e, t, n], b.styled), o.confirmButtonColor && e.style.setProperty("--swal2-confirm-button-background-color", o.confirmButtonColor), o.denyButtonColor && t.style.setProperty("--swal2-deny-button-background-color", o.denyButtonColor), o.cancelButtonColor && n.style.setProperty("--swal2-cancel-button-background-color", o.cancelButtonColor), Bo(e), Bo(t), Bo(n);
}
function Bo(e) {
  const t = window.getComputedStyle(e);
  if (t.getPropertyValue("--swal2-action-button-focus-box-shadow"))
    return;
  const n = t.backgroundColor.replace(/rgba?\((\d+), (\d+), (\d+).*/, "rgba($1, $2, $3, 0.5)");
  e.style.setProperty("--swal2-action-button-focus-box-shadow", t.getPropertyValue("--swal2-outline").replace(/ rgba\(.*/, ` ${n}`));
}
function Fo(e, t, n) {
  const o = (
    /** @type {'Confirm' | 'Deny' | 'Cancel'} */
    kr(t)
  );
  $n(e, n[`show${o}Button`], "inline-block"), Ge(e, n[`${t}ButtonText`] || ""), e.setAttribute("aria-label", n[`${t}ButtonAriaLabel`] || ""), e.className = b[t], qe(e, n, `${t}Button`);
}
const Ud = (e, t) => {
  const n = Tr();
  n && (Ge(n, t.closeButtonHtml || ""), qe(n, t, "closeButton"), $n(n, t.showCloseButton), n.setAttribute("aria-label", t.closeButtonAriaLabel || ""));
}, Vd = (e, t) => {
  const n = Be();
  n && (Hd(n, t.backdrop), jd(n, t.position), Yd(n, t.grow), qe(n, t, "container"));
};
function Hd(e, t) {
  typeof t == "string" ? e.style.background = t : t || oe([document.documentElement, document.body], b["no-backdrop"]);
}
function jd(e, t) {
  t && (t in b ? oe(e, b[t]) : (Me('The "position" parameter is not valid, defaulting to "center"'), oe(e, b.center)));
}
function Yd(e, t) {
  t && oe(e, b[`grow-${t}`]);
}
var ce = {
  innerParams: /* @__PURE__ */ new WeakMap(),
  domCache: /* @__PURE__ */ new WeakMap()
};
const Wd = ["input", "file", "range", "select", "radio", "checkbox", "textarea"], qd = (e, t) => {
  const n = ae();
  if (!n)
    return;
  const o = ce.innerParams.get(e), r = !o || t.input !== o.input;
  Wd.forEach((s) => {
    const a = Tt(n, b[s]);
    a && (Gd(s, t.inputAttributes), a.className = b[s], r && Se(a));
  }), t.input && (r && zd(t), Xd(t));
}, zd = (e) => {
  if (!e.input)
    return;
  if (!ge[e.input]) {
    Gt(`Unexpected type of input! Expected ${Object.keys(ge).join(" | ")}, got "${e.input}"`);
    return;
  }
  const t = Ua(e.input);
  if (!t)
    return;
  const n = ge[e.input](t, e);
  Te(t), e.inputAutoFocus && setTimeout(() => {
    Ra(n);
  });
}, Kd = (e) => {
  for (let t = 0; t < e.attributes.length; t++) {
    const n = e.attributes[t].name;
    ["id", "type", "value", "style"].includes(n) || e.removeAttribute(n);
  }
}, Gd = (e, t) => {
  const n = ae();
  if (!n)
    return;
  const o = xo(n, e);
  if (o) {
    Kd(o);
    for (const r in t)
      o.setAttribute(r, t[r]);
  }
}, Xd = (e) => {
  if (!e.input)
    return;
  const t = Ua(e.input);
  t && qe(t, e, "input");
}, Sr = (e, t) => {
  !e.placeholder && t.inputPlaceholder && (e.placeholder = t.inputPlaceholder);
}, Sn = (e, t, n) => {
  if (n.inputLabel) {
    const o = document.createElement("label"), r = b["input-label"];
    o.setAttribute("for", e.id), o.className = r, typeof n.customClass == "object" && oe(o, n.customClass.inputLabel), o.innerText = n.inputLabel, t.insertAdjacentElement("beforebegin", o);
  }
}, Ua = (e) => {
  const t = ae();
  if (t)
    return Tt(t, b[
      /** @type {SwalClass} */
      e
    ] || b.input);
}, Jn = (e, t) => {
  ["string", "number"].includes(typeof t) ? e.value = `${t}` : Cr(t) || Me(`Unexpected type of inputValue! Expected "string", "number" or "Promise", got "${typeof t}"`);
}, ge = {};
ge.text = ge.email = ge.password = ge.number = ge.tel = ge.url = ge.search = ge.date = ge["datetime-local"] = ge.time = ge.week = ge.month = /** @type {(input: Input | HTMLElement, params: SweetAlertOptions) => Input} */
(e, t) => {
  const n = (
    /** @type {HTMLInputElement} */
    e
  );
  return Jn(n, t.inputValue), Sn(n, n, t), Sr(n, t), n.type = /** @type {string} */
  t.input, n;
};
ge.file = (e, t) => {
  const n = (
    /** @type {HTMLInputElement} */
    e
  );
  return Sn(n, n, t), Sr(n, t), n;
};
ge.range = (e, t) => {
  const n = (
    /** @type {HTMLElement} */
    e
  ), o = n.querySelector("input"), r = n.querySelector("output");
  return o && (Jn(o, t.inputValue), o.type = /** @type {string} */
  t.input, Sn(
    o,
    /** @type {Input} */
    e,
    t
  )), r && Jn(r, t.inputValue), /** @type {Input} */
  e;
};
ge.select = (e, t) => {
  const n = (
    /** @type {HTMLSelectElement} */
    e
  );
  if (n.textContent = "", t.inputPlaceholder) {
    const o = document.createElement("option");
    Ge(o, t.inputPlaceholder), o.value = "", o.disabled = !0, o.selected = !0, n.appendChild(o);
  }
  return Sn(n, n, t), n;
};
ge.radio = (e) => {
  const t = (
    /** @type {HTMLElement} */
    e
  );
  return t.textContent = "", /** @type {Input} */
  e;
};
ge.checkbox = (e, t) => {
  const n = ae();
  if (!n)
    throw new Error("Popup not found");
  const o = xo(n, "checkbox");
  if (!o)
    throw new Error("Checkbox input not found");
  o.value = "1", o.checked = !!t.inputValue;
  const r = (
    /** @type {HTMLElement} */
    e.querySelector("span")
  );
  if (r) {
    const s = t.inputPlaceholder || t.inputLabel;
    s && Ge(r, s);
  }
  return o;
};
ge.textarea = (e, t) => {
  const n = (
    /** @type {HTMLTextAreaElement} */
    e
  );
  Jn(n, t.inputValue), Sr(n, t), Sn(n, n, t);
  const o = (r) => parseInt(window.getComputedStyle(r).marginLeft) + parseInt(window.getComputedStyle(r).marginRight);
  return setTimeout(() => {
    if ("MutationObserver" in window) {
      const r = ae();
      if (!r)
        return;
      const s = parseInt(window.getComputedStyle(r).width), a = () => {
        if (!document.body.contains(n))
          return;
        const i = n.offsetWidth + o(n), l = ae();
        l && (i > s ? l.style.width = `${i}px` : Yt(l, "width", t.width));
      };
      new MutationObserver(a).observe(n, {
        attributes: !0,
        attributeFilter: ["style"]
      });
    }
  }), n;
};
const Zd = (e, t) => {
  const n = Ar();
  n && (Pr(n), qe(n, t, "htmlContainer"), t.html ? ($r(t.html, n), Te(n, "block")) : t.text ? (n.textContent = t.text, Te(n, "block")) : Se(n), qd(e, t));
}, Jd = (e, t) => {
  const n = Ma();
  n && (Pr(n), $n(n, !!t.footer, "block"), t.footer && $r(t.footer, n), qe(n, t, "footer"));
}, Qd = (e, t) => {
  const n = ce.innerParams.get(e), o = wn();
  if (o) {
    if (n && t.icon === n.icon) {
      Is(o, t), Ps(o, t);
      return;
    }
    if (!t.icon && !t.iconHtml) {
      Se(o);
      return;
    }
    if (t.icon && Object.keys(Zn).indexOf(t.icon) === -1) {
      Gt(`Unknown icon! Expected "success", "error", "warning", "info" or "question", got "${t.icon}"`), Se(o);
      return;
    }
    Te(o), Is(o, t), Ps(o, t), oe(o, t.showClass && t.showClass.icon), window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", Va);
  }
}, Ps = (e, t) => {
  for (const [n, o] of Object.entries(Zn))
    t.icon !== n && ot(e, o);
  oe(e, t.icon && Zn[t.icon]), nm(e, t), Va(), qe(e, t, "icon");
}, Va = () => {
  const e = ae();
  if (!e)
    return;
  const t = window.getComputedStyle(e).getPropertyValue("background-color"), n = e.querySelectorAll("[class^=swal2-success-circular-line], .swal2-success-fix");
  for (let o = 0; o < n.length; o++)
    n[o].style.backgroundColor = t;
}, em = (e) => `
  ${e.animation ? '<div class="swal2-success-circular-line-left"></div>' : ""}
  <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>
  <div class="swal2-success-ring"></div>
  ${e.animation ? '<div class="swal2-success-fix"></div>' : ""}
  ${e.animation ? '<div class="swal2-success-circular-line-right"></div>' : ""}
`, tm = `
  <span class="swal2-x-mark">
    <span class="swal2-x-mark-line-left"></span>
    <span class="swal2-x-mark-line-right"></span>
  </span>
`, Is = (e, t) => {
  if (!t.icon && !t.iconHtml)
    return;
  let n = e.innerHTML, o = "";
  t.iconHtml ? o = $s(t.iconHtml) : t.icon === "success" ? (o = em(t), n = n.replace(/ style=".*?"/g, "")) : t.icon === "error" ? o = tm : t.icon && (o = $s({
    question: "?",
    warning: "!",
    info: "i"
  }[t.icon])), n.trim() !== o.trim() && Ge(e, o);
}, nm = (e, t) => {
  if (t.iconColor) {
    e.style.color = t.iconColor, e.style.borderColor = t.iconColor;
    for (const n of [".swal2-success-line-tip", ".swal2-success-line-long", ".swal2-x-mark-line-left", ".swal2-x-mark-line-right"])
      Os(e, n, "background-color", t.iconColor);
    Os(e, ".swal2-success-ring", "border-color", t.iconColor);
  }
}, $s = (e) => `<div class="${b["icon-content"]}">${e}</div>`, om = (e, t) => {
  const n = Da();
  if (n) {
    if (!t.imageUrl) {
      Se(n);
      return;
    }
    Te(n, ""), n.setAttribute("src", t.imageUrl), n.setAttribute("alt", t.imageAlt || ""), Yt(n, "width", t.imageWidth), Yt(n, "height", t.imageHeight), n.className = b.image, qe(n, t, "image");
  }
};
let Dr = !1, Ha = 0, ja = 0, Ya = 0, Wa = 0;
const rm = (e) => {
  e.addEventListener("mousedown", Qn), document.body.addEventListener("mousemove", eo), e.addEventListener("mouseup", to), e.addEventListener("touchstart", Qn), document.body.addEventListener("touchmove", eo), e.addEventListener("touchend", to);
}, sm = (e) => {
  e.removeEventListener("mousedown", Qn), document.body.removeEventListener("mousemove", eo), e.removeEventListener("mouseup", to), e.removeEventListener("touchstart", Qn), document.body.removeEventListener("touchmove", eo), e.removeEventListener("touchend", to);
}, Qn = (e) => {
  const t = ae();
  if (!t)
    return;
  const n = wn();
  if (e.target === t || n && n.contains(
    /** @type {HTMLElement} */
    e.target
  )) {
    Dr = !0;
    const o = qa(e);
    Ha = o.clientX, ja = o.clientY, Ya = parseInt(t.style.insetInlineStart) || 0, Wa = parseInt(t.style.insetBlockStart) || 0, oe(t, "swal2-dragging");
  }
}, eo = (e) => {
  const t = ae();
  if (t && Dr) {
    let {
      clientX: n,
      clientY: o
    } = qa(e);
    const r = n - Ha;
    t.style.insetInlineStart = `${Ya + (R.isRTL ? -r : r)}px`, t.style.insetBlockStart = `${Wa + (o - ja)}px`;
  }
}, to = () => {
  const e = ae();
  Dr = !1, ot(e, "swal2-dragging");
}, qa = (e) => {
  let t = 0, n = 0;
  return e.type.startsWith("mouse") ? (t = /** @type {MouseEvent} */
  e.clientX, n = /** @type {MouseEvent} */
  e.clientY) : e.type.startsWith("touch") && (t = /** @type {TouchEvent} */
  e.touches[0].clientX, n = /** @type {TouchEvent} */
  e.touches[0].clientY), {
    clientX: t,
    clientY: n
  };
}, am = (e, t) => {
  const n = Be(), o = ae();
  if (!(!n || !o)) {
    if (t.toast) {
      Yt(n, "width", t.width), o.style.width = "100%";
      const r = hn();
      r && o.insertBefore(r, wn());
    } else
      Yt(o, "width", t.width);
    Yt(o, "padding", t.padding), t.color && (o.style.color = t.color), t.background && (o.style.background = t.background), Se(_o()), im(o, t), t.draggable && !t.toast ? (oe(o, b.draggable), rm(o)) : (ot(o, b.draggable), sm(o));
  }
}, im = (e, t) => {
  const n = t.showClass || {};
  e.className = `${b.popup} ${He(e) ? n.popup : ""}`, t.toast ? (oe([document.documentElement, document.body], b["toast-shown"]), oe(e, b.toast)) : oe(e, b.modal), qe(e, t, "popup"), typeof t.customClass == "string" && oe(e, t.customClass), t.icon && oe(e, b[`icon-${t.icon}`]);
}, lm = (e, t) => {
  const n = Lr();
  if (!n)
    return;
  const {
    progressSteps: o,
    currentProgressStep: r
  } = t;
  if (!o || o.length === 0 || r === void 0) {
    Se(n);
    return;
  }
  Te(n), n.textContent = "", r >= o.length && Me("Invalid currentProgressStep parameter, it should be less than progressSteps.length (currentProgressStep like JS arrays starts from 0)"), o.forEach((s, a) => {
    const i = cm(s);
    if (n.appendChild(i), a === r && oe(i, b["active-progress-step"]), a !== o.length - 1) {
      const l = um(t);
      n.appendChild(l);
    }
  });
}, cm = (e) => {
  const t = document.createElement("li");
  return oe(t, b["progress-step"]), Ge(t, e), t;
}, um = (e) => {
  const t = document.createElement("li");
  return oe(t, b["progress-step-line"]), e.progressStepsDistance && Yt(t, "width", e.progressStepsDistance), t;
}, dm = (e, t) => {
  const n = Sa();
  n && (Pr(n), $n(n, !!(t.title || t.titleText), "block"), t.title && $r(t.title, n), t.titleText && (n.innerText = t.titleText), qe(n, t, "title"));
}, za = (e, t) => {
  var n;
  am(e, t), Vd(e, t), lm(e, t), Qd(e, t), om(e, t), dm(e, t), Ud(e, t), Zd(e, t), Rd(e, t), Jd(e, t);
  const o = ae();
  typeof t.didRender == "function" && o && t.didRender(o), (n = R.eventEmitter) === null || n === void 0 || n.emit("didRender", o);
}, mm = () => He(ae()), Ka = () => {
  var e;
  return (e = ht()) === null || e === void 0 ? void 0 : e.click();
}, fm = () => {
  var e;
  return (e = Xt()) === null || e === void 0 ? void 0 : e.click();
}, wm = () => {
  var e;
  return (e = pn()) === null || e === void 0 ? void 0 : e.click();
}, gn = Object.freeze({
  cancel: "cancel",
  backdrop: "backdrop",
  close: "close",
  esc: "esc",
  timer: "timer"
}), Ga = (e) => {
  if (e.keydownTarget && e.keydownHandlerAdded && e.keydownHandler) {
    const t = (
      /** @type {EventListenerOrEventListenerObject} */
      /** @type {unknown} */
      e.keydownHandler
    );
    e.keydownTarget.removeEventListener("keydown", t, {
      capture: e.keydownListenerCapture
    }), e.keydownHandlerAdded = !1;
  }
}, pm = (e, t, n) => {
  if (Ga(e), !t.toast) {
    const o = (s) => gm(t, s, n);
    e.keydownHandler = o;
    const r = t.keydownListenerCapture ? window : ae();
    if (r) {
      e.keydownTarget = r, e.keydownListenerCapture = t.keydownListenerCapture;
      const s = (
        /** @type {EventListenerOrEventListenerObject} */
        /** @type {unknown} */
        o
      );
      e.keydownTarget.addEventListener("keydown", s, {
        capture: e.keydownListenerCapture
      }), e.keydownHandlerAdded = !0;
    }
  }
}, sr = (e, t) => {
  var n;
  const o = Nr();
  if (o.length) {
    e = e + t, e === -2 && (e = o.length - 1), e === o.length ? e = 0 : e === -1 && (e = o.length - 1), o[e].focus();
    return;
  }
  (n = ae()) === null || n === void 0 || n.focus();
}, Xa = ["ArrowRight", "ArrowDown"], hm = ["ArrowLeft", "ArrowUp"], gm = (e, t, n) => {
  e && (t.isComposing || t.keyCode === 229 || (e.stopKeydownPropagation && t.stopPropagation(), t.key === "Enter" ? bm(t, e) : t.key === "Tab" ? vm(t) : [...Xa, ...hm].includes(t.key) ? ym(t.key) : t.key === "Escape" && _m(t, e, n)));
}, bm = (e, t) => {
  if (!yo(t.allowEnterKey))
    return;
  const n = ae();
  if (!n || !t.input)
    return;
  const o = xo(n, t.input);
  if (e.target && o && e.target instanceof HTMLElement && e.target.outerHTML === o.outerHTML) {
    if (["textarea", "file"].includes(t.input))
      return;
    Ka(), e.preventDefault();
  }
}, vm = (e) => {
  const t = e.target, n = Nr();
  let o = -1;
  for (let r = 0; r < n.length; r++)
    if (t === n[r]) {
      o = r;
      break;
    }
  e.shiftKey ? sr(o, -1) : sr(o, 1), e.stopPropagation(), e.preventDefault();
}, ym = (e) => {
  const t = In(), n = ht(), o = Xt(), r = pn();
  if (!t || !n || !o || !r)
    return;
  const s = [n, o, r];
  if (document.activeElement instanceof HTMLElement && !s.includes(document.activeElement))
    return;
  const a = Xa.includes(e) ? "nextElementSibling" : "previousElementSibling";
  let i = document.activeElement;
  if (i) {
    for (let l = 0; l < t.children.length; l++) {
      if (i = i[a], !i)
        return;
      if (i instanceof HTMLButtonElement && He(i))
        break;
    }
    i instanceof HTMLButtonElement && i.focus();
  }
}, _m = (e, t, n) => {
  e.preventDefault(), yo(t.allowEscapeKey) && n(gn.esc);
};
var ln = {
  swalPromiseResolve: /* @__PURE__ */ new WeakMap(),
  swalPromiseReject: /* @__PURE__ */ new WeakMap()
};
const Em = () => {
  const e = Be();
  Array.from(document.body.children).forEach((t) => {
    t.contains(e) || (t.hasAttribute("aria-hidden") && t.setAttribute("data-previous-aria-hidden", t.getAttribute("aria-hidden") || ""), t.setAttribute("aria-hidden", "true"));
  });
}, Za = () => {
  Array.from(document.body.children).forEach((e) => {
    e.hasAttribute("data-previous-aria-hidden") ? (e.setAttribute("aria-hidden", e.getAttribute("data-previous-aria-hidden") || ""), e.removeAttribute("data-previous-aria-hidden")) : e.removeAttribute("aria-hidden");
  });
}, Ja = typeof window < "u" && !!window.GestureEvent, km = () => {
  if (Ja && !kt(document.body, b.iosfix)) {
    const e = document.body.scrollTop;
    document.body.style.top = `${e * -1}px`, oe(document.body, b.iosfix), xm();
  }
}, xm = () => {
  const e = Be();
  if (!e)
    return;
  let t;
  e.ontouchstart = (n) => {
    t = Cm(n);
  }, e.ontouchmove = (n) => {
    t && (n.preventDefault(), n.stopPropagation());
  };
}, Cm = (e) => {
  const t = e.target, n = Be(), o = Ar();
  return !n || !o || Am(e) || Lm(e) ? !1 : t === n || !rr(n) && t instanceof HTMLElement && !Cd(t, o) && // #2823
  t.tagName !== "INPUT" && // #1603
  t.tagName !== "TEXTAREA" && // #2266
  !(rr(o) && // #1944
  o.contains(t));
}, Am = (e) => !!(e.touches && e.touches.length && // @ts-ignore - touchType is not a standard property
e.touches[0].touchType === "stylus"), Lm = (e) => e.touches && e.touches.length > 1, Tm = () => {
  if (kt(document.body, b.iosfix)) {
    const e = parseInt(document.body.style.top, 10);
    ot(document.body, b.iosfix), document.body.style.top = "", document.body.scrollTop = e * -1;
  }
}, Nm = () => {
  const e = document.createElement("div");
  e.className = b["scrollbar-measure"], document.body.appendChild(e);
  const t = e.getBoundingClientRect().width - e.clientWidth;
  return document.body.removeChild(e), t;
};
let nn = null;
const Om = (e) => {
  nn === null && (document.body.scrollHeight > window.innerHeight || e === "scroll") && (nn = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right")), document.body.style.paddingRight = `${nn + Nm()}px`);
}, Pm = () => {
  nn !== null && (document.body.style.paddingRight = `${nn}px`, nn = null);
};
function Qa(e, t, n, o) {
  ko() ? Ss(e, o) : (pd(n).then(() => Ss(e, o)), Ga(R)), Ja ? (t.setAttribute("style", "display:none !important"), t.removeAttribute("class"), t.innerHTML = "") : t.remove(), Or() && (Pm(), Tm(), Za()), Im();
}
function Im() {
  ot([document.documentElement, document.body], [b.shown, b["height-auto"], b["no-backdrop"], b["toast-shown"]]);
}
function Nt(e) {
  e = Sm(e);
  const t = ln.swalPromiseResolve.get(this), n = $m(this);
  this.isAwaitingPromise ? e.isDismissed || (Dn(this), t(e)) : n && t(e);
}
const $m = (e) => {
  const t = ae();
  if (!t)
    return !1;
  const n = ce.innerParams.get(e);
  if (!n || kt(t, n.hideClass.popup))
    return !1;
  ot(t, n.showClass.popup), oe(t, n.hideClass.popup);
  const o = Be();
  return ot(o, n.showClass.backdrop), oe(o, n.hideClass.backdrop), Dm(e, t, n), !0;
};
function ei(e) {
  const t = ln.swalPromiseReject.get(this);
  Dn(this), t && t(e);
}
const Dn = (e) => {
  e.isAwaitingPromise && (delete e.isAwaitingPromise, ce.innerParams.get(e) || e._destroy());
}, Sm = (e) => typeof e > "u" ? {
  isConfirmed: !1,
  isDenied: !1,
  isDismissed: !0
} : Object.assign({
  isConfirmed: !1,
  isDenied: !1,
  isDismissed: !1
}, e), Dm = (e, t, n) => {
  var o;
  const r = Be(), s = Fa(t);
  typeof n.willClose == "function" && n.willClose(t), (o = R.eventEmitter) === null || o === void 0 || o.emit("willClose", t), s && r ? Mm(e, t, r, !!n.returnFocus, n.didClose) : r && Qa(e, r, !!n.returnFocus, n.didClose);
}, Mm = (e, t, n, o, r) => {
  R.swalCloseEventFinishedCallback = Qa.bind(null, e, n, o, r);
  const s = function(a) {
    if (a.target === t) {
      var i;
      (i = R.swalCloseEventFinishedCallback) === null || i === void 0 || i.call(R), delete R.swalCloseEventFinishedCallback, t.removeEventListener("animationend", s), t.removeEventListener("transitionend", s);
    }
  };
  t.addEventListener("animationend", s), t.addEventListener("transitionend", s);
}, Ss = (e, t) => {
  setTimeout(() => {
    var n;
    typeof t == "function" && t.bind(e.params)(), (n = R.eventEmitter) === null || n === void 0 || n.emit("didClose"), e._destroy && e._destroy();
  });
}, cn = (e) => {
  let t = ae();
  if (t || new ir(), t = ae(), !t)
    return;
  const n = hn();
  ko() ? Se(wn()) : Rm(t, e), Te(n), t.setAttribute("data-loading", "true"), t.setAttribute("aria-busy", "true"), t.focus();
}, Rm = (e, t) => {
  const n = In(), o = hn();
  !n || !o || (!t && He(ht()) && (t = ht()), Te(n), t && (Se(t), o.setAttribute("data-button-to-replace", t.className), n.insertBefore(o, t)), oe([e, n], b.loading));
}, Bm = (e, t) => {
  t.input === "select" || t.input === "radio" ? jm(e, t) : ["text", "email", "number", "tel", "textarea"].some((n) => n === t.input) && (xr(t.inputValue) || Cr(t.inputValue)) && (cn(ht()), Ym(e, t));
}, Fm = (e, t) => {
  const n = e.getInput();
  if (!n)
    return null;
  switch (t.input) {
    case "checkbox":
      return Um(n);
    case "radio":
      return Vm(n);
    case "file":
      return Hm(n);
    default:
      return t.inputAutoTrim ? n.value.trim() : n.value;
  }
}, Um = (e) => e.checked ? 1 : 0, Vm = (e) => e.checked ? e.value : null, Hm = (e) => e.files && e.files.length ? e.getAttribute("multiple") !== null ? e.files : e.files[0] : null, jm = (e, t) => {
  const n = ae();
  if (!n)
    return;
  const o = (r) => {
    t.input === "select" ? Wm(n, no(r), t) : t.input === "radio" && qm(n, no(r), t);
  };
  xr(t.inputOptions) || Cr(t.inputOptions) ? (cn(ht()), On(t.inputOptions).then((r) => {
    e.hideLoading(), o(r);
  })) : typeof t.inputOptions == "object" ? o(t.inputOptions) : Gt(`Unexpected type of inputOptions! Expected object, Map or Promise, got ${typeof t.inputOptions}`);
}, Ym = (e, t) => {
  const n = e.getInput();
  n && (Se(n), On(t.inputValue).then((o) => {
    n.value = t.input === "number" ? `${parseFloat(o) || 0}` : `${o}`, Te(n), n.focus(), e.hideLoading();
  }).catch((o) => {
    Gt(`Error in inputValue promise: ${o}`), n.value = "", Te(n), n.focus(), e.hideLoading();
  }));
};
function Wm(e, t, n) {
  const o = Tt(e, b.select);
  if (!o)
    return;
  const r = (s, a, i) => {
    const l = document.createElement("option");
    l.value = i, Ge(l, a), l.selected = ti(i, n.inputValue), s.appendChild(l);
  };
  t.forEach((s) => {
    const a = s[0], i = s[1];
    if (Array.isArray(i)) {
      const l = document.createElement("optgroup");
      l.label = a, l.disabled = !1, o.appendChild(l), i.forEach((p) => r(l, p[1], p[0]));
    } else
      r(o, i, a);
  }), o.focus();
}
function qm(e, t, n) {
  const o = Tt(e, b.radio);
  if (!o)
    return;
  t.forEach((s) => {
    const a = s[0], i = s[1], l = document.createElement("input"), p = document.createElement("label");
    l.type = "radio", l.name = b.radio, l.value = a, ti(a, n.inputValue) && (l.checked = !0);
    const y = document.createElement("span");
    Ge(y, i), y.className = b.label, p.appendChild(l), p.appendChild(y), o.appendChild(p);
  });
  const r = o.querySelectorAll("input");
  r.length && r[0].focus();
}
const no = (e) => {
  const t = [];
  return e instanceof Map ? e.forEach((n, o) => {
    let r = n;
    typeof r == "object" && (r = no(r)), t.push([o, r]);
  }) : Object.keys(e).forEach((n) => {
    let o = e[n];
    typeof o == "object" && (o = no(o)), t.push([n, o]);
  }), t;
}, ti = (e, t) => !!t && t !== null && t !== void 0 && t.toString() === e.toString(), zm = (e) => {
  const t = ce.innerParams.get(e);
  e.disableButtons(), t.input ? ni(e, "confirm") : Rr(e, !0);
}, Km = (e) => {
  const t = ce.innerParams.get(e);
  e.disableButtons(), t.returnInputValueOnDeny ? ni(e, "deny") : Mr(e, !1);
}, Gm = (e, t) => {
  e.disableButtons(), t(gn.cancel);
}, ni = (e, t) => {
  const n = ce.innerParams.get(e);
  if (!n.input) {
    Gt(`The "input" parameter is needed to be set when using returnInputValueOn${kr(t)}`);
    return;
  }
  const o = e.getInput(), r = Fm(e, n);
  n.inputValidator ? Xm(e, r, t) : o && !o.checkValidity() ? (e.enableButtons(), e.showValidationMessage(n.validationMessage || o.validationMessage)) : t === "deny" ? Mr(e, r) : Rr(e, r);
}, Xm = (e, t, n) => {
  const o = ce.innerParams.get(e);
  e.disableInput(), Promise.resolve().then(() => On(o.inputValidator(t, o.validationMessage))).then((r) => {
    e.enableButtons(), e.enableInput(), r ? e.showValidationMessage(r) : n === "deny" ? Mr(e, t) : Rr(e, t);
  });
}, Mr = (e, t) => {
  const n = ce.innerParams.get(e);
  n.showLoaderOnDeny && cn(Xt()), n.preDeny ? (e.isAwaitingPromise = !0, Promise.resolve().then(() => On(n.preDeny(t, n.validationMessage))).then((o) => {
    o === !1 ? (e.hideLoading(), Dn(e)) : e.close(
      /** @type SweetAlertResult */
      {
        isDenied: !0,
        value: typeof o > "u" ? t : o
      }
    );
  }).catch((o) => oi(e, o))) : e.close(
    /** @type SweetAlertResult */
    {
      isDenied: !0,
      value: t
    }
  );
}, Ds = (e, t) => {
  e.close(
    /** @type SweetAlertResult */
    {
      isConfirmed: !0,
      value: t
    }
  );
}, oi = (e, t) => {
  e.rejectPromise(t);
}, Rr = (e, t) => {
  const n = ce.innerParams.get(e);
  n.showLoaderOnConfirm && cn(), n.preConfirm ? (e.resetValidationMessage(), e.isAwaitingPromise = !0, Promise.resolve().then(() => On(n.preConfirm(t, n.validationMessage))).then((o) => {
    He(_o()) || o === !1 ? (e.hideLoading(), Dn(e)) : Ds(e, typeof o > "u" ? t : o);
  }).catch((o) => oi(e, o))) : Ds(e, t);
};
function oo() {
  const e = ce.innerParams.get(this);
  if (!e)
    return;
  const t = ce.domCache.get(this);
  Se(t.loader), ko() ? e.icon && Te(wn()) : Zm(t), ot([t.popup, t.actions], b.loading), t.popup.removeAttribute("aria-busy"), t.popup.removeAttribute("data-loading"), t.confirmButton.disabled = !1, t.denyButton.disabled = !1, t.cancelButton.disabled = !1;
}
const Zm = (e) => {
  const t = e.loader.getAttribute("data-button-to-replace"), n = t ? e.popup.getElementsByClassName(t) : [];
  n.length ? Te(
    /** @type {HTMLElement} */
    n[0],
    "inline-block"
  ) : xd() && Se(e.actions);
};
function ri() {
  const e = ce.innerParams.get(this), t = ce.domCache.get(this);
  return t ? xo(t.popup, e.input) : null;
}
function si(e, t, n) {
  const o = ce.domCache.get(e);
  t.forEach((r) => {
    o[r].disabled = n;
  });
}
function ai(e, t) {
  const n = ae();
  if (!(!n || !e))
    if (e.type === "radio") {
      const o = n.querySelectorAll(`[name="${b.radio}"]`);
      for (let r = 0; r < o.length; r++)
        o[r].disabled = t;
    } else
      e.disabled = t;
}
function ii() {
  si(this, ["confirmButton", "denyButton", "cancelButton"], !1);
}
function li() {
  si(this, ["confirmButton", "denyButton", "cancelButton"], !0);
}
function ci() {
  ai(this.getInput(), !1);
}
function ui() {
  ai(this.getInput(), !0);
}
function di(e) {
  const t = ce.domCache.get(this), n = ce.innerParams.get(this);
  Ge(t.validationMessage, e), t.validationMessage.className = b["validation-message"], n.customClass && n.customClass.validationMessage && oe(t.validationMessage, n.customClass.validationMessage), Te(t.validationMessage);
  const o = this.getInput();
  o && (o.setAttribute("aria-invalid", "true"), o.setAttribute("aria-describedby", b["validation-message"]), Ra(o), oe(o, b.inputerror));
}
function mi() {
  const e = ce.domCache.get(this);
  e.validationMessage && Se(e.validationMessage);
  const t = this.getInput();
  t && (t.removeAttribute("aria-invalid"), t.removeAttribute("aria-describedby"), ot(t, b.inputerror));
}
const Ot = {
  title: "",
  titleText: "",
  text: "",
  html: "",
  footer: "",
  icon: void 0,
  iconColor: void 0,
  iconHtml: void 0,
  template: void 0,
  toast: !1,
  draggable: !1,
  animation: !0,
  theme: "light",
  showClass: {
    popup: "swal2-show",
    backdrop: "swal2-backdrop-show",
    icon: "swal2-icon-show"
  },
  hideClass: {
    popup: "swal2-hide",
    backdrop: "swal2-backdrop-hide",
    icon: "swal2-icon-hide"
  },
  customClass: {},
  target: "body",
  color: void 0,
  backdrop: !0,
  heightAuto: !0,
  allowOutsideClick: !0,
  allowEscapeKey: !0,
  allowEnterKey: !0,
  stopKeydownPropagation: !0,
  keydownListenerCapture: !1,
  showConfirmButton: !0,
  showDenyButton: !1,
  showCancelButton: !1,
  preConfirm: void 0,
  preDeny: void 0,
  confirmButtonText: "OK",
  confirmButtonAriaLabel: "",
  confirmButtonColor: void 0,
  denyButtonText: "No",
  denyButtonAriaLabel: "",
  denyButtonColor: void 0,
  cancelButtonText: "Cancel",
  cancelButtonAriaLabel: "",
  cancelButtonColor: void 0,
  buttonsStyling: !0,
  reverseButtons: !1,
  focusConfirm: !0,
  focusDeny: !1,
  focusCancel: !1,
  returnFocus: !0,
  showCloseButton: !1,
  closeButtonHtml: "&times;",
  closeButtonAriaLabel: "Close this dialog",
  loaderHtml: "",
  showLoaderOnConfirm: !1,
  showLoaderOnDeny: !1,
  imageUrl: void 0,
  imageWidth: void 0,
  imageHeight: void 0,
  imageAlt: "",
  timer: void 0,
  timerProgressBar: !1,
  width: void 0,
  padding: void 0,
  background: void 0,
  input: void 0,
  inputPlaceholder: "",
  inputLabel: "",
  inputValue: "",
  inputOptions: {},
  inputAutoFocus: !0,
  inputAutoTrim: !0,
  inputAttributes: {},
  inputValidator: void 0,
  returnInputValueOnDeny: !1,
  validationMessage: void 0,
  grow: !1,
  position: "center",
  progressSteps: [],
  currentProgressStep: void 0,
  progressStepsDistance: void 0,
  willOpen: void 0,
  didOpen: void 0,
  didRender: void 0,
  willClose: void 0,
  didClose: void 0,
  didDestroy: void 0,
  scrollbarPadding: !0,
  topLayer: !1
}, Jm = ["allowEscapeKey", "allowOutsideClick", "background", "buttonsStyling", "cancelButtonAriaLabel", "cancelButtonColor", "cancelButtonText", "closeButtonAriaLabel", "closeButtonHtml", "color", "confirmButtonAriaLabel", "confirmButtonColor", "confirmButtonText", "currentProgressStep", "customClass", "denyButtonAriaLabel", "denyButtonColor", "denyButtonText", "didClose", "didDestroy", "draggable", "footer", "hideClass", "html", "icon", "iconColor", "iconHtml", "imageAlt", "imageHeight", "imageUrl", "imageWidth", "preConfirm", "preDeny", "progressSteps", "returnFocus", "reverseButtons", "showCancelButton", "showCloseButton", "showConfirmButton", "showDenyButton", "text", "title", "titleText", "theme", "willClose"], Qm = {
  allowEnterKey: void 0
}, ef = ["allowOutsideClick", "allowEnterKey", "backdrop", "draggable", "focusConfirm", "focusDeny", "focusCancel", "returnFocus", "heightAuto", "keydownListenerCapture"], fi = (e) => Object.prototype.hasOwnProperty.call(Ot, e), wi = (e) => Jm.indexOf(e) !== -1, pi = (e) => Qm[e], tf = (e) => {
  fi(e) || Me(`Unknown parameter "${e}"`);
}, nf = (e) => {
  ef.includes(e) && Me(`The parameter "${e}" is incompatible with toasts`);
}, of = (e) => {
  const t = pi(e);
  t && $a(e, t);
}, hi = (e) => {
  e.backdrop === !1 && e.allowOutsideClick && Me('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`'), e.theme && !["light", "dark", "auto", "minimal", "borderless", "bootstrap-4", "bootstrap-4-light", "bootstrap-4-dark", "bootstrap-5", "bootstrap-5-light", "bootstrap-5-dark", "material-ui", "material-ui-light", "material-ui-dark", "embed-iframe", "bulma", "bulma-light", "bulma-dark"].includes(e.theme) && Me(`Invalid theme "${e.theme}"`);
  for (const t in e)
    tf(t), e.toast && nf(t), of(t);
};
function gi(e) {
  const t = Be(), n = ae(), o = ce.innerParams.get(this);
  if (!n || kt(n, o.hideClass.popup)) {
    Me("You're trying to update the closed or closing popup, that won't work. Use the update() method in preConfirm parameter or show a new popup.");
    return;
  }
  const r = rf(e), s = Object.assign({}, o, r);
  hi(s), t && (t.dataset.swal2Theme = s.theme), za(this, s), ce.innerParams.set(this, s), Object.defineProperties(this, {
    params: {
      value: Object.assign({}, this.params, e),
      writable: !1,
      enumerable: !0
    }
  });
}
const rf = (e) => {
  const t = {};
  return Object.keys(e).forEach((n) => {
    if (wi(n)) {
      const o = (
        /** @type {Record<string, any>} */
        e
      );
      t[n] = o[n];
    } else
      Me(`Invalid parameter to update: ${n}`);
  }), t;
};
function bi() {
  var e;
  const t = ce.domCache.get(this), n = ce.innerParams.get(this);
  if (!n) {
    vi(this);
    return;
  }
  t.popup && R.swalCloseEventFinishedCallback && (R.swalCloseEventFinishedCallback(), delete R.swalCloseEventFinishedCallback), typeof n.didDestroy == "function" && n.didDestroy(), (e = R.eventEmitter) === null || e === void 0 || e.emit("didDestroy"), sf(this);
}
const sf = (e) => {
  vi(e), delete e.params, delete R.keydownHandler, delete R.keydownTarget, delete R.currentInstance;
}, vi = (e) => {
  e.isAwaitingPromise ? (Uo(ce, e), e.isAwaitingPromise = !0) : (Uo(ln, e), Uo(ce, e), delete e.isAwaitingPromise, delete e.disableButtons, delete e.enableButtons, delete e.getInput, delete e.disableInput, delete e.enableInput, delete e.hideLoading, delete e.disableLoading, delete e.showValidationMessage, delete e.resetValidationMessage, delete e.close, delete e.closePopup, delete e.closeModal, delete e.closeToast, delete e.rejectPromise, delete e.update, delete e._destroy);
}, Uo = (e, t) => {
  for (const n in e)
    e[n].delete(t);
};
var af = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  _destroy: bi,
  close: Nt,
  closeModal: Nt,
  closePopup: Nt,
  closeToast: Nt,
  disableButtons: li,
  disableInput: ui,
  disableLoading: oo,
  enableButtons: ii,
  enableInput: ci,
  getInput: ri,
  handleAwaitingPromise: Dn,
  hideLoading: oo,
  rejectPromise: ei,
  resetValidationMessage: mi,
  showValidationMessage: di,
  update: gi
});
const lf = (e, t, n) => {
  e.toast ? cf(e, t, n) : (df(t), mf(t), ff(e, t, n));
}, cf = (e, t, n) => {
  t.popup.onclick = () => {
    e && (uf(e) || e.timer || e.input) || n(gn.close);
  };
}, uf = (e) => !!(e.showConfirmButton || e.showDenyButton || e.showCancelButton || e.showCloseButton);
let ro = !1;
const df = (e) => {
  e.popup.onmousedown = () => {
    e.container.onmouseup = function(t) {
      e.container.onmouseup = () => {
      }, t.target === e.container && (ro = !0);
    };
  };
}, mf = (e) => {
  e.container.onmousedown = (t) => {
    t.target === e.container && t.preventDefault(), e.popup.onmouseup = function(n) {
      e.popup.onmouseup = () => {
      }, (n.target === e.popup || n.target instanceof HTMLElement && e.popup.contains(n.target)) && (ro = !0);
    };
  };
}, ff = (e, t, n) => {
  t.container.onclick = (o) => {
    if (ro) {
      ro = !1;
      return;
    }
    o.target === t.container && yo(e.allowOutsideClick) && n(gn.backdrop);
  };
}, wf = (e) => typeof e == "object" && e.jquery, Ms = (e) => e instanceof Element || wf(e), pf = (e) => {
  const t = {};
  return typeof e[0] == "object" && !Ms(e[0]) ? Object.assign(t, e[0]) : ["title", "html", "icon"].forEach((n, o) => {
    const r = e[o];
    typeof r == "string" || Ms(r) ? t[n] = r : r !== void 0 && Gt(`Unexpected type of ${n}! Expected "string" or "Element", got ${typeof r}`);
  }), t;
};
function hf(...e) {
  return new this(...e);
}
function gf(e) {
  class t extends this {
    /**
     * @param {any} params
     * @param {any} priorityMixinParams
     */
    _main(o, r) {
      return super._main(o, Object.assign({}, e, r));
    }
  }
  return t;
}
const bf = () => R.timeout && R.timeout.getTimerLeft(), yi = () => {
  if (R.timeout)
    return Ad(), R.timeout.stop();
}, _i = () => {
  if (R.timeout) {
    const e = R.timeout.start();
    return Ir(e), e;
  }
}, vf = () => {
  const e = R.timeout;
  return e && (e.running ? yi() : _i());
}, yf = (e) => {
  if (R.timeout) {
    const t = R.timeout.increase(e);
    return Ir(t, !0), t;
  }
}, _f = () => !!(R.timeout && R.timeout.isRunning());
let Rs = !1;
const ar = {};
function Ef(e = "data-swal-template") {
  ar[e] = this, Rs || (document.body.addEventListener("click", kf), Rs = !0);
}
const kf = (e) => {
  for (let t = (
    /** @type {any} */
    e.target
  ); t && t !== document; t = t.parentNode)
    for (const n in ar) {
      const o = t.getAttribute && t.getAttribute(n);
      if (o) {
        ar[n].fire({
          template: o
        });
        return;
      }
    }
};
class xf {
  constructor() {
    this.events = {};
  }
  /**
   * @param {string} eventName
   * @returns {EventHandlers}
   */
  _getHandlersByEventName(t) {
    return typeof this.events[t] > "u" && (this.events[t] = []), this.events[t];
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  on(t, n) {
    const o = this._getHandlersByEventName(t);
    o.includes(n) || o.push(n);
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  once(t, n) {
    const o = (...r) => {
      this.removeListener(t, o), n.apply(this, r);
    };
    this.on(t, o);
  }
  /**
   * @param {string} eventName
   * @param {...any} args
   */
  emit(t, ...n) {
    this._getHandlersByEventName(t).forEach(
      /**
       * @param {EventHandler} eventHandler
       */
      (o) => {
        try {
          o.apply(this, n);
        } catch (r) {
          console.error(r);
        }
      }
    );
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  removeListener(t, n) {
    const o = this._getHandlersByEventName(t), r = o.indexOf(n);
    r > -1 && o.splice(r, 1);
  }
  /**
   * @param {string} eventName
   */
  removeAllListeners(t) {
    this.events[t] !== void 0 && (this.events[t].length = 0);
  }
  reset() {
    this.events = {};
  }
}
R.eventEmitter = new xf();
const Cf = (e, t) => {
  R.eventEmitter && R.eventEmitter.on(e, t);
}, Af = (e, t) => {
  R.eventEmitter && R.eventEmitter.once(e, t);
}, Lf = (e, t) => {
  if (R.eventEmitter) {
    if (!e) {
      R.eventEmitter.reset();
      return;
    }
    t ? R.eventEmitter.removeListener(e, t) : R.eventEmitter.removeAllListeners(e);
  }
};
var Tf = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  argsToParams: pf,
  bindClickHandler: Ef,
  clickCancel: wm,
  clickConfirm: Ka,
  clickDeny: fm,
  enableLoading: cn,
  fire: hf,
  getActions: In,
  getCancelButton: pn,
  getCloseButton: Tr,
  getConfirmButton: ht,
  getContainer: Be,
  getDenyButton: Xt,
  getFocusableElements: Nr,
  getFooter: Ma,
  getHtmlContainer: Ar,
  getIcon: wn,
  getIconContent: vd,
  getImage: Da,
  getInputLabel: yd,
  getLoader: hn,
  getPopup: ae,
  getProgressSteps: Lr,
  getTimerLeft: bf,
  getTimerProgressBar: Eo,
  getTitle: Sa,
  getValidationMessage: _o,
  increaseTimer: yf,
  isDeprecatedParameter: pi,
  isLoading: Ed,
  isTimerRunning: _f,
  isUpdatableParameter: wi,
  isValidParameter: fi,
  isVisible: mm,
  mixin: gf,
  off: Lf,
  on: Cf,
  once: Af,
  resumeTimer: _i,
  showLoading: cn,
  stopTimer: yi,
  toggleTimer: vf
});
class Nf {
  /**
   * @param {() => void} callback
   * @param {number} delay
   */
  constructor(t, n) {
    this.callback = t, this.remaining = n, this.running = !1, this.start();
  }
  /**
   * @returns {number}
   */
  start() {
    return this.running || (this.running = !0, this.started = /* @__PURE__ */ new Date(), this.id = setTimeout(this.callback, this.remaining)), this.remaining;
  }
  /**
   * @returns {number}
   */
  stop() {
    return this.started && this.running && (this.running = !1, clearTimeout(this.id), this.remaining -= (/* @__PURE__ */ new Date()).getTime() - this.started.getTime()), this.remaining;
  }
  /**
   * @param {number} n
   * @returns {number}
   */
  increase(t) {
    const n = this.running;
    return n && this.stop(), this.remaining += t, n && this.start(), this.remaining;
  }
  /**
   * @returns {number}
   */
  getTimerLeft() {
    return this.running && (this.stop(), this.start()), this.remaining;
  }
  /**
   * @returns {boolean}
   */
  isRunning() {
    return this.running;
  }
}
const Ei = ["swal-title", "swal-html", "swal-footer"], Of = (e) => {
  const t = typeof e.template == "string" ? (
    /** @type {HTMLTemplateElement} */
    document.querySelector(e.template)
  ) : e.template;
  if (!t)
    return {};
  const n = t.content;
  return Bf(n), Object.assign(Pf(n), If(n), $f(n), Sf(n), Df(n), Mf(n), Rf(n, Ei));
}, Pf = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-param")).forEach((n) => {
    zt(n, ["name", "value"]);
    const o = (
      /** @type {keyof SweetAlertOptions} */
      n.getAttribute("name")
    ), r = n.getAttribute("value");
    !o || !r || (o in Ot && typeof Ot[
      /** @type {keyof typeof defaultParams} */
      o
    ] == "boolean" ? t[o] = r !== "false" : o in Ot && typeof Ot[
      /** @type {keyof typeof defaultParams} */
      o
    ] == "object" ? t[o] = JSON.parse(r) : t[o] = r);
  }), t;
}, If = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-function-param")).forEach((n) => {
    const o = (
      /** @type {keyof SweetAlertOptions} */
      n.getAttribute("name")
    ), r = n.getAttribute("value");
    !o || !r || (t[o] = new Function(`return ${r}`)());
  }), t;
}, $f = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-button")).forEach((n) => {
    zt(n, ["type", "color", "aria-label"]);
    const o = n.getAttribute("type");
    if (!(!o || !["confirm", "cancel", "deny"].includes(o))) {
      if (t[`${o}ButtonText`] = n.innerHTML, t[`show${kr(o)}Button`] = !0, n.hasAttribute("color")) {
        const r = n.getAttribute("color");
        r !== null && (t[`${o}ButtonColor`] = r);
      }
      if (n.hasAttribute("aria-label")) {
        const r = n.getAttribute("aria-label");
        r !== null && (t[`${o}ButtonAriaLabel`] = r);
      }
    }
  }), t;
}, Sf = (e) => {
  const t = {}, n = e.querySelector("swal-image");
  return n && (zt(n, ["src", "width", "height", "alt"]), n.hasAttribute("src") && (t.imageUrl = n.getAttribute("src") || void 0), n.hasAttribute("width") && (t.imageWidth = n.getAttribute("width") || void 0), n.hasAttribute("height") && (t.imageHeight = n.getAttribute("height") || void 0), n.hasAttribute("alt") && (t.imageAlt = n.getAttribute("alt") || void 0)), t;
}, Df = (e) => {
  const t = {}, n = e.querySelector("swal-icon");
  return n && (zt(n, ["type", "color"]), n.hasAttribute("type") && (t.icon = n.getAttribute("type")), n.hasAttribute("color") && (t.iconColor = n.getAttribute("color")), t.iconHtml = n.innerHTML), t;
}, Mf = (e) => {
  const t = {}, n = e.querySelector("swal-input");
  n && (zt(n, ["type", "label", "placeholder", "value"]), t.input = n.getAttribute("type") || "text", n.hasAttribute("label") && (t.inputLabel = n.getAttribute("label")), n.hasAttribute("placeholder") && (t.inputPlaceholder = n.getAttribute("placeholder")), n.hasAttribute("value") && (t.inputValue = n.getAttribute("value")));
  const o = Array.from(e.querySelectorAll("swal-input-option"));
  return o.length && (t.inputOptions = {}, o.forEach((r) => {
    zt(r, ["value"]);
    const s = r.getAttribute("value");
    if (!s)
      return;
    const a = r.innerHTML;
    t.inputOptions[s] = a;
  })), t;
}, Rf = (e, t) => {
  const n = {};
  for (const o in t) {
    const r = t[o], s = e.querySelector(r);
    s && (zt(s, []), n[r.replace(/^swal-/, "")] = s.innerHTML.trim());
  }
  return n;
}, Bf = (e) => {
  const t = Ei.concat(["swal-param", "swal-function-param", "swal-button", "swal-image", "swal-icon", "swal-input", "swal-input-option"]);
  Array.from(e.children).forEach((n) => {
    const o = n.tagName.toLowerCase();
    t.includes(o) || Me(`Unrecognized element <${o}>`);
  });
}, zt = (e, t) => {
  Array.from(e.attributes).forEach((n) => {
    t.indexOf(n.name) === -1 && Me([`Unrecognized attribute "${n.name}" on <${e.tagName.toLowerCase()}>.`, `${t.length ? `Allowed attributes are: ${t.join(", ")}` : "To set the value, use HTML within the element."}`]);
  });
}, ki = 10, Ff = (e) => {
  var t, n;
  const o = Be(), r = ae();
  if (!o || !r)
    return;
  typeof e.willOpen == "function" && e.willOpen(r), (t = R.eventEmitter) === null || t === void 0 || t.emit("willOpen", r);
  const s = window.getComputedStyle(document.body).overflowY;
  if (Hf(o, r, e), setTimeout(() => {
    Uf(o, r);
  }, ki), Or() && (Vf(o, e.scrollbarPadding !== void 0 ? e.scrollbarPadding : !1, s), Em()), !ko() && !R.previousActiveElement && (R.previousActiveElement = document.activeElement), typeof e.didOpen == "function") {
    const a = e.didOpen;
    setTimeout(() => a(r));
  }
  (n = R.eventEmitter) === null || n === void 0 || n.emit("didOpen", r);
}, so = (e) => {
  const t = ae();
  if (!t || e.target !== t)
    return;
  const n = Be();
  n && (t.removeEventListener("animationend", so), t.removeEventListener("transitionend", so), n.style.overflowY = "auto", ot(n, b["no-transition"]));
}, Uf = (e, t) => {
  Fa(t) ? (e.style.overflowY = "hidden", t.addEventListener("animationend", so), t.addEventListener("transitionend", so)) : e.style.overflowY = "auto";
}, Vf = (e, t, n) => {
  km(), t && n !== "hidden" && Om(n), setTimeout(() => {
    e.scrollTop = 0;
  });
}, Hf = (e, t, n) => {
  var o;
  (o = n.showClass) !== null && o !== void 0 && o.backdrop && oe(e, n.showClass.backdrop), n.animation ? (t.style.setProperty("opacity", "0", "important"), Te(t, "grid"), setTimeout(() => {
    var r;
    (r = n.showClass) !== null && r !== void 0 && r.popup && oe(t, n.showClass.popup), t.style.removeProperty("opacity");
  }, ki)) : Te(t, "grid"), oe([document.documentElement, document.body], b.shown), n.heightAuto && n.backdrop && !n.toast && oe([document.documentElement, document.body], b["height-auto"]);
};
var Bs = {
  /**
   * @param {string} string
   * @param {string} [validationMessage]
   * @returns {Promise<string | void>}
   */
  email: (e, t) => /^[a-zA-Z0-9.+_'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]+$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid email address"),
  /**
   * @param {string} string
   * @param {string} [validationMessage]
   * @returns {Promise<string | void>}
   */
  url: (e, t) => /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid URL")
};
function jf(e) {
  e.inputValidator || (e.input === "email" && (e.inputValidator = Bs.email), e.input === "url" && (e.inputValidator = Bs.url));
}
function Yf(e) {
  (!e.target || typeof e.target == "string" && !document.querySelector(e.target) || typeof e.target != "string" && !e.target.appendChild) && (Me('Target parameter is not valid, defaulting to "body"'), e.target = "body");
}
function Wf(e) {
  jf(e), e.showLoaderOnConfirm && !e.preConfirm && Me(`showLoaderOnConfirm is set to true, but preConfirm is not defined.
showLoaderOnConfirm should be used together with preConfirm, see usage example:
https://sweetalert2.github.io/#ajax-request`), Yf(e), typeof e.title == "string" && (e.title = e.title.split(`
`).join("<br />")), Sd(e);
}
let mt;
var Wn = /* @__PURE__ */ new WeakMap();
class _e {
  /**
   * @param {...(SweetAlertOptions | string)} args
   * @this {SweetAlert}
   */
  constructor(...t) {
    if (dd(
      this,
      Wn,
      /** @type {Promise<SweetAlertResult>} */
      Promise.resolve({
        isConfirmed: !1,
        isDenied: !1,
        isDismissed: !0
      })
    ), typeof window > "u")
      return;
    mt = this;
    const n = Object.freeze(this.constructor.argsToParams(t));
    this.params = n, this.isAwaitingPromise = !1, md(Wn, this, this._main(mt.params));
  }
  /**
   * @param {any} userParams
   * @param {any} mixinParams
   */
  _main(t, n = {}) {
    if (hi(Object.assign({}, n, t)), R.currentInstance) {
      const s = ln.swalPromiseResolve.get(R.currentInstance), {
        isAwaitingPromise: a
      } = R.currentInstance;
      R.currentInstance._destroy(), a || s({
        isDismissed: !0
      }), Or() && Za();
    }
    R.currentInstance = mt;
    const o = zf(t, n);
    Wf(o), Object.freeze(o), R.timeout && (R.timeout.stop(), delete R.timeout), clearTimeout(R.restoreFocusTimeout);
    const r = Kf(mt);
    return za(mt, o), ce.innerParams.set(mt, o), qf(mt, r, o);
  }
  // `catch` cannot be the name of a module export, so we define our thenable methods here instead
  /**
   * @param {any} onFulfilled
   */
  then(t) {
    return Ts(Wn, this).then(t);
  }
  /**
   * @param {any} onFinally
   */
  finally(t) {
    return Ts(Wn, this).finally(t);
  }
}
const qf = (e, t, n) => new Promise((o, r) => {
  const s = (a) => {
    e.close({
      isDismissed: !0,
      dismiss: a,
      isConfirmed: !1,
      isDenied: !1
    });
  };
  ln.swalPromiseResolve.set(e, o), ln.swalPromiseReject.set(e, r), t.confirmButton.onclick = () => {
    zm(e);
  }, t.denyButton.onclick = () => {
    Km(e);
  }, t.cancelButton.onclick = () => {
    Gm(e, s);
  }, t.closeButton.onclick = () => {
    s(gn.close);
  }, lf(n, t, s), pm(R, n, s), Bm(e, n), Ff(n), Gf(R, n, s), Xf(t, n), setTimeout(() => {
    t.container.scrollTop = 0;
  });
}), zf = (e, t) => {
  const n = Of(e), o = Object.assign({}, Ot, t, n, e);
  return o.showClass = Object.assign({}, Ot.showClass, o.showClass), o.hideClass = Object.assign({}, Ot.hideClass, o.hideClass), o.animation === !1 && (o.showClass = {
    backdrop: "swal2-noanimation"
  }, o.hideClass = {}), o;
}, Kf = (e) => {
  const t = (
    /** @type {DomCache} */
    {
      popup: (
        /** @type {HTMLElement} */
        ae()
      ),
      container: (
        /** @type {HTMLElement} */
        Be()
      ),
      actions: (
        /** @type {HTMLElement} */
        In()
      ),
      confirmButton: (
        /** @type {HTMLElement} */
        ht()
      ),
      denyButton: (
        /** @type {HTMLElement} */
        Xt()
      ),
      cancelButton: (
        /** @type {HTMLElement} */
        pn()
      ),
      loader: (
        /** @type {HTMLElement} */
        hn()
      ),
      closeButton: (
        /** @type {HTMLElement} */
        Tr()
      ),
      validationMessage: (
        /** @type {HTMLElement} */
        _o()
      ),
      progressSteps: (
        /** @type {HTMLElement} */
        Lr()
      )
    }
  );
  return ce.domCache.set(e, t), t;
}, Gf = (e, t, n) => {
  const o = Eo();
  Se(o), t.timer && (e.timeout = new Nf(() => {
    n("timer"), delete e.timeout;
  }, t.timer), t.timerProgressBar && o && (Te(o), qe(o, t, "timerProgressBar"), setTimeout(() => {
    e.timeout && e.timeout.running && Ir(
      /** @type {number} */
      t.timer
    );
  })));
}, Xf = (e, t) => {
  if (!t.toast) {
    if (!yo(t.allowEnterKey)) {
      $a("allowEnterKey"), Qf();
      return;
    }
    Zf(e) || Jf(e, t) || sr(-1, 1);
  }
}, Zf = (e) => {
  const t = Array.from(e.popup.querySelectorAll("[autofocus]"));
  for (const n of t)
    if (n instanceof HTMLElement && He(n))
      return n.focus(), !0;
  return !1;
}, Jf = (e, t) => t.focusDeny && He(e.denyButton) ? (e.denyButton.focus(), !0) : t.focusCancel && He(e.cancelButton) ? (e.cancelButton.focus(), !0) : t.focusConfirm && He(e.confirmButton) ? (e.confirmButton.focus(), !0) : !1, Qf = () => {
  document.activeElement instanceof HTMLElement && typeof document.activeElement.blur == "function" && document.activeElement.blur();
};
_e.prototype.disableButtons = li;
_e.prototype.enableButtons = ii;
_e.prototype.getInput = ri;
_e.prototype.disableInput = ui;
_e.prototype.enableInput = ci;
_e.prototype.hideLoading = oo;
_e.prototype.disableLoading = oo;
_e.prototype.showValidationMessage = di;
_e.prototype.resetValidationMessage = mi;
_e.prototype.close = Nt;
_e.prototype.closePopup = Nt;
_e.prototype.closeModal = Nt;
_e.prototype.closeToast = Nt;
_e.prototype.rejectPromise = ei;
_e.prototype.update = gi;
_e.prototype._destroy = bi;
Object.assign(_e, Tf);
Object.keys(af).forEach((e) => {
  _e[e] = function(...t) {
    if (mt && mt[e])
      return mt[e](...t);
  };
});
_e.DismissReason = gn;
_e.version = "11.26.17";
const ir = _e;
ir.default = ir;
typeof document < "u" && function(e, t) {
  var n = e.createElement("style");
  if (e.getElementsByTagName("head")[0].appendChild(n), n.styleSheet) n.styleSheet.disabled || (n.styleSheet.cssText = t);
  else try {
    n.innerHTML = t;
  } catch {
    n.innerText = t;
  }
}(document, ':root{--swal2-outline: 0 0 0 3px rgba(100, 150, 200, 0.5);--swal2-container-padding: 0.625em;--swal2-backdrop: rgba(0, 0, 0, 0.4);--swal2-backdrop-transition: background-color 0.15s;--swal2-width: 32em;--swal2-padding: 0 0 1.25em;--swal2-border: none;--swal2-border-radius: 0.3125rem;--swal2-background: white;--swal2-color: #545454;--swal2-show-animation: swal2-show 0.3s;--swal2-hide-animation: swal2-hide 0.15s forwards;--swal2-icon-zoom: 1;--swal2-icon-animations: true;--swal2-title-padding: 0.8em 1em 0;--swal2-html-container-padding: 1em 1.6em 0.3em;--swal2-input-border: 1px solid #d9d9d9;--swal2-input-border-radius: 0.1875em;--swal2-input-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px transparent;--swal2-input-background: transparent;--swal2-input-transition: border-color 0.2s, box-shadow 0.2s;--swal2-input-hover-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px transparent;--swal2-input-focus-border: 1px solid #b4dbed;--swal2-input-focus-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px rgba(100, 150, 200, 0.5);--swal2-progress-step-background: #add8e6;--swal2-validation-message-background: #f0f0f0;--swal2-validation-message-color: #666;--swal2-footer-border-color: #eee;--swal2-footer-background: transparent;--swal2-footer-color: inherit;--swal2-timer-progress-bar-background: rgba(0, 0, 0, 0.3);--swal2-close-button-position: initial;--swal2-close-button-inset: auto;--swal2-close-button-font-size: 2.5em;--swal2-close-button-color: #ccc;--swal2-close-button-transition: color 0.2s, box-shadow 0.2s;--swal2-close-button-outline: initial;--swal2-close-button-box-shadow: inset 0 0 0 3px transparent;--swal2-close-button-focus-box-shadow: inset var(--swal2-outline);--swal2-close-button-hover-transform: none;--swal2-actions-justify-content: center;--swal2-actions-width: auto;--swal2-actions-margin: 1.25em auto 0;--swal2-actions-padding: 0;--swal2-actions-border-radius: 0;--swal2-actions-background: transparent;--swal2-action-button-transition: background-color 0.2s, box-shadow 0.2s;--swal2-action-button-hover: black 10%;--swal2-action-button-active: black 10%;--swal2-confirm-button-box-shadow: none;--swal2-confirm-button-border-radius: 0.25em;--swal2-confirm-button-background-color: #7066e0;--swal2-confirm-button-color: #fff;--swal2-deny-button-box-shadow: none;--swal2-deny-button-border-radius: 0.25em;--swal2-deny-button-background-color: #dc3741;--swal2-deny-button-color: #fff;--swal2-cancel-button-box-shadow: none;--swal2-cancel-button-border-radius: 0.25em;--swal2-cancel-button-background-color: #6e7881;--swal2-cancel-button-color: #fff;--swal2-toast-show-animation: swal2-toast-show 0.5s;--swal2-toast-hide-animation: swal2-toast-hide 0.1s forwards;--swal2-toast-border: none;--swal2-toast-box-shadow: 0 0 1px hsl(0deg 0% 0% / 0.075), 0 1px 2px hsl(0deg 0% 0% / 0.075), 1px 2px 4px hsl(0deg 0% 0% / 0.075), 1px 3px 8px hsl(0deg 0% 0% / 0.075), 2px 4px 16px hsl(0deg 0% 0% / 0.075)}[data-swal2-theme=dark]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white);--swal2-timer-progress-bar-background: rgba(255, 255, 255, 0.7)}@media(prefers-color-scheme: dark){[data-swal2-theme=auto]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white);--swal2-timer-progress-bar-background: rgba(255, 255, 255, 0.7)}}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow:hidden}body.swal2-height-auto{height:auto !important}body.swal2-no-backdrop .swal2-container{background-color:rgba(0,0,0,0) !important;pointer-events:none}body.swal2-no-backdrop .swal2-container .swal2-popup{pointer-events:all}body.swal2-no-backdrop .swal2-container .swal2-modal{box-shadow:0 0 10px var(--swal2-backdrop)}body.swal2-toast-shown .swal2-container{box-sizing:border-box;width:360px;max-width:100%;background-color:rgba(0,0,0,0);pointer-events:none}body.swal2-toast-shown .swal2-container.swal2-top{inset:0 auto auto 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-top-end,body.swal2-toast-shown .swal2-container.swal2-top-right{inset:0 0 auto auto}body.swal2-toast-shown .swal2-container.swal2-top-start,body.swal2-toast-shown .swal2-container.swal2-top-left{inset:0 auto auto 0}body.swal2-toast-shown .swal2-container.swal2-center-start,body.swal2-toast-shown .swal2-container.swal2-center-left{inset:50% auto auto 0;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-center{inset:50% auto auto 50%;transform:translate(-50%, -50%)}body.swal2-toast-shown .swal2-container.swal2-center-end,body.swal2-toast-shown .swal2-container.swal2-center-right{inset:50% 0 auto auto;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-start,body.swal2-toast-shown .swal2-container.swal2-bottom-left{inset:auto auto 0 0}body.swal2-toast-shown .swal2-container.swal2-bottom{inset:auto auto 0 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-end,body.swal2-toast-shown .swal2-container.swal2-bottom-right{inset:auto 0 0 auto}@media print{body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow-y:scroll !important}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown)>[aria-hidden=true]{display:none}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown) .swal2-container{position:static !important}}div:where(.swal2-container){display:grid;position:fixed;z-index:1060;inset:0;box-sizing:border-box;grid-template-areas:"top-start     top            top-end" "center-start  center         center-end" "bottom-start  bottom-center  bottom-end";grid-template-rows:minmax(min-content, auto) minmax(min-content, auto) minmax(min-content, auto);height:100%;padding:var(--swal2-container-padding);overflow-x:hidden;transition:var(--swal2-backdrop-transition);-webkit-overflow-scrolling:touch}div:where(.swal2-container).swal2-backdrop-show,div:where(.swal2-container).swal2-noanimation{background:var(--swal2-backdrop)}div:where(.swal2-container).swal2-backdrop-hide{background:rgba(0,0,0,0) !important}div:where(.swal2-container).swal2-top-start,div:where(.swal2-container).swal2-center-start,div:where(.swal2-container).swal2-bottom-start{grid-template-columns:minmax(0, 1fr) auto auto}div:where(.swal2-container).swal2-top,div:where(.swal2-container).swal2-center,div:where(.swal2-container).swal2-bottom{grid-template-columns:auto minmax(0, 1fr) auto}div:where(.swal2-container).swal2-top-end,div:where(.swal2-container).swal2-center-end,div:where(.swal2-container).swal2-bottom-end{grid-template-columns:auto auto minmax(0, 1fr)}div:where(.swal2-container).swal2-top-start>.swal2-popup{align-self:start}div:where(.swal2-container).swal2-top>.swal2-popup{grid-column:2;place-self:start center}div:where(.swal2-container).swal2-top-end>.swal2-popup,div:where(.swal2-container).swal2-top-right>.swal2-popup{grid-column:3;place-self:start end}div:where(.swal2-container).swal2-center-start>.swal2-popup,div:where(.swal2-container).swal2-center-left>.swal2-popup{grid-row:2;align-self:center}div:where(.swal2-container).swal2-center>.swal2-popup{grid-column:2;grid-row:2;place-self:center center}div:where(.swal2-container).swal2-center-end>.swal2-popup,div:where(.swal2-container).swal2-center-right>.swal2-popup{grid-column:3;grid-row:2;place-self:center end}div:where(.swal2-container).swal2-bottom-start>.swal2-popup,div:where(.swal2-container).swal2-bottom-left>.swal2-popup{grid-column:1;grid-row:3;align-self:end}div:where(.swal2-container).swal2-bottom>.swal2-popup{grid-column:2;grid-row:3;place-self:end center}div:where(.swal2-container).swal2-bottom-end>.swal2-popup,div:where(.swal2-container).swal2-bottom-right>.swal2-popup{grid-column:3;grid-row:3;place-self:end end}div:where(.swal2-container).swal2-grow-row>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-column:1/4;width:100%}div:where(.swal2-container).swal2-grow-column>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-row:1/4;align-self:stretch}div:where(.swal2-container).swal2-no-transition{transition:none !important}div:where(.swal2-container)[popover]{width:auto;border:0}div:where(.swal2-container) div:where(.swal2-popup){display:none;position:relative;box-sizing:border-box;grid-template-columns:minmax(0, 100%);width:var(--swal2-width);max-width:100%;padding:var(--swal2-padding);border:var(--swal2-border);border-radius:var(--swal2-border-radius);background:var(--swal2-background);color:var(--swal2-color);font-family:inherit;font-size:1rem;container-name:swal2-popup}div:where(.swal2-container) div:where(.swal2-popup):focus{outline:none}div:where(.swal2-container) div:where(.swal2-popup).swal2-loading{overflow-y:hidden}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable{cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable div:where(.swal2-icon){cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging{cursor:grabbing}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging div:where(.swal2-icon){cursor:grabbing}div:where(.swal2-container) h2:where(.swal2-title){position:relative;max-width:100%;margin:0;padding:var(--swal2-title-padding);color:inherit;font-size:1.875em;font-weight:600;text-align:center;text-transform:none;overflow-wrap:break-word;cursor:initial}div:where(.swal2-container) div:where(.swal2-actions){display:flex;z-index:1;box-sizing:border-box;flex-wrap:wrap;align-items:center;justify-content:var(--swal2-actions-justify-content);width:var(--swal2-actions-width);margin:var(--swal2-actions-margin);padding:var(--swal2-actions-padding);border-radius:var(--swal2-actions-border-radius);background:var(--swal2-actions-background)}div:where(.swal2-container) div:where(.swal2-loader){display:none;align-items:center;justify-content:center;width:2.2em;height:2.2em;margin:0 1.875em;animation:swal2-rotate-loading 1.5s linear 0s infinite normal;border-width:.25em;border-style:solid;border-radius:100%;border-color:#2778c4 rgba(0,0,0,0) #2778c4 rgba(0,0,0,0)}div:where(.swal2-container) button:where(.swal2-styled){margin:.3125em;padding:.625em 1.1em;transition:var(--swal2-action-button-transition);border:none;box-shadow:0 0 0 3px rgba(0,0,0,0);font-weight:500}div:where(.swal2-container) button:where(.swal2-styled):not([disabled]){cursor:pointer}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm){border-radius:var(--swal2-confirm-button-border-radius);background:initial;background-color:var(--swal2-confirm-button-background-color);box-shadow:var(--swal2-confirm-button-box-shadow);color:var(--swal2-confirm-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):hover{background-color:color-mix(in srgb, var(--swal2-confirm-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):active{background-color:color-mix(in srgb, var(--swal2-confirm-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny){border-radius:var(--swal2-deny-button-border-radius);background:initial;background-color:var(--swal2-deny-button-background-color);box-shadow:var(--swal2-deny-button-box-shadow);color:var(--swal2-deny-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):hover{background-color:color-mix(in srgb, var(--swal2-deny-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):active{background-color:color-mix(in srgb, var(--swal2-deny-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel){border-radius:var(--swal2-cancel-button-border-radius);background:initial;background-color:var(--swal2-cancel-button-background-color);box-shadow:var(--swal2-cancel-button-box-shadow);color:var(--swal2-cancel-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):hover{background-color:color-mix(in srgb, var(--swal2-cancel-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):active{background-color:color-mix(in srgb, var(--swal2-cancel-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):focus-visible{outline:none;box-shadow:var(--swal2-action-button-focus-box-shadow)}div:where(.swal2-container) button:where(.swal2-styled)[disabled]:not(.swal2-loading){opacity:.4}div:where(.swal2-container) button:where(.swal2-styled)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-footer){margin:1em 0 0;padding:1em 1em 0;border-top:1px solid var(--swal2-footer-border-color);background:var(--swal2-footer-background);color:var(--swal2-footer-color);font-size:1em;text-align:center;cursor:initial}div:where(.swal2-container) .swal2-timer-progress-bar-container{position:absolute;right:0;bottom:0;left:0;grid-column:auto !important;overflow:hidden;border-bottom-right-radius:var(--swal2-border-radius);border-bottom-left-radius:var(--swal2-border-radius)}div:where(.swal2-container) div:where(.swal2-timer-progress-bar){width:100%;height:.25em;background:var(--swal2-timer-progress-bar-background)}div:where(.swal2-container) img:where(.swal2-image){max-width:100%;margin:2em auto 1em;cursor:initial}div:where(.swal2-container) button:where(.swal2-close){position:var(--swal2-close-button-position);inset:var(--swal2-close-button-inset);z-index:2;align-items:center;justify-content:center;width:1.2em;height:1.2em;margin-top:0;margin-right:0;margin-bottom:-1.2em;padding:0;overflow:hidden;transition:var(--swal2-close-button-transition);border:none;border-radius:var(--swal2-border-radius);outline:var(--swal2-close-button-outline);background:rgba(0,0,0,0);color:var(--swal2-close-button-color);font-family:monospace;font-size:var(--swal2-close-button-font-size);cursor:pointer;justify-self:end}div:where(.swal2-container) button:where(.swal2-close):hover{transform:var(--swal2-close-button-hover-transform);background:rgba(0,0,0,0);color:#f27474}div:where(.swal2-container) button:where(.swal2-close):focus-visible{outline:none;box-shadow:var(--swal2-close-button-focus-box-shadow)}div:where(.swal2-container) button:where(.swal2-close)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-html-container){z-index:1;justify-content:center;margin:0;padding:var(--swal2-html-container-padding);overflow:auto;color:inherit;font-size:1.125em;font-weight:normal;line-height:normal;text-align:center;overflow-wrap:break-word;word-break:break-word;cursor:initial}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea),div:where(.swal2-container) select:where(.swal2-select),div:where(.swal2-container) div:where(.swal2-radio),div:where(.swal2-container) label:where(.swal2-checkbox){margin:1em 2em 3px}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea){box-sizing:border-box;width:auto;transition:var(--swal2-input-transition);border:var(--swal2-input-border);border-radius:var(--swal2-input-border-radius);background:var(--swal2-input-background);box-shadow:var(--swal2-input-box-shadow);color:inherit;font-size:1.125em}div:where(.swal2-container) input:where(.swal2-input).swal2-inputerror,div:where(.swal2-container) input:where(.swal2-file).swal2-inputerror,div:where(.swal2-container) textarea:where(.swal2-textarea).swal2-inputerror{border-color:#f27474 !important;box-shadow:0 0 2px #f27474 !important}div:where(.swal2-container) input:where(.swal2-input):hover,div:where(.swal2-container) input:where(.swal2-file):hover,div:where(.swal2-container) textarea:where(.swal2-textarea):hover{box-shadow:var(--swal2-input-hover-box-shadow)}div:where(.swal2-container) input:where(.swal2-input):focus,div:where(.swal2-container) input:where(.swal2-file):focus,div:where(.swal2-container) textarea:where(.swal2-textarea):focus{border:var(--swal2-input-focus-border);outline:none;box-shadow:var(--swal2-input-focus-box-shadow)}div:where(.swal2-container) input:where(.swal2-input)::placeholder,div:where(.swal2-container) input:where(.swal2-file)::placeholder,div:where(.swal2-container) textarea:where(.swal2-textarea)::placeholder{color:#ccc}div:where(.swal2-container) .swal2-range{margin:1em 2em 3px;background:var(--swal2-background)}div:where(.swal2-container) .swal2-range input{width:80%}div:where(.swal2-container) .swal2-range output{width:20%;color:inherit;font-weight:600;text-align:center}div:where(.swal2-container) .swal2-range input,div:where(.swal2-container) .swal2-range output{height:2.625em;padding:0;font-size:1.125em;line-height:2.625em}div:where(.swal2-container) .swal2-input{height:2.625em;padding:0 .75em}div:where(.swal2-container) .swal2-file{width:75%;margin-right:auto;margin-left:auto;background:var(--swal2-input-background);font-size:1.125em}div:where(.swal2-container) .swal2-textarea{height:6.75em;padding:.75em}div:where(.swal2-container) .swal2-select{min-width:50%;max-width:100%;padding:.375em .625em;background:var(--swal2-input-background);color:inherit;font-size:1.125em}div:where(.swal2-container) .swal2-radio,div:where(.swal2-container) .swal2-checkbox{align-items:center;justify-content:center;background:var(--swal2-background);color:inherit}div:where(.swal2-container) .swal2-radio label,div:where(.swal2-container) .swal2-checkbox label{margin:0 .6em;font-size:1.125em}div:where(.swal2-container) .swal2-radio input,div:where(.swal2-container) .swal2-checkbox input{flex-shrink:0;margin:0 .4em}div:where(.swal2-container) label:where(.swal2-input-label){display:flex;justify-content:center;margin:1em auto 0}div:where(.swal2-container) div:where(.swal2-validation-message){align-items:center;justify-content:center;margin:1em 0 0;padding:.625em;overflow:hidden;background:var(--swal2-validation-message-background);color:var(--swal2-validation-message-color);font-size:1em;font-weight:300}div:where(.swal2-container) div:where(.swal2-validation-message)::before{content:"!";display:inline-block;width:1.5em;min-width:1.5em;height:1.5em;margin:0 .625em;border-radius:50%;background-color:#f27474;color:#fff;font-weight:600;line-height:1.5em;text-align:center}div:where(.swal2-container) .swal2-progress-steps{flex-wrap:wrap;align-items:center;max-width:100%;margin:1.25em auto;padding:0;background:rgba(0,0,0,0);font-weight:600}div:where(.swal2-container) .swal2-progress-steps li{display:inline-block;position:relative}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step{z-index:20;flex-shrink:0;width:2em;height:2em;border-radius:2em;background:#2778c4;color:#fff;line-height:2em;text-align:center}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step{background:#2778c4}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step{background:var(--swal2-progress-step-background);color:#fff}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step-line{background:var(--swal2-progress-step-background)}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step-line{z-index:10;flex-shrink:0;width:2.5em;height:.4em;margin:0 -1px;background:#2778c4}div:where(.swal2-icon){position:relative;box-sizing:content-box;justify-content:center;width:5em;height:5em;margin:2.5em auto .6em;zoom:var(--swal2-icon-zoom);border:.25em solid rgba(0,0,0,0);border-radius:50%;border-color:#000;font-family:inherit;line-height:5em;cursor:default;user-select:none}div:where(.swal2-icon) .swal2-icon-content{display:flex;align-items:center;font-size:3.75em}div:where(.swal2-icon).swal2-error{border-color:#f27474;color:#f27474}div:where(.swal2-icon).swal2-error .swal2-x-mark{position:relative;flex-grow:1}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line]{display:block;position:absolute;top:2.3125em;width:2.9375em;height:.3125em;border-radius:.125em;background-color:#f27474}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=left]{left:1.0625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=right]{right:1em;transform:rotate(-45deg)}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-error.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-error.swal2-icon-show .swal2-x-mark{animation:swal2-animate-error-x-mark .5s}}div:where(.swal2-icon).swal2-warning{border-color:#f8bb86;color:#f8bb86}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-warning.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-warning.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .5s}}div:where(.swal2-icon).swal2-info{border-color:#3fc3ee;color:#3fc3ee}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-info.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-info.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .8s}}div:where(.swal2-icon).swal2-question{border-color:#87adbd;color:#87adbd}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-question.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-question.swal2-icon-show .swal2-icon-content{animation:swal2-animate-question-mark .8s}}div:where(.swal2-icon).swal2-success{border-color:#a5dc86;color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line]{position:absolute;width:3.75em;height:7.5em;border-radius:50%}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.4375em;left:-2.0635em;transform:rotate(-45deg);transform-origin:3.75em 3.75em;border-radius:7.5em 0 0 7.5em}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.6875em;left:1.875em;transform:rotate(-45deg);transform-origin:0 3.75em;border-radius:0 7.5em 7.5em 0}div:where(.swal2-icon).swal2-success .swal2-success-ring{position:absolute;z-index:2;top:-0.25em;left:-0.25em;box-sizing:content-box;width:100%;height:100%;border:.25em solid rgba(165,220,134,.3);border-radius:50%}div:where(.swal2-icon).swal2-success .swal2-success-fix{position:absolute;z-index:1;top:.5em;left:1.625em;width:.4375em;height:5.625em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line]{display:block;position:absolute;z-index:2;height:.3125em;border-radius:.125em;background-color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=tip]{top:2.875em;left:.8125em;width:1.5625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=long]{top:2.375em;right:.5em;width:2.9375em;transform:rotate(-45deg)}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-animate-success-line-tip .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-animate-success-line-long .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-circular-line-right{animation:swal2-rotate-success-circular-line 4.25s ease-in}}[class^=swal2]{-webkit-tap-highlight-color:rgba(0,0,0,0)}.swal2-show{animation:var(--swal2-show-animation)}.swal2-hide{animation:var(--swal2-hide-animation)}.swal2-noanimation{transition:none}.swal2-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}.swal2-rtl .swal2-close{margin-right:initial;margin-left:0}.swal2-rtl .swal2-timer-progress-bar{right:0;left:auto}.swal2-toast{box-sizing:border-box;grid-column:1/4 !important;grid-row:1/4 !important;grid-template-columns:min-content auto min-content;padding:1em;overflow-y:hidden;border:var(--swal2-toast-border);background:var(--swal2-background);box-shadow:var(--swal2-toast-box-shadow);pointer-events:all}.swal2-toast>*{grid-column:2}.swal2-toast h2:where(.swal2-title){margin:.5em 1em;padding:0;font-size:1em;text-align:initial}.swal2-toast .swal2-loading{justify-content:center}.swal2-toast input:where(.swal2-input){height:2em;margin:.5em;font-size:1em}.swal2-toast .swal2-validation-message{font-size:1em}.swal2-toast div:where(.swal2-footer){margin:.5em 0 0;padding:.5em 0 0;font-size:.8em}.swal2-toast button:where(.swal2-close){grid-column:3/3;grid-row:1/99;align-self:center;width:.8em;height:.8em;margin:0;font-size:2em}.swal2-toast div:where(.swal2-html-container){margin:.5em 1em;padding:0;overflow:initial;font-size:1em;text-align:initial}.swal2-toast div:where(.swal2-html-container):empty{padding:0}.swal2-toast .swal2-loader{grid-column:1;grid-row:1/99;align-self:center;width:2em;height:2em;margin:.25em}.swal2-toast .swal2-icon{grid-column:1;grid-row:1/99;align-self:center;width:2em;min-width:2em;height:2em;margin:0 .5em 0 0}.swal2-toast .swal2-icon .swal2-icon-content{display:flex;align-items:center;font-size:1.8em;font-weight:bold}.swal2-toast .swal2-icon.swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line]{top:.875em;width:1.375em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:.3125em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:.3125em}.swal2-toast div:where(.swal2-actions){justify-content:flex-start;height:auto;margin:0;margin-top:.5em;padding:0 .5em}.swal2-toast button:where(.swal2-styled){margin:.25em .5em;padding:.4em .6em;font-size:1em}.swal2-toast .swal2-success{border-color:#a5dc86}.swal2-toast .swal2-success [class^=swal2-success-circular-line]{position:absolute;width:1.6em;height:3em;border-radius:50%}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.8em;left:-0.5em;transform:rotate(-45deg);transform-origin:2em 2em;border-radius:4em 0 0 4em}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.25em;left:.9375em;transform-origin:0 1.5em;border-radius:0 4em 4em 0}.swal2-toast .swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-success .swal2-success-fix{top:0;left:.4375em;width:.4375em;height:2.6875em}.swal2-toast .swal2-success [class^=swal2-success-line]{height:.3125em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=tip]{top:1.125em;left:.1875em;width:.75em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=long]{top:.9375em;right:.1875em;width:1.375em}@container swal2-popup style(--swal2-icon-animations:true){.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-toast-animate-success-line-tip .75s}.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-toast-animate-success-line-long .75s}}.swal2-toast.swal2-show{animation:var(--swal2-toast-show-animation)}.swal2-toast.swal2-hide{animation:var(--swal2-toast-hide-animation)}@keyframes swal2-show{0%{transform:translate3d(0, -50px, 0) scale(0.9);opacity:0}100%{transform:translate3d(0, 0, 0) scale(1);opacity:1}}@keyframes swal2-hide{0%{transform:translate3d(0, 0, 0) scale(1);opacity:1}100%{transform:translate3d(0, -50px, 0) scale(0.9);opacity:0}}@keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-0.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.8125em;width:1.5625em}}@keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@keyframes swal2-rotate-success-circular-line{0%{transform:rotate(-45deg)}5%{transform:rotate(-45deg)}12%{transform:rotate(-405deg)}100%{transform:rotate(-405deg)}}@keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;transform:scale(0.4);opacity:0}50%{margin-top:1.625em;transform:scale(0.4);opacity:0}80%{margin-top:-0.375em;transform:scale(1.15)}100%{margin-top:0;transform:scale(1);opacity:1}}@keyframes swal2-animate-error-icon{0%{transform:rotateX(100deg);opacity:0}100%{transform:rotateX(0deg);opacity:1}}@keyframes swal2-rotate-loading{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}@keyframes swal2-animate-question-mark{0%{transform:rotateY(-360deg)}100%{transform:rotateY(0)}}@keyframes swal2-animate-i-mark{0%{transform:rotateZ(45deg);opacity:0}25%{transform:rotateZ(-25deg);opacity:.4}50%{transform:rotateZ(15deg);opacity:.8}75%{transform:rotateZ(-5deg);opacity:1}100%{transform:rotateX(0);opacity:1}}@keyframes swal2-toast-show{0%{transform:translateY(-0.625em) rotateZ(2deg)}33%{transform:translateY(0) rotateZ(-2deg)}66%{transform:translateY(0.3125em) rotateZ(2deg)}100%{transform:translateY(0) rotateZ(0deg)}}@keyframes swal2-toast-hide{100%{transform:rotateZ(1deg);opacity:0}}@keyframes swal2-toast-animate-success-line-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-0.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@keyframes swal2-toast-animate-success-line-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}');
const ew = (e) => {
  if (!/^\d{8}$/.test(e)) return !1;
  const t = [1, 2, 1, 2, 1, 2, 4, 1];
  let n = 0, o = 0;
  for (let r = 0; r < 8; r++) {
    const s = parseInt(e.charAt(r), 10) * t[r];
    if (s >= 10) {
      const a = Math.floor(s / 10), i = s % 10;
      r === 6 && a === 7 ? (n += 7, o += 8) : (n += a + i, o += a + i);
    } else
      n += s, o += s;
  }
  return n % 5 === 0 || o % 5 === 0;
}, tw = (e) => {
  let t = e.replace(/\D/g, "");
  t.length > 8 && (t = t.slice(0, 8));
  let n = "", o = !1;
  return t.length === 8 ? ew(t) ? o = !0 : n = "統編格式檢查錯誤，請確認號碼" : t.length > 0 && (n = `統編需為 8 位數字（目前已輸入 ${t.length} 碼）`), { value: t, error: n, isReady: o };
};
function nw(e) {
  const {
    paymentInfo: t,
    isLoading: n,
    paymentError: o,
    fetchPaymentInfoPaginated: r,
    createInvoice: s,
    queryCompanyName: a,
    voidPayment: i
  } = rd(e), l = Ve(void 0), p = Zs({
    currentPage: 1,
    totalPages: 1,
    limit: 10
  }), y = Ye(() => t.value ? Array.isArray(t.value) ? t.value : [t.value] : []), k = Ye(() => {
    let N = 0, h = 0, T = 0, m = 0;
    return y.value.forEach((g) => {
      const C = String(g.rtn_code);
      C === "1" ? (N += g.trade_amt ? Number(g.trade_amt) : 0, h++) : C === "0" ? T++ : m++;
    }), { totalAmount: N, successCount: h, pendingCount: T, failedCount: m };
  }), d = async (N = 1) => {
    try {
      const h = {
        page: N,
        limit: p.limit,
        rtn_code: l.value
      }, T = await r(h);
      p.currentPage = T.page, p.totalPages = T.total > 0 ? Math.ceil(T.total / T.limit) : 1;
    } catch {
    }
  };
  return {
    isLoading: n,
    paymentError: o,
    paymentsList: y,
    filterRtnCode: l,
    pagination: p,
    stats: k,
    loadPaymentInfo: d,
    changeFilter: async (N) => {
      l.value = N, await d(1);
    },
    createInvoice: s,
    queryCompanyName: a,
    voidPayment: i
  };
}
const ow = { class: "w-full bg-linear-to-br from-blue-700 to-blue-800 p-6 rounded-3xl text-white shadow-xl" }, rw = { class: "text-3xl sm:text-4xl font-black mt-2" }, sw = { class: "grid grid-cols-3 gap-2 text-center text-xs sm:text-sm" }, aw = { class: "bg-white/10 p-3 rounded-2xl" }, iw = { class: "text-lg font-bold mt-1" }, lw = { class: "bg-white/10 p-3 rounded-2xl" }, cw = { class: "text-lg font-bold mt-1" }, uw = { class: "bg-white/10 p-3 rounded-2xl" }, dw = { class: "text-lg font-bold mt-1" }, mw = /* @__PURE__ */ $t({
  __name: "PaymentStats",
  props: {
    totalAmount: {},
    successCount: {},
    pendingCount: {},
    failedCount: {}
  },
  setup(e) {
    return (t, n) => (X(), ee("div", ow, [
      n[3] || (n[3] = _("p", { class: "text-blue-100 opacity-90 font-medium text-sm" }, "總交易金額 (台幣)", -1)),
      _("h2", rw, "$ " + j(e.totalAmount.toLocaleString()), 1),
      n[4] || (n[4] = _("hr", { class: "border-white opacity-20 my-4" }, null, -1)),
      _("div", sw, [
        _("div", aw, [
          n[0] || (n[0] = _("p", { class: "text-blue-100 opacity-80" }, "成功", -1)),
          _("p", iw, j(e.successCount) + " 筆", 1)
        ]),
        _("div", lw, [
          n[1] || (n[1] = _("p", { class: "text-blue-100 opacity-80" }, "處理中", -1)),
          _("p", cw, j(e.pendingCount) + " 筆", 1)
        ]),
        _("div", uw, [
          n[2] || (n[2] = _("p", { class: "text-blue-100 opacity-80" }, "失敗", -1)),
          _("p", dw, j(e.failedCount) + " 筆", 1)
        ])
      ])
    ]));
  }
}), fw = { class: "w-full flex flex-col sm:flex-row sm:items-center justify-between gap-3 border-b border-gray-100 pb-4" }, ww = { class: "min-w-0 flex-1" }, pw = { class: "font-mono font-bold text-gray-700 text-sm sm:text-base mt-0.5 break-all" }, hw = {
  key: 0,
  class: "min-w-0 flex-1"
}, gw = { class: "flex items-start" }, bw = { class: "grid grid-cols-2 gap-4 text-sm border-b border-gray-100 pb-4" }, vw = { class: "text-lg sm:text-xl font-black text-gray-700 mt-1" }, yw = { class: "text-gray-700 font-medium mt-1 text-xs sm:text-sm" }, _w = { class: "text-xs text-gray-700 opacity-60 block mt-0.5" }, Ew = {
  key: 0,
  class: "bg-gray-50 rounded-2xl p-4"
}, kw = { class: "flex items-center justify-between mb-2" }, xw = { class: "text-xs font-bold text-gray-700 uppercase tracking-wider" }, Cw = { class: "text-xs bg-white text-gray-700 font-bold px-2 py-0.5 rounded-md border border-gray-200" }, Aw = { class: "flex flex-col gap-1.5" }, Lw = { class: "select-all break-all" }, Tw = {
  key: 1,
  class: "text-xs text-gray-700 font-medium bg-gray-50 p-3 rounded-2xl text-center"
}, Nw = {
  key: 2,
  class: "bg-blue-50/50 rounded-2xl p-4 border border-blue-100"
}, Ow = { class: "flex items-center justify-between mb-3" }, Pw = {
  key: 0,
  class: "flex items-center gap-2"
}, Iw = { class: "flex items-center gap-2" }, $w = ["href"], Sw = { class: "grid grid-cols-2 gap-y-3 gap-x-4 text-[11px]" }, Dw = { class: "font-mono font-bold text-gray-700" }, Mw = { class: "font-medium text-gray-700" }, Rw = { key: 0 }, Bw = { class: "font-mono font-bold text-gray-700" }, Fw = { key: 1 }, Uw = { class: "font-bold text-gray-700" }, Vw = { key: 2 }, Hw = { class: "font-mono font-bold text-gray-700" }, jw = {
  key: 0,
  class: "mt-3 pt-3 border-t border-red-100 flex flex-col gap-1"
}, Yw = { class: "text-[11px] text-red-600 font-medium" }, Ww = {
  key: 0,
  class: "bg-red-50 px-1 py-0.5 rounded mr-1"
}, qw = /* @__PURE__ */ $t({
  __name: "PaymentCard",
  props: {
    payment: {}
  },
  emits: ["clickCard"],
  setup(e, { emit: t }) {
    const { t: n } = fn(), o = e, r = t, s = {
      1: { text: "交易成功", className: "bg-green-100 text-green-700 border-green-200" },
      0: { text: "尚未付款", className: "bg-gray-100 text-black border-blue-700" },
      "-1": { text: "作廢", className: "bg-yellow-100 text-red-700 border-yellow-700" },
      default: { text: "交易失敗", className: "bg-rose-100 text-red-700 border-rose-200" }
    }, a = {
      issued: "已開立",
      voided: "已作廢",
      init: "新建立",
      cancelled: "已折讓",
      failed: "開立失敗"
    }, i = {
      COUNTER: { text: "櫃檯結帳", className: "bg-purple-50 text-purple-700 border-purple-200" },
      ONLINE: { text: "線上支付", className: "bg-indigo-50 text-indigo-700 border-indigo-200" },
      default: { text: "未知管道", className: "bg-gray-50 text-gray-600 border-gray-200" }
    }, l = Ye(() => String(o.payment.rtn_code) === "1"), p = Ye(() => {
      const d = String(o.payment.rtn_code);
      return d in s ? s[d] : s.default;
    }), y = Ye(() => {
      const d = o.payment.checkout_type;
      return d ? d in i ? i[d] : { text: d, className: i.default.className } : i.default;
    }), k = Ye(() => {
      var w;
      const d = (w = o.payment.invoice_transaction) == null ? void 0 : w.status;
      return d === "issued" ? "bg-blue-100 text-blue-700 border-blue-200" : d === "failed" ? "bg-red-100 text-red-700 border-red-200" : "bg-gray-100 text-gray-500 border-gray-200";
    });
    return (d, w) => {
      var N;
      return X(), ee("div", {
        onClick: w[1] || (w[1] = (h) => r("clickCard", e.payment)),
        class: tn([
          "bg-white rounded-3xl border border-gray-100 p-5 sm:p-6 shadow-sm hover:shadow-md transition-all duration-200 space-y-4",
          l.value ? "cursor-pointer hover:border-blue-300" : ""
        ])
      }, [
        _("div", fw, [
          _("div", ww, [
            w[2] || (w[2] = _("p", { class: "text-xs text-gray-700 opacity-60 uppercase tracking-wider" }, "交易編號", -1)),
            _("p", pw, j(e.payment.merchant_trade_no), 1)
          ]),
          e.payment.checkout_type ? (X(), ee("div", hw, [
            _("span", {
              class: tn([y.value.className, "px-2.5 py-1 rounded-lg text-xs font-semibold border whitespace-nowrap"])
            }, j(y.value.text), 3)
          ])) : Ue("", !0),
          _("div", gw, [
            _("span", {
              class: tn([p.value.className, "px-3 py-1.5 rounded-full text-xs font-black border whitespace-nowrap"])
            }, j(p.value.text), 3)
          ])
        ]),
        _("div", bw, [
          _("div", null, [
            w[3] || (w[3] = _("p", { class: "text-gray-700 opacity-60 text-xs" }, "交易金額", -1)),
            _("p", vw, " $ " + j(e.payment.trade_amt ? Number(e.payment.trade_amt).toLocaleString() : "0"), 1)
          ]),
          _("div", null, [
            w[4] || (w[4] = _("p", { class: "text-gray-700 opacity-60 text-xs" }, "建立時間", -1)),
            _("p", yw, [
              Lt(j(e.payment.created_at ? new Date(e.payment.created_at).toLocaleDateString() : "-") + " ", 1),
              _("span", _w, j(e.payment.created_at ? new Date(e.payment.created_at).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }) : ""), 1)
            ])
          ])
        ]),
        (N = e.payment.order_ids) != null && N.length ? (X(), ee("div", Ew, [
          _("div", kw, [
            _("p", xw, j(K(n)("ecpay.associatedOrders") || "關聯系統訂單ID"), 1),
            _("span", Cw, j(e.payment.order_ids.length) + " 筆 ", 1)
          ]),
          _("div", Aw, [
            (X(!0), ee(Nn, null, mr(e.payment.order_ids, (h) => (X(), ee("div", {
              key: h,
              class: "flex items-center gap-2 bg-white px-3 py-1.5 rounded-xl border border-gray-100 text-xs font-mono text-gray-700 shadow-xs"
            }, [
              w[5] || (w[5] = _("span", { class: "w-1.5 h-1.5 bg-blue-700 rounded-full shrink-0" }, null, -1)),
              _("span", Lw, j(h.slice(-3)), 1)
            ]))), 128))
          ])
        ])) : (X(), ee("div", Tw, " ⚠️ 找不到關聯的訂單交易紀錄 ")),
        e.payment.invoice_transaction ? (X(), ee("div", Nw, [
          _("div", Ow, [
            e.payment.invoice_transaction.status === "issued" ? (X(), ee("div", Pw, [...w[6] || (w[6] = [
              _("svg", {
                class: "w-4 h-4 text-blue-700",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, [
                _("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                })
              ], -1),
              _("p", { class: "text-xs font-bold text-blue-700 uppercase tracking-wider" }, "電子發票已開立", -1)
            ])])) : Ue("", !0),
            _("div", Iw, [
              _("span", {
                class: tn([k.value, "px-2 py-0.5 rounded text-[10px] font-bold border"])
              }, j(a[e.payment.invoice_transaction.status] || "未知狀態"), 3),
              e.payment.invoice_transaction.print_html ? (X(), ee("a", {
                key: 0,
                href: e.payment.invoice_transaction.print_html,
                target: "_blank",
                onClick: w[0] || (w[0] = kl(() => {
                }, ["stop"])),
                class: "text-[10px] bg-blue-700 text-white font-bold px-2 py-0.5 rounded hover:bg-blue-800 transition-colors"
              }, " 📄 檢視發票 ", 8, $w)) : Ue("", !0)
            ])
          ]),
          _("div", Sw, [
            _("div", null, [
              w[7] || (w[7] = _("p", { class: "text-gray-500 mb-0.5" }, "發票號碼", -1)),
              _("p", Dw, j(e.payment.invoice_transaction.invoice_no), 1)
            ]),
            _("div", null, [
              w[8] || (w[8] = _("p", { class: "text-gray-500 mb-0.5" }, "開立日期", -1)),
              _("p", Mw, j(e.payment.invoice_transaction.invoice_date ? new Date(e.payment.invoice_transaction.invoice_date).toLocaleDateString() : "-"), 1)
            ]),
            e.payment.invoice_transaction.customer_identifier ? (X(), ee("div", Rw, [
              w[9] || (w[9] = _("p", { class: "text-gray-500 mb-0.5" }, "買方統編", -1)),
              _("p", Bw, j(e.payment.invoice_transaction.customer_identifier), 1)
            ])) : Ue("", !0),
            e.payment.invoice_transaction.customer_name ? (X(), ee("div", Fw, [
              w[10] || (w[10] = _("p", { class: "text-gray-500 mb-0.5" }, "買受人名稱", -1)),
              _("p", Uw, j(e.payment.invoice_transaction.customer_name), 1)
            ])) : Ue("", !0),
            e.payment.invoice_transaction.carrier_num ? (X(), ee("div", Vw, [
              w[11] || (w[11] = _("p", { class: "text-gray-500 mb-0.5" }, "載具號碼", -1)),
              _("p", Hw, j(e.payment.invoice_transaction.carrier_num), 1)
            ])) : Ue("", !0)
          ]),
          e.payment.invoice_transaction.status === "failed" && (e.payment.invoice_transaction.error_message || e.payment.invoice_transaction.error_code) ? (X(), ee("div", jw, [
            w[12] || (w[12] = _("div", { class: "flex items-center gap-1.5 text-red-700" }, [
              _("svg", {
                class: "w-3.5 h-3.5",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, [
                _("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                })
              ]),
              _("p", { class: "text-[10px] font-black uppercase tracking-wider" }, "開立失敗原因")
            ], -1)),
            _("p", Yw, [
              e.payment.invoice_transaction.error_code ? (X(), ee("span", Ww, "[" + j(e.payment.invoice_transaction.error_code) + "]", 1)) : Ue("", !0),
              Lt(" " + j(e.payment.invoice_transaction.error_message), 1)
            ])
          ])) : Ue("", !0)
        ])) : Ue("", !0)
      ], 2);
    };
  }
});
/*!
* sweetalert2 v11.26.10
* Released under the MIT License.
*/
function xi(e, t, n) {
  if (typeof e == "function" ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
  throw new TypeError("Private element is not present on this object");
}
function zw(e, t) {
  if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function Fs(e, t) {
  return e.get(xi(e, t));
}
function Kw(e, t, n) {
  zw(e, t), t.set(e, n);
}
function Gw(e, t, n) {
  return e.set(xi(e, t), n), n;
}
const Xw = 100, U = {}, Zw = () => {
  U.previousActiveElement instanceof HTMLElement ? (U.previousActiveElement.focus(), U.previousActiveElement = null) : document.body && document.body.focus();
}, Jw = (e) => new Promise((t) => {
  if (!e)
    return t();
  const n = window.scrollX, o = window.scrollY;
  U.restoreFocusTimeout = setTimeout(() => {
    Zw(), t();
  }, Xw), window.scrollTo(n, o);
}), Ci = "swal2-", Qw = ["container", "shown", "height-auto", "iosfix", "popup", "modal", "no-backdrop", "no-transition", "toast", "toast-shown", "show", "hide", "close", "title", "html-container", "actions", "confirm", "deny", "cancel", "footer", "icon", "icon-content", "image", "input", "file", "range", "select", "radio", "checkbox", "label", "textarea", "inputerror", "input-label", "validation-message", "progress-steps", "active-progress-step", "progress-step", "progress-step-line", "loader", "loading", "styled", "top", "top-start", "top-end", "top-left", "top-right", "center", "center-start", "center-end", "center-left", "center-right", "bottom", "bottom-start", "bottom-end", "bottom-left", "bottom-right", "grow-row", "grow-column", "grow-fullscreen", "rtl", "timer-progress-bar", "timer-progress-bar-container", "scrollbar-measure", "icon-success", "icon-warning", "icon-info", "icon-question", "icon-error", "draggable", "dragging"], v = Qw.reduce(
  (e, t) => (e[t] = Ci + t, e),
  /** @type {SwalClasses} */
  {}
), ep = ["success", "warning", "info", "question", "error"], ao = ep.reduce(
  (e, t) => (e[t] = Ci + t, e),
  /** @type {SwalIcons} */
  {}
), Ai = "SweetAlert2:", Br = (e) => e.charAt(0).toUpperCase() + e.slice(1), Re = (e) => {
  console.warn(`${Ai} ${typeof e == "object" ? e.join(" ") : e}`);
}, Zt = (e) => {
  console.error(`${Ai} ${e}`);
}, Us = [], tp = (e) => {
  Us.includes(e) || (Us.push(e), Re(e));
}, Li = (e, t = null) => {
  tp(`"${e}" is deprecated and will be removed in the next major release.${t ? ` Use "${t}" instead.` : ""}`);
}, Co = (e) => typeof e == "function" ? e() : e, Fr = (e) => e && typeof e.toPromise == "function", Mn = (e) => Fr(e) ? e.toPromise() : Promise.resolve(e), Ur = (e) => e && Promise.resolve(e) === e, Fe = () => document.body.querySelector(`.${v.container}`), Rn = (e) => {
  const t = Fe();
  return t ? t.querySelector(e) : null;
}, Xe = (e) => Rn(`.${e}`), te = () => Xe(v.popup), bn = () => Xe(v.icon), np = () => Xe(v["icon-content"]), Ti = () => Xe(v.title), Vr = () => Xe(v["html-container"]), Ni = () => Xe(v.image), Hr = () => Xe(v["progress-steps"]), Ao = () => Xe(v["validation-message"]), gt = () => (
  /** @type {HTMLButtonElement} */
  Rn(`.${v.actions} .${v.confirm}`)
), vn = () => (
  /** @type {HTMLButtonElement} */
  Rn(`.${v.actions} .${v.cancel}`)
), Jt = () => (
  /** @type {HTMLButtonElement} */
  Rn(`.${v.actions} .${v.deny}`)
), op = () => Xe(v["input-label"]), yn = () => Rn(`.${v.loader}`), Bn = () => Xe(v.actions), Oi = () => Xe(v.footer), Lo = () => Xe(v["timer-progress-bar"]), jr = () => Xe(v.close), rp = `
  a[href],
  area[href],
  input:not([disabled]),
  select:not([disabled]),
  textarea:not([disabled]),
  button:not([disabled]),
  iframe,
  object,
  embed,
  [tabindex="0"],
  [contenteditable],
  audio[controls],
  video[controls],
  summary
`, Yr = () => {
  const e = te();
  if (!e)
    return [];
  const t = e.querySelectorAll('[tabindex]:not([tabindex="-1"]):not([tabindex="0"])'), n = Array.from(t).sort((s, a) => {
    const i = parseInt(s.getAttribute("tabindex") || "0"), l = parseInt(a.getAttribute("tabindex") || "0");
    return i > l ? 1 : i < l ? -1 : 0;
  }), o = e.querySelectorAll(rp), r = Array.from(o).filter((s) => s.getAttribute("tabindex") !== "-1");
  return [...new Set(n.concat(r))].filter((s) => je(s));
}, Wr = () => xt(document.body, v.shown) && !xt(document.body, v["toast-shown"]) && !xt(document.body, v["no-backdrop"]), To = () => {
  const e = te();
  return e ? xt(e, v.toast) : !1;
}, sp = () => {
  const e = te();
  return e ? e.hasAttribute("data-loading") : !1;
}, Ze = (e, t) => {
  if (e.textContent = "", t) {
    const o = new DOMParser().parseFromString(t, "text/html"), r = o.querySelector("head");
    r && Array.from(r.childNodes).forEach((a) => {
      e.appendChild(a);
    });
    const s = o.querySelector("body");
    s && Array.from(s.childNodes).forEach((a) => {
      a instanceof HTMLVideoElement || a instanceof HTMLAudioElement ? e.appendChild(a.cloneNode(!0)) : e.appendChild(a);
    });
  }
}, xt = (e, t) => {
  if (!t)
    return !1;
  const n = t.split(/\s+/);
  for (let o = 0; o < n.length; o++)
    if (!e.classList.contains(n[o]))
      return !1;
  return !0;
}, ap = (e, t) => {
  Array.from(e.classList).forEach((n) => {
    !Object.values(v).includes(n) && !Object.values(ao).includes(n) && !Object.values(t.showClass || {}).includes(n) && e.classList.remove(n);
  });
}, ze = (e, t, n) => {
  if (ap(e, t), !t.customClass)
    return;
  const o = t.customClass[
    /** @type {keyof SweetAlertCustomClass} */
    n
  ];
  if (o) {
    if (typeof o != "string" && !o.forEach) {
      Re(`Invalid type of customClass.${n}! Expected string or iterable object, got "${typeof o}"`);
      return;
    }
    re(e, o);
  }
}, No = (e, t) => {
  if (!t)
    return null;
  switch (t) {
    case "select":
    case "textarea":
    case "file":
      return e.querySelector(`.${v.popup} > .${v[t]}`);
    case "checkbox":
      return e.querySelector(`.${v.popup} > .${v.checkbox} input`);
    case "radio":
      return e.querySelector(`.${v.popup} > .${v.radio} input:checked`) || e.querySelector(`.${v.popup} > .${v.radio} input:first-child`);
    case "range":
      return e.querySelector(`.${v.popup} > .${v.range} input`);
    default:
      return e.querySelector(`.${v.popup} > .${v.input}`);
  }
}, Pi = (e) => {
  if (e.focus(), e.type !== "file") {
    const t = e.value;
    e.value = "", e.value = t;
  }
}, Ii = (e, t, n) => {
  !e || !t || (typeof t == "string" && (t = t.split(/\s+/).filter(Boolean)), t.forEach((o) => {
    Array.isArray(e) ? e.forEach((r) => {
      n ? r.classList.add(o) : r.classList.remove(o);
    }) : n ? e.classList.add(o) : e.classList.remove(o);
  }));
}, re = (e, t) => {
  Ii(e, t, !0);
}, rt = (e, t) => {
  Ii(e, t, !1);
}, Pt = (e, t) => {
  const n = Array.from(e.children);
  for (let o = 0; o < n.length; o++) {
    const r = n[o];
    if (r instanceof HTMLElement && xt(r, t))
      return r;
  }
}, Wt = (e, t, n) => {
  n === `${parseInt(`${n}`)}` && (n = parseInt(n)), n || parseInt(`${n}`) === 0 ? e.style.setProperty(t, typeof n == "number" ? `${n}px` : n) : e.style.removeProperty(t);
}, Ne = (e, t = "flex") => {
  e && (e.style.display = t);
}, De = (e) => {
  e && (e.style.display = "none");
}, qr = (e, t = "block") => {
  e && new MutationObserver(() => {
    Fn(e, e.innerHTML, t);
  }).observe(e, {
    childList: !0,
    subtree: !0
  });
}, Vs = (e, t, n, o) => {
  const r = e.querySelector(t);
  r && r.style.setProperty(n, o);
}, Fn = (e, t, n = "flex") => {
  t ? Ne(e, n) : De(e);
}, je = (e) => !!(e && (e.offsetWidth || e.offsetHeight || e.getClientRects().length)), ip = () => !je(gt()) && !je(Jt()) && !je(vn()), lr = (e) => e.scrollHeight > e.clientHeight, lp = (e, t) => {
  let n = e;
  for (; n && n !== t; ) {
    if (lr(n))
      return !0;
    n = n.parentElement;
  }
  return !1;
}, $i = (e) => {
  const t = window.getComputedStyle(e), n = parseFloat(t.getPropertyValue("animation-duration") || "0"), o = parseFloat(t.getPropertyValue("transition-duration") || "0");
  return n > 0 || o > 0;
}, zr = (e, t = !1) => {
  const n = Lo();
  n && je(n) && (t && (n.style.transition = "none", n.style.width = "100%"), setTimeout(() => {
    n.style.transition = `width ${e / 1e3}s linear`, n.style.width = "0%";
  }, 10));
}, cp = () => {
  const e = Lo();
  if (!e)
    return;
  const t = parseInt(window.getComputedStyle(e).width);
  e.style.removeProperty("transition"), e.style.width = "100%";
  const n = parseInt(window.getComputedStyle(e).width), o = t / n * 100;
  e.style.width = `${o}%`;
}, up = () => typeof window > "u" || typeof document > "u", dp = `
 <div aria-labelledby="${v.title}" aria-describedby="${v["html-container"]}" class="${v.popup}" tabindex="-1">
   <button type="button" class="${v.close}"></button>
   <ul class="${v["progress-steps"]}"></ul>
   <div class="${v.icon}"></div>
   <img class="${v.image}" />
   <h2 class="${v.title}" id="${v.title}"></h2>
   <div class="${v["html-container"]}" id="${v["html-container"]}"></div>
   <input class="${v.input}" id="${v.input}" />
   <input type="file" class="${v.file}" />
   <div class="${v.range}">
     <input type="range" />
     <output></output>
   </div>
   <select class="${v.select}" id="${v.select}"></select>
   <div class="${v.radio}"></div>
   <label class="${v.checkbox}">
     <input type="checkbox" id="${v.checkbox}" />
     <span class="${v.label}"></span>
   </label>
   <textarea class="${v.textarea}" id="${v.textarea}"></textarea>
   <div class="${v["validation-message"]}" id="${v["validation-message"]}"></div>
   <div class="${v.actions}">
     <div class="${v.loader}"></div>
     <button type="button" class="${v.confirm}"></button>
     <button type="button" class="${v.deny}"></button>
     <button type="button" class="${v.cancel}"></button>
   </div>
   <div class="${v.footer}"></div>
   <div class="${v["timer-progress-bar-container"]}">
     <div class="${v["timer-progress-bar"]}"></div>
   </div>
 </div>
`.replace(/(^|\n)\s*/g, ""), mp = () => {
  const e = Fe();
  return e ? (e.remove(), rt([document.documentElement, document.body], [v["no-backdrop"], v["toast-shown"], v["has-column"]]), !0) : !1;
}, Vt = () => {
  U.currentInstance.resetValidationMessage();
}, fp = () => {
  const e = te(), t = Pt(e, v.input), n = Pt(e, v.file), o = e.querySelector(`.${v.range} input`), r = e.querySelector(`.${v.range} output`), s = Pt(e, v.select), a = e.querySelector(`.${v.checkbox} input`), i = Pt(e, v.textarea);
  t.oninput = Vt, n.onchange = Vt, s.onchange = Vt, a.onchange = Vt, i.oninput = Vt, o.oninput = () => {
    Vt(), r.value = o.value;
  }, o.onchange = () => {
    Vt(), r.value = o.value;
  };
}, wp = (e) => typeof e == "string" ? document.querySelector(e) : e, pp = (e) => {
  const t = te();
  t.setAttribute("role", e.toast ? "alert" : "dialog"), t.setAttribute("aria-live", e.toast ? "polite" : "assertive"), e.toast || t.setAttribute("aria-modal", "true");
}, hp = (e) => {
  window.getComputedStyle(e).direction === "rtl" && (re(Fe(), v.rtl), U.isRTL = !0);
}, gp = (e) => {
  const t = mp();
  if (up()) {
    Zt("SweetAlert2 requires document to initialize");
    return;
  }
  const n = document.createElement("div");
  n.className = v.container, t && re(n, v["no-transition"]), Ze(n, dp), n.dataset.swal2Theme = e.theme;
  const o = wp(e.target);
  o.appendChild(n), e.topLayer && (n.setAttribute("popover", ""), n.showPopover()), pp(e), hp(o), fp();
}, Kr = (e, t) => {
  e instanceof HTMLElement ? t.appendChild(e) : typeof e == "object" ? bp(e, t) : e && Ze(t, e);
}, bp = (e, t) => {
  e.jquery ? vp(t, e) : Ze(t, e.toString());
}, vp = (e, t) => {
  if (e.textContent = "", 0 in t)
    for (let n = 0; n in t; n++)
      e.appendChild(t[n].cloneNode(!0));
  else
    e.appendChild(t.cloneNode(!0));
}, yp = (e, t) => {
  const n = Bn(), o = yn();
  !n || !o || (!t.showConfirmButton && !t.showDenyButton && !t.showCancelButton ? De(n) : Ne(n), ze(n, t, "actions"), _p(n, o, t), Ze(o, t.loaderHtml || ""), ze(o, t, "loader"));
};
function _p(e, t, n) {
  const o = gt(), r = Jt(), s = vn();
  !o || !r || !s || (Ho(o, "confirm", n), Ho(r, "deny", n), Ho(s, "cancel", n), Ep(o, r, s, n), n.reverseButtons && (n.toast ? (e.insertBefore(s, o), e.insertBefore(r, o)) : (e.insertBefore(s, t), e.insertBefore(r, t), e.insertBefore(o, t))));
}
function Ep(e, t, n, o) {
  if (!o.buttonsStyling) {
    rt([e, t, n], v.styled);
    return;
  }
  re([e, t, n], v.styled), o.confirmButtonColor && e.style.setProperty("--swal2-confirm-button-background-color", o.confirmButtonColor), o.denyButtonColor && t.style.setProperty("--swal2-deny-button-background-color", o.denyButtonColor), o.cancelButtonColor && n.style.setProperty("--swal2-cancel-button-background-color", o.cancelButtonColor), Vo(e), Vo(t), Vo(n);
}
function Vo(e) {
  const t = window.getComputedStyle(e);
  if (t.getPropertyValue("--swal2-action-button-focus-box-shadow"))
    return;
  const n = t.backgroundColor.replace(/rgba?\((\d+), (\d+), (\d+).*/, "rgba($1, $2, $3, 0.5)");
  e.style.setProperty("--swal2-action-button-focus-box-shadow", t.getPropertyValue("--swal2-outline").replace(/ rgba\(.*/, ` ${n}`));
}
function Ho(e, t, n) {
  const o = (
    /** @type {'Confirm' | 'Deny' | 'Cancel'} */
    Br(t)
  );
  Fn(e, n[`show${o}Button`], "inline-block"), Ze(e, n[`${t}ButtonText`] || ""), e.setAttribute("aria-label", n[`${t}ButtonAriaLabel`] || ""), e.className = v[t], ze(e, n, `${t}Button`);
}
const kp = (e, t) => {
  const n = jr();
  n && (Ze(n, t.closeButtonHtml || ""), ze(n, t, "closeButton"), Fn(n, t.showCloseButton), n.setAttribute("aria-label", t.closeButtonAriaLabel || ""));
}, xp = (e, t) => {
  const n = Fe();
  n && (Cp(n, t.backdrop), Ap(n, t.position), Lp(n, t.grow), ze(n, t, "container"));
};
function Cp(e, t) {
  typeof t == "string" ? e.style.background = t : t || re([document.documentElement, document.body], v["no-backdrop"]);
}
function Ap(e, t) {
  t && (t in v ? re(e, v[t]) : (Re('The "position" parameter is not valid, defaulting to "center"'), re(e, v.center)));
}
function Lp(e, t) {
  t && re(e, v[`grow-${t}`]);
}
var ue = {
  innerParams: /* @__PURE__ */ new WeakMap(),
  domCache: /* @__PURE__ */ new WeakMap()
};
const Tp = ["input", "file", "range", "select", "radio", "checkbox", "textarea"], Np = (e, t) => {
  const n = te();
  if (!n)
    return;
  const o = ue.innerParams.get(e), r = !o || t.input !== o.input;
  Tp.forEach((s) => {
    const a = Pt(n, v[s]);
    a && (Ip(s, t.inputAttributes), a.className = v[s], r && De(a));
  }), t.input && (r && Op(t), $p(t));
}, Op = (e) => {
  if (!e.input)
    return;
  if (!be[e.input]) {
    Zt(`Unexpected type of input! Expected ${Object.keys(be).join(" | ")}, got "${e.input}"`);
    return;
  }
  const t = Si(e.input);
  if (!t)
    return;
  const n = be[e.input](t, e);
  Ne(t), e.inputAutoFocus && setTimeout(() => {
    Pi(n);
  });
}, Pp = (e) => {
  for (let t = 0; t < e.attributes.length; t++) {
    const n = e.attributes[t].name;
    ["id", "type", "value", "style"].includes(n) || e.removeAttribute(n);
  }
}, Ip = (e, t) => {
  const n = te();
  if (!n)
    return;
  const o = No(n, e);
  if (o) {
    Pp(o);
    for (const r in t)
      o.setAttribute(r, t[r]);
  }
}, $p = (e) => {
  if (!e.input)
    return;
  const t = Si(e.input);
  t && ze(t, e, "input");
}, Gr = (e, t) => {
  !e.placeholder && t.inputPlaceholder && (e.placeholder = t.inputPlaceholder);
}, Un = (e, t, n) => {
  if (n.inputLabel) {
    const o = document.createElement("label"), r = v["input-label"];
    o.setAttribute("for", e.id), o.className = r, typeof n.customClass == "object" && re(o, n.customClass.inputLabel), o.innerText = n.inputLabel, t.insertAdjacentElement("beforebegin", o);
  }
}, Si = (e) => {
  const t = te();
  if (t)
    return Pt(t, v[
      /** @type {SwalClass} */
      e
    ] || v.input);
}, io = (e, t) => {
  ["string", "number"].includes(typeof t) ? e.value = `${t}` : Ur(t) || Re(`Unexpected type of inputValue! Expected "string", "number" or "Promise", got "${typeof t}"`);
}, be = {};
be.text = be.email = be.password = be.number = be.tel = be.url = be.search = be.date = be["datetime-local"] = be.time = be.week = be.month = /** @type {(input: Input | HTMLElement, params: SweetAlertOptions) => Input} */
(e, t) => (io(e, t.inputValue), Un(e, e, t), Gr(e, t), e.type = t.input, e);
be.file = (e, t) => (Un(e, e, t), Gr(e, t), e);
be.range = (e, t) => {
  const n = e.querySelector("input"), o = e.querySelector("output");
  return io(n, t.inputValue), n.type = t.input, io(o, t.inputValue), Un(n, e, t), e;
};
be.select = (e, t) => {
  if (e.textContent = "", t.inputPlaceholder) {
    const n = document.createElement("option");
    Ze(n, t.inputPlaceholder), n.value = "", n.disabled = !0, n.selected = !0, e.appendChild(n);
  }
  return Un(e, e, t), e;
};
be.radio = (e) => (e.textContent = "", e);
be.checkbox = (e, t) => {
  const n = No(te(), "checkbox");
  n.value = "1", n.checked = !!t.inputValue;
  const o = e.querySelector("span");
  return Ze(o, t.inputPlaceholder || t.inputLabel), n;
};
be.textarea = (e, t) => {
  io(e, t.inputValue), Gr(e, t), Un(e, e, t);
  const n = (o) => parseInt(window.getComputedStyle(o).marginLeft) + parseInt(window.getComputedStyle(o).marginRight);
  return setTimeout(() => {
    if ("MutationObserver" in window) {
      const o = parseInt(window.getComputedStyle(te()).width), r = () => {
        if (!document.body.contains(e))
          return;
        const s = e.offsetWidth + n(e);
        s > o ? te().style.width = `${s}px` : Wt(te(), "width", t.width);
      };
      new MutationObserver(r).observe(e, {
        attributes: !0,
        attributeFilter: ["style"]
      });
    }
  }), e;
};
const Sp = (e, t) => {
  const n = Vr();
  n && (qr(n), ze(n, t, "htmlContainer"), t.html ? (Kr(t.html, n), Ne(n, "block")) : t.text ? (n.textContent = t.text, Ne(n, "block")) : De(n), Np(e, t));
}, Dp = (e, t) => {
  const n = Oi();
  n && (qr(n), Fn(n, !!t.footer, "block"), t.footer && Kr(t.footer, n), ze(n, t, "footer"));
}, Mp = (e, t) => {
  const n = ue.innerParams.get(e), o = bn();
  if (!o)
    return;
  if (n && t.icon === n.icon) {
    js(o, t), Hs(o, t);
    return;
  }
  if (!t.icon && !t.iconHtml) {
    De(o);
    return;
  }
  if (t.icon && Object.keys(ao).indexOf(t.icon) === -1) {
    Zt(`Unknown icon! Expected "success", "error", "warning", "info" or "question", got "${t.icon}"`), De(o);
    return;
  }
  Ne(o), js(o, t), Hs(o, t), re(o, t.showClass && t.showClass.icon), window.matchMedia("(prefers-color-scheme: dark)").addEventListener("change", Di);
}, Hs = (e, t) => {
  for (const [n, o] of Object.entries(ao))
    t.icon !== n && rt(e, o);
  re(e, t.icon && ao[t.icon]), Fp(e, t), Di(), ze(e, t, "icon");
}, Di = () => {
  const e = te();
  if (!e)
    return;
  const t = window.getComputedStyle(e).getPropertyValue("background-color"), n = e.querySelectorAll("[class^=swal2-success-circular-line], .swal2-success-fix");
  for (let o = 0; o < n.length; o++)
    n[o].style.backgroundColor = t;
}, Rp = (e) => `
  ${e.animation ? '<div class="swal2-success-circular-line-left"></div>' : ""}
  <span class="swal2-success-line-tip"></span> <span class="swal2-success-line-long"></span>
  <div class="swal2-success-ring"></div>
  ${e.animation ? '<div class="swal2-success-fix"></div>' : ""}
  ${e.animation ? '<div class="swal2-success-circular-line-right"></div>' : ""}
`, Bp = `
  <span class="swal2-x-mark">
    <span class="swal2-x-mark-line-left"></span>
    <span class="swal2-x-mark-line-right"></span>
  </span>
`, js = (e, t) => {
  if (!t.icon && !t.iconHtml)
    return;
  let n = e.innerHTML, o = "";
  t.iconHtml ? o = Ys(t.iconHtml) : t.icon === "success" ? (o = Rp(t), n = n.replace(/ style=".*?"/g, "")) : t.icon === "error" ? o = Bp : t.icon && (o = Ys({
    question: "?",
    warning: "!",
    info: "i"
  }[t.icon])), n.trim() !== o.trim() && Ze(e, o);
}, Fp = (e, t) => {
  if (t.iconColor) {
    e.style.color = t.iconColor, e.style.borderColor = t.iconColor;
    for (const n of [".swal2-success-line-tip", ".swal2-success-line-long", ".swal2-x-mark-line-left", ".swal2-x-mark-line-right"])
      Vs(e, n, "background-color", t.iconColor);
    Vs(e, ".swal2-success-ring", "border-color", t.iconColor);
  }
}, Ys = (e) => `<div class="${v["icon-content"]}">${e}</div>`, Up = (e, t) => {
  const n = Ni();
  if (n) {
    if (!t.imageUrl) {
      De(n);
      return;
    }
    Ne(n, ""), n.setAttribute("src", t.imageUrl), n.setAttribute("alt", t.imageAlt || ""), Wt(n, "width", t.imageWidth), Wt(n, "height", t.imageHeight), n.className = v.image, ze(n, t, "image");
  }
};
let Xr = !1, Mi = 0, Ri = 0, Bi = 0, Fi = 0;
const Vp = (e) => {
  e.addEventListener("mousedown", lo), document.body.addEventListener("mousemove", co), e.addEventListener("mouseup", uo), e.addEventListener("touchstart", lo), document.body.addEventListener("touchmove", co), e.addEventListener("touchend", uo);
}, Hp = (e) => {
  e.removeEventListener("mousedown", lo), document.body.removeEventListener("mousemove", co), e.removeEventListener("mouseup", uo), e.removeEventListener("touchstart", lo), document.body.removeEventListener("touchmove", co), e.removeEventListener("touchend", uo);
}, lo = (e) => {
  const t = te();
  if (e.target === t || bn().contains(
    /** @type {HTMLElement} */
    e.target
  )) {
    Xr = !0;
    const n = Ui(e);
    Mi = n.clientX, Ri = n.clientY, Bi = parseInt(t.style.insetInlineStart) || 0, Fi = parseInt(t.style.insetBlockStart) || 0, re(t, "swal2-dragging");
  }
}, co = (e) => {
  const t = te();
  if (Xr) {
    let {
      clientX: n,
      clientY: o
    } = Ui(e);
    const r = n - Mi;
    t.style.insetInlineStart = `${Bi + (U.isRTL ? -r : r)}px`, t.style.insetBlockStart = `${Fi + (o - Ri)}px`;
  }
}, uo = () => {
  const e = te();
  Xr = !1, rt(e, "swal2-dragging");
}, Ui = (e) => {
  let t = 0, n = 0;
  return e.type.startsWith("mouse") ? (t = /** @type {MouseEvent} */
  e.clientX, n = /** @type {MouseEvent} */
  e.clientY) : e.type.startsWith("touch") && (t = /** @type {TouchEvent} */
  e.touches[0].clientX, n = /** @type {TouchEvent} */
  e.touches[0].clientY), {
    clientX: t,
    clientY: n
  };
}, jp = (e, t) => {
  const n = Fe(), o = te();
  if (!(!n || !o)) {
    if (t.toast) {
      Wt(n, "width", t.width), o.style.width = "100%";
      const r = yn();
      r && o.insertBefore(r, bn());
    } else
      Wt(o, "width", t.width);
    Wt(o, "padding", t.padding), t.color && (o.style.color = t.color), t.background && (o.style.background = t.background), De(Ao()), Yp(o, t), t.draggable && !t.toast ? (re(o, v.draggable), Vp(o)) : (rt(o, v.draggable), Hp(o));
  }
}, Yp = (e, t) => {
  const n = t.showClass || {};
  e.className = `${v.popup} ${je(e) ? n.popup : ""}`, t.toast ? (re([document.documentElement, document.body], v["toast-shown"]), re(e, v.toast)) : re(e, v.modal), ze(e, t, "popup"), typeof t.customClass == "string" && re(e, t.customClass), t.icon && re(e, v[`icon-${t.icon}`]);
}, Wp = (e, t) => {
  const n = Hr();
  if (!n)
    return;
  const {
    progressSteps: o,
    currentProgressStep: r
  } = t;
  if (!o || o.length === 0 || r === void 0) {
    De(n);
    return;
  }
  Ne(n), n.textContent = "", r >= o.length && Re("Invalid currentProgressStep parameter, it should be less than progressSteps.length (currentProgressStep like JS arrays starts from 0)"), o.forEach((s, a) => {
    const i = qp(s);
    if (n.appendChild(i), a === r && re(i, v["active-progress-step"]), a !== o.length - 1) {
      const l = zp(t);
      n.appendChild(l);
    }
  });
}, qp = (e) => {
  const t = document.createElement("li");
  return re(t, v["progress-step"]), Ze(t, e), t;
}, zp = (e) => {
  const t = document.createElement("li");
  return re(t, v["progress-step-line"]), e.progressStepsDistance && Wt(t, "width", e.progressStepsDistance), t;
}, Kp = (e, t) => {
  const n = Ti();
  n && (qr(n), Fn(n, !!(t.title || t.titleText), "block"), t.title && Kr(t.title, n), t.titleText && (n.innerText = t.titleText), ze(n, t, "title"));
}, Vi = (e, t) => {
  jp(e, t), xp(e, t), Wp(e, t), Mp(e, t), Up(e, t), Kp(e, t), kp(e, t), Sp(e, t), yp(e, t), Dp(e, t);
  const n = te();
  typeof t.didRender == "function" && n && t.didRender(n), U.eventEmitter.emit("didRender", n);
}, Gp = () => je(te()), Hi = () => {
  var e;
  return (e = gt()) === null || e === void 0 ? void 0 : e.click();
}, Xp = () => {
  var e;
  return (e = Jt()) === null || e === void 0 ? void 0 : e.click();
}, Zp = () => {
  var e;
  return (e = vn()) === null || e === void 0 ? void 0 : e.click();
}, _n = Object.freeze({
  cancel: "cancel",
  backdrop: "backdrop",
  close: "close",
  esc: "esc",
  timer: "timer"
}), ji = (e) => {
  e.keydownTarget && e.keydownHandlerAdded && (e.keydownTarget.removeEventListener("keydown", e.keydownHandler, {
    capture: e.keydownListenerCapture
  }), e.keydownHandlerAdded = !1);
}, Jp = (e, t, n) => {
  ji(e), t.toast || (e.keydownHandler = (o) => eh(t, o, n), e.keydownTarget = t.keydownListenerCapture ? window : te(), e.keydownListenerCapture = t.keydownListenerCapture, e.keydownTarget.addEventListener("keydown", e.keydownHandler, {
    capture: e.keydownListenerCapture
  }), e.keydownHandlerAdded = !0);
}, cr = (e, t) => {
  var n;
  const o = Yr();
  if (o.length) {
    e = e + t, e === -2 && (e = o.length - 1), e === o.length ? e = 0 : e === -1 && (e = o.length - 1), o[e].focus();
    return;
  }
  (n = te()) === null || n === void 0 || n.focus();
}, Yi = ["ArrowRight", "ArrowDown"], Qp = ["ArrowLeft", "ArrowUp"], eh = (e, t, n) => {
  e && (t.isComposing || t.keyCode === 229 || (e.stopKeydownPropagation && t.stopPropagation(), t.key === "Enter" ? th(t, e) : t.key === "Tab" ? nh(t) : [...Yi, ...Qp].includes(t.key) ? oh(t.key) : t.key === "Escape" && rh(t, e, n)));
}, th = (e, t) => {
  if (!Co(t.allowEnterKey))
    return;
  const n = No(te(), t.input);
  if (e.target && n && e.target instanceof HTMLElement && e.target.outerHTML === n.outerHTML) {
    if (["textarea", "file"].includes(t.input))
      return;
    Hi(), e.preventDefault();
  }
}, nh = (e) => {
  const t = e.target, n = Yr();
  let o = -1;
  for (let r = 0; r < n.length; r++)
    if (t === n[r]) {
      o = r;
      break;
    }
  e.shiftKey ? cr(o, -1) : cr(o, 1), e.stopPropagation(), e.preventDefault();
}, oh = (e) => {
  const t = Bn(), n = gt(), o = Jt(), r = vn();
  if (!t || !n || !o || !r)
    return;
  const s = [n, o, r];
  if (document.activeElement instanceof HTMLElement && !s.includes(document.activeElement))
    return;
  const a = Yi.includes(e) ? "nextElementSibling" : "previousElementSibling";
  let i = document.activeElement;
  if (i) {
    for (let l = 0; l < t.children.length; l++) {
      if (i = i[a], !i)
        return;
      if (i instanceof HTMLButtonElement && je(i))
        break;
    }
    i instanceof HTMLButtonElement && i.focus();
  }
}, rh = (e, t, n) => {
  e.preventDefault(), Co(t.allowEscapeKey) && n(_n.esc);
};
var un = {
  swalPromiseResolve: /* @__PURE__ */ new WeakMap(),
  swalPromiseReject: /* @__PURE__ */ new WeakMap()
};
const sh = () => {
  const e = Fe();
  Array.from(document.body.children).forEach((n) => {
    n.contains(e) || (n.hasAttribute("aria-hidden") && n.setAttribute("data-previous-aria-hidden", n.getAttribute("aria-hidden") || ""), n.setAttribute("aria-hidden", "true"));
  });
}, Wi = () => {
  Array.from(document.body.children).forEach((t) => {
    t.hasAttribute("data-previous-aria-hidden") ? (t.setAttribute("aria-hidden", t.getAttribute("data-previous-aria-hidden") || ""), t.removeAttribute("data-previous-aria-hidden")) : t.removeAttribute("aria-hidden");
  });
}, qi = typeof window < "u" && !!window.GestureEvent, ah = () => {
  if (qi && !xt(document.body, v.iosfix)) {
    const e = document.body.scrollTop;
    document.body.style.top = `${e * -1}px`, re(document.body, v.iosfix), ih();
  }
}, ih = () => {
  const e = Fe();
  if (!e)
    return;
  let t;
  e.ontouchstart = (n) => {
    t = lh(n);
  }, e.ontouchmove = (n) => {
    t && (n.preventDefault(), n.stopPropagation());
  };
}, lh = (e) => {
  const t = e.target, n = Fe(), o = Vr();
  return !n || !o || ch(e) || uh(e) ? !1 : t === n || !lr(n) && t instanceof HTMLElement && !lp(t, o) && // #2823
  t.tagName !== "INPUT" && // #1603
  t.tagName !== "TEXTAREA" && // #2266
  !(lr(o) && // #1944
  o.contains(t));
}, ch = (e) => e.touches && e.touches.length && e.touches[0].touchType === "stylus", uh = (e) => e.touches && e.touches.length > 1, dh = () => {
  if (xt(document.body, v.iosfix)) {
    const e = parseInt(document.body.style.top, 10);
    rt(document.body, v.iosfix), document.body.style.top = "", document.body.scrollTop = e * -1;
  }
}, mh = () => {
  const e = document.createElement("div");
  e.className = v["scrollbar-measure"], document.body.appendChild(e);
  const t = e.getBoundingClientRect().width - e.clientWidth;
  return document.body.removeChild(e), t;
};
let on = null;
const fh = (e) => {
  on === null && (document.body.scrollHeight > window.innerHeight || e === "scroll") && (on = parseInt(window.getComputedStyle(document.body).getPropertyValue("padding-right")), document.body.style.paddingRight = `${on + mh()}px`);
}, wh = () => {
  on !== null && (document.body.style.paddingRight = `${on}px`, on = null);
};
function zi(e, t, n, o) {
  To() ? Ws(e, o) : (Jw(n).then(() => Ws(e, o)), ji(U)), qi ? (t.setAttribute("style", "display:none !important"), t.removeAttribute("class"), t.innerHTML = "") : t.remove(), Wr() && (wh(), dh(), Wi()), ph();
}
function ph() {
  rt([document.documentElement, document.body], [v.shown, v["height-auto"], v["no-backdrop"], v["toast-shown"]]);
}
function It(e) {
  e = gh(e);
  const t = un.swalPromiseResolve.get(this), n = hh(this);
  this.isAwaitingPromise ? e.isDismissed || (Vn(this), t(e)) : n && t(e);
}
const hh = (e) => {
  const t = te();
  if (!t)
    return !1;
  const n = ue.innerParams.get(e);
  if (!n || xt(t, n.hideClass.popup))
    return !1;
  rt(t, n.showClass.popup), re(t, n.hideClass.popup);
  const o = Fe();
  return rt(o, n.showClass.backdrop), re(o, n.hideClass.backdrop), bh(e, t, n), !0;
};
function Ki(e) {
  const t = un.swalPromiseReject.get(this);
  Vn(this), t && t(e);
}
const Vn = (e) => {
  e.isAwaitingPromise && (delete e.isAwaitingPromise, ue.innerParams.get(e) || e._destroy());
}, gh = (e) => typeof e > "u" ? {
  isConfirmed: !1,
  isDenied: !1,
  isDismissed: !0
} : Object.assign({
  isConfirmed: !1,
  isDenied: !1,
  isDismissed: !1
}, e), bh = (e, t, n) => {
  var o;
  const r = Fe(), s = $i(t);
  typeof n.willClose == "function" && n.willClose(t), (o = U.eventEmitter) === null || o === void 0 || o.emit("willClose", t), s ? vh(e, t, r, n.returnFocus, n.didClose) : zi(e, r, n.returnFocus, n.didClose);
}, vh = (e, t, n, o, r) => {
  U.swalCloseEventFinishedCallback = zi.bind(null, e, n, o, r);
  const s = function(a) {
    if (a.target === t) {
      var i;
      (i = U.swalCloseEventFinishedCallback) === null || i === void 0 || i.call(U), delete U.swalCloseEventFinishedCallback, t.removeEventListener("animationend", s), t.removeEventListener("transitionend", s);
    }
  };
  t.addEventListener("animationend", s), t.addEventListener("transitionend", s);
}, Ws = (e, t) => {
  setTimeout(() => {
    var n;
    typeof t == "function" && t.bind(e.params)(), (n = U.eventEmitter) === null || n === void 0 || n.emit("didClose"), e._destroy && e._destroy();
  });
}, dn = (e) => {
  let t = te();
  if (t || new jt(), t = te(), !t)
    return;
  const n = yn();
  To() ? De(bn()) : yh(t, e), Ne(n), t.setAttribute("data-loading", "true"), t.setAttribute("aria-busy", "true"), t.focus();
}, yh = (e, t) => {
  const n = Bn(), o = yn();
  !n || !o || (!t && je(gt()) && (t = gt()), Ne(n), t && (De(t), o.setAttribute("data-button-to-replace", t.className), n.insertBefore(o, t)), re([e, n], v.loading));
}, _h = (e, t) => {
  t.input === "select" || t.input === "radio" ? Ah(e, t) : ["text", "email", "number", "tel", "textarea"].some((n) => n === t.input) && (Fr(t.inputValue) || Ur(t.inputValue)) && (dn(gt()), Lh(e, t));
}, Eh = (e, t) => {
  const n = e.getInput();
  if (!n)
    return null;
  switch (t.input) {
    case "checkbox":
      return kh(n);
    case "radio":
      return xh(n);
    case "file":
      return Ch(n);
    default:
      return t.inputAutoTrim ? n.value.trim() : n.value;
  }
}, kh = (e) => e.checked ? 1 : 0, xh = (e) => e.checked ? e.value : null, Ch = (e) => e.files && e.files.length ? e.getAttribute("multiple") !== null ? e.files : e.files[0] : null, Ah = (e, t) => {
  const n = te();
  if (!n)
    return;
  const o = (r) => {
    t.input === "select" ? Th(n, mo(r), t) : t.input === "radio" && Nh(n, mo(r), t);
  };
  Fr(t.inputOptions) || Ur(t.inputOptions) ? (dn(gt()), Mn(t.inputOptions).then((r) => {
    e.hideLoading(), o(r);
  })) : typeof t.inputOptions == "object" ? o(t.inputOptions) : Zt(`Unexpected type of inputOptions! Expected object, Map or Promise, got ${typeof t.inputOptions}`);
}, Lh = (e, t) => {
  const n = e.getInput();
  n && (De(n), Mn(t.inputValue).then((o) => {
    n.value = t.input === "number" ? `${parseFloat(o) || 0}` : `${o}`, Ne(n), n.focus(), e.hideLoading();
  }).catch((o) => {
    Zt(`Error in inputValue promise: ${o}`), n.value = "", Ne(n), n.focus(), e.hideLoading();
  }));
};
function Th(e, t, n) {
  const o = Pt(e, v.select);
  if (!o)
    return;
  const r = (s, a, i) => {
    const l = document.createElement("option");
    l.value = i, Ze(l, a), l.selected = Gi(i, n.inputValue), s.appendChild(l);
  };
  t.forEach((s) => {
    const a = s[0], i = s[1];
    if (Array.isArray(i)) {
      const l = document.createElement("optgroup");
      l.label = a, l.disabled = !1, o.appendChild(l), i.forEach((p) => r(l, p[1], p[0]));
    } else
      r(o, i, a);
  }), o.focus();
}
function Nh(e, t, n) {
  const o = Pt(e, v.radio);
  if (!o)
    return;
  t.forEach((s) => {
    const a = s[0], i = s[1], l = document.createElement("input"), p = document.createElement("label");
    l.type = "radio", l.name = v.radio, l.value = a, Gi(a, n.inputValue) && (l.checked = !0);
    const y = document.createElement("span");
    Ze(y, i), y.className = v.label, p.appendChild(l), p.appendChild(y), o.appendChild(p);
  });
  const r = o.querySelectorAll("input");
  r.length && r[0].focus();
}
const mo = (e) => {
  const t = [];
  return e instanceof Map ? e.forEach((n, o) => {
    let r = n;
    typeof r == "object" && (r = mo(r)), t.push([o, r]);
  }) : Object.keys(e).forEach((n) => {
    let o = e[n];
    typeof o == "object" && (o = mo(o)), t.push([n, o]);
  }), t;
}, Gi = (e, t) => !!t && t.toString() === e.toString(), Oh = (e) => {
  const t = ue.innerParams.get(e);
  e.disableButtons(), t.input ? Xi(e, "confirm") : Jr(e, !0);
}, Ph = (e) => {
  const t = ue.innerParams.get(e);
  e.disableButtons(), t.returnInputValueOnDeny ? Xi(e, "deny") : Zr(e, !1);
}, Ih = (e, t) => {
  e.disableButtons(), t(_n.cancel);
}, Xi = (e, t) => {
  const n = ue.innerParams.get(e);
  if (!n.input) {
    Zt(`The "input" parameter is needed to be set when using returnInputValueOn${Br(t)}`);
    return;
  }
  const o = e.getInput(), r = Eh(e, n);
  n.inputValidator ? $h(e, r, t) : o && !o.checkValidity() ? (e.enableButtons(), e.showValidationMessage(n.validationMessage || o.validationMessage)) : t === "deny" ? Zr(e, r) : Jr(e, r);
}, $h = (e, t, n) => {
  const o = ue.innerParams.get(e);
  e.disableInput(), Promise.resolve().then(() => Mn(o.inputValidator(t, o.validationMessage))).then((s) => {
    e.enableButtons(), e.enableInput(), s ? e.showValidationMessage(s) : n === "deny" ? Zr(e, t) : Jr(e, t);
  });
}, Zr = (e, t) => {
  const n = ue.innerParams.get(e || void 0);
  n.showLoaderOnDeny && dn(Jt()), n.preDeny ? (e.isAwaitingPromise = !0, Promise.resolve().then(() => Mn(n.preDeny(t, n.validationMessage))).then((r) => {
    r === !1 ? (e.hideLoading(), Vn(e)) : e.close(
      /** @type SweetAlertResult */
      {
        isDenied: !0,
        value: typeof r > "u" ? t : r
      }
    );
  }).catch((r) => Zi(e || void 0, r))) : e.close(
    /** @type SweetAlertResult */
    {
      isDenied: !0,
      value: t
    }
  );
}, qs = (e, t) => {
  e.close(
    /** @type SweetAlertResult */
    {
      isConfirmed: !0,
      value: t
    }
  );
}, Zi = (e, t) => {
  e.rejectPromise(t);
}, Jr = (e, t) => {
  const n = ue.innerParams.get(e || void 0);
  n.showLoaderOnConfirm && dn(), n.preConfirm ? (e.resetValidationMessage(), e.isAwaitingPromise = !0, Promise.resolve().then(() => Mn(n.preConfirm(t, n.validationMessage))).then((r) => {
    je(Ao()) || r === !1 ? (e.hideLoading(), Vn(e)) : qs(e, typeof r > "u" ? t : r);
  }).catch((r) => Zi(e || void 0, r))) : qs(e, t);
};
function fo() {
  const e = ue.innerParams.get(this);
  if (!e)
    return;
  const t = ue.domCache.get(this);
  De(t.loader), To() ? e.icon && Ne(bn()) : Sh(t), rt([t.popup, t.actions], v.loading), t.popup.removeAttribute("aria-busy"), t.popup.removeAttribute("data-loading"), t.confirmButton.disabled = !1, t.denyButton.disabled = !1, t.cancelButton.disabled = !1;
}
const Sh = (e) => {
  const t = e.popup.getElementsByClassName(e.loader.getAttribute("data-button-to-replace"));
  t.length ? Ne(t[0], "inline-block") : ip() && De(e.actions);
};
function Ji() {
  const e = ue.innerParams.get(this), t = ue.domCache.get(this);
  return t ? No(t.popup, e.input) : null;
}
function Qi(e, t, n) {
  const o = ue.domCache.get(e);
  t.forEach((r) => {
    o[r].disabled = n;
  });
}
function el(e, t) {
  const n = te();
  if (!(!n || !e))
    if (e.type === "radio") {
      const o = n.querySelectorAll(`[name="${v.radio}"]`);
      for (let r = 0; r < o.length; r++)
        o[r].disabled = t;
    } else
      e.disabled = t;
}
function tl() {
  Qi(this, ["confirmButton", "denyButton", "cancelButton"], !1);
}
function nl() {
  Qi(this, ["confirmButton", "denyButton", "cancelButton"], !0);
}
function ol() {
  el(this.getInput(), !1);
}
function rl() {
  el(this.getInput(), !0);
}
function sl(e) {
  const t = ue.domCache.get(this), n = ue.innerParams.get(this);
  Ze(t.validationMessage, e), t.validationMessage.className = v["validation-message"], n.customClass && n.customClass.validationMessage && re(t.validationMessage, n.customClass.validationMessage), Ne(t.validationMessage);
  const o = this.getInput();
  o && (o.setAttribute("aria-invalid", "true"), o.setAttribute("aria-describedby", v["validation-message"]), Pi(o), re(o, v.inputerror));
}
function al() {
  const e = ue.domCache.get(this);
  e.validationMessage && De(e.validationMessage);
  const t = this.getInput();
  t && (t.removeAttribute("aria-invalid"), t.removeAttribute("aria-describedby"), rt(t, v.inputerror));
}
const rn = {
  title: "",
  titleText: "",
  text: "",
  html: "",
  footer: "",
  icon: void 0,
  iconColor: void 0,
  iconHtml: void 0,
  template: void 0,
  toast: !1,
  draggable: !1,
  animation: !0,
  theme: "light",
  showClass: {
    popup: "swal2-show",
    backdrop: "swal2-backdrop-show",
    icon: "swal2-icon-show"
  },
  hideClass: {
    popup: "swal2-hide",
    backdrop: "swal2-backdrop-hide",
    icon: "swal2-icon-hide"
  },
  customClass: {},
  target: "body",
  color: void 0,
  backdrop: !0,
  heightAuto: !0,
  allowOutsideClick: !0,
  allowEscapeKey: !0,
  allowEnterKey: !0,
  stopKeydownPropagation: !0,
  keydownListenerCapture: !1,
  showConfirmButton: !0,
  showDenyButton: !1,
  showCancelButton: !1,
  preConfirm: void 0,
  preDeny: void 0,
  confirmButtonText: "OK",
  confirmButtonAriaLabel: "",
  confirmButtonColor: void 0,
  denyButtonText: "No",
  denyButtonAriaLabel: "",
  denyButtonColor: void 0,
  cancelButtonText: "Cancel",
  cancelButtonAriaLabel: "",
  cancelButtonColor: void 0,
  buttonsStyling: !0,
  reverseButtons: !1,
  focusConfirm: !0,
  focusDeny: !1,
  focusCancel: !1,
  returnFocus: !0,
  showCloseButton: !1,
  closeButtonHtml: "&times;",
  closeButtonAriaLabel: "Close this dialog",
  loaderHtml: "",
  showLoaderOnConfirm: !1,
  showLoaderOnDeny: !1,
  imageUrl: void 0,
  imageWidth: void 0,
  imageHeight: void 0,
  imageAlt: "",
  timer: void 0,
  timerProgressBar: !1,
  width: void 0,
  padding: void 0,
  background: void 0,
  input: void 0,
  inputPlaceholder: "",
  inputLabel: "",
  inputValue: "",
  inputOptions: {},
  inputAutoFocus: !0,
  inputAutoTrim: !0,
  inputAttributes: {},
  inputValidator: void 0,
  returnInputValueOnDeny: !1,
  validationMessage: void 0,
  grow: !1,
  position: "center",
  progressSteps: [],
  currentProgressStep: void 0,
  progressStepsDistance: void 0,
  willOpen: void 0,
  didOpen: void 0,
  didRender: void 0,
  willClose: void 0,
  didClose: void 0,
  didDestroy: void 0,
  scrollbarPadding: !0,
  topLayer: !1
}, Dh = ["allowEscapeKey", "allowOutsideClick", "background", "buttonsStyling", "cancelButtonAriaLabel", "cancelButtonColor", "cancelButtonText", "closeButtonAriaLabel", "closeButtonHtml", "color", "confirmButtonAriaLabel", "confirmButtonColor", "confirmButtonText", "currentProgressStep", "customClass", "denyButtonAriaLabel", "denyButtonColor", "denyButtonText", "didClose", "didDestroy", "draggable", "footer", "hideClass", "html", "icon", "iconColor", "iconHtml", "imageAlt", "imageHeight", "imageUrl", "imageWidth", "preConfirm", "preDeny", "progressSteps", "returnFocus", "reverseButtons", "showCancelButton", "showCloseButton", "showConfirmButton", "showDenyButton", "text", "title", "titleText", "theme", "willClose"], Mh = {
  allowEnterKey: void 0
}, Rh = ["allowOutsideClick", "allowEnterKey", "backdrop", "draggable", "focusConfirm", "focusDeny", "focusCancel", "returnFocus", "heightAuto", "keydownListenerCapture"], il = (e) => Object.prototype.hasOwnProperty.call(rn, e), ll = (e) => Dh.indexOf(e) !== -1, cl = (e) => Mh[e], Bh = (e) => {
  il(e) || Re(`Unknown parameter "${e}"`);
}, Fh = (e) => {
  Rh.includes(e) && Re(`The parameter "${e}" is incompatible with toasts`);
}, Uh = (e) => {
  const t = cl(e);
  t && Li(e, t);
}, ul = (e) => {
  e.backdrop === !1 && e.allowOutsideClick && Re('"allowOutsideClick" parameter requires `backdrop` parameter to be set to `true`'), e.theme && !["light", "dark", "auto", "minimal", "borderless", "bootstrap-4", "bootstrap-4-light", "bootstrap-4-dark", "bootstrap-5", "bootstrap-5-light", "bootstrap-5-dark", "material-ui", "material-ui-light", "material-ui-dark", "embed-iframe", "bulma", "bulma-light", "bulma-dark"].includes(e.theme) && Re(`Invalid theme "${e.theme}"`);
  for (const t in e)
    Bh(t), e.toast && Fh(t), Uh(t);
};
function dl(e) {
  const t = Fe(), n = te(), o = ue.innerParams.get(this);
  if (!n || xt(n, o.hideClass.popup)) {
    Re("You're trying to update the closed or closing popup, that won't work. Use the update() method in preConfirm parameter or show a new popup.");
    return;
  }
  const r = Vh(e), s = Object.assign({}, o, r);
  ul(s), t.dataset.swal2Theme = s.theme, Vi(this, s), ue.innerParams.set(this, s), Object.defineProperties(this, {
    params: {
      value: Object.assign({}, this.params, e),
      writable: !1,
      enumerable: !0
    }
  });
}
const Vh = (e) => {
  const t = {};
  return Object.keys(e).forEach((n) => {
    ll(n) ? t[n] = e[n] : Re(`Invalid parameter to update: ${n}`);
  }), t;
};
function ml() {
  const e = ue.domCache.get(this), t = ue.innerParams.get(this);
  if (!t) {
    fl(this);
    return;
  }
  e.popup && U.swalCloseEventFinishedCallback && (U.swalCloseEventFinishedCallback(), delete U.swalCloseEventFinishedCallback), typeof t.didDestroy == "function" && t.didDestroy(), U.eventEmitter.emit("didDestroy"), Hh(this);
}
const Hh = (e) => {
  fl(e), delete e.params, delete U.keydownHandler, delete U.keydownTarget, delete U.currentInstance;
}, fl = (e) => {
  e.isAwaitingPromise ? (jo(ue, e), e.isAwaitingPromise = !0) : (jo(un, e), jo(ue, e), delete e.isAwaitingPromise, delete e.disableButtons, delete e.enableButtons, delete e.getInput, delete e.disableInput, delete e.enableInput, delete e.hideLoading, delete e.disableLoading, delete e.showValidationMessage, delete e.resetValidationMessage, delete e.close, delete e.closePopup, delete e.closeModal, delete e.closeToast, delete e.rejectPromise, delete e.update, delete e._destroy);
}, jo = (e, t) => {
  for (const n in e)
    e[n].delete(t);
};
var jh = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  _destroy: ml,
  close: It,
  closeModal: It,
  closePopup: It,
  closeToast: It,
  disableButtons: nl,
  disableInput: rl,
  disableLoading: fo,
  enableButtons: tl,
  enableInput: ol,
  getInput: Ji,
  handleAwaitingPromise: Vn,
  hideLoading: fo,
  rejectPromise: Ki,
  resetValidationMessage: al,
  showValidationMessage: sl,
  update: dl
});
const Yh = (e, t, n) => {
  e.toast ? Wh(e, t, n) : (zh(t), Kh(t), Gh(e, t, n));
}, Wh = (e, t, n) => {
  t.popup.onclick = () => {
    e && (qh(e) || e.timer || e.input) || n(_n.close);
  };
}, qh = (e) => !!(e.showConfirmButton || e.showDenyButton || e.showCancelButton || e.showCloseButton);
let wo = !1;
const zh = (e) => {
  e.popup.onmousedown = () => {
    e.container.onmouseup = function(t) {
      e.container.onmouseup = () => {
      }, t.target === e.container && (wo = !0);
    };
  };
}, Kh = (e) => {
  e.container.onmousedown = (t) => {
    t.target === e.container && t.preventDefault(), e.popup.onmouseup = function(n) {
      e.popup.onmouseup = () => {
      }, (n.target === e.popup || n.target instanceof HTMLElement && e.popup.contains(n.target)) && (wo = !0);
    };
  };
}, Gh = (e, t, n) => {
  t.container.onclick = (o) => {
    if (wo) {
      wo = !1;
      return;
    }
    o.target === t.container && Co(e.allowOutsideClick) && n(_n.backdrop);
  };
}, Xh = (e) => typeof e == "object" && e.jquery, zs = (e) => e instanceof Element || Xh(e), Zh = (e) => {
  const t = {};
  return typeof e[0] == "object" && !zs(e[0]) ? Object.assign(t, e[0]) : ["title", "html", "icon"].forEach((n, o) => {
    const r = e[o];
    typeof r == "string" || zs(r) ? t[n] = r : r !== void 0 && Zt(`Unexpected type of ${n}! Expected "string" or "Element", got ${typeof r}`);
  }), t;
};
function Jh(...e) {
  return new this(...e);
}
function Qh(e) {
  class t extends this {
    _main(o, r) {
      return super._main(o, Object.assign({}, e, r));
    }
  }
  return t;
}
const eg = () => U.timeout && U.timeout.getTimerLeft(), wl = () => {
  if (U.timeout)
    return cp(), U.timeout.stop();
}, pl = () => {
  if (U.timeout) {
    const e = U.timeout.start();
    return zr(e), e;
  }
}, tg = () => {
  const e = U.timeout;
  return e && (e.running ? wl() : pl());
}, ng = (e) => {
  if (U.timeout) {
    const t = U.timeout.increase(e);
    return zr(t, !0), t;
  }
}, og = () => !!(U.timeout && U.timeout.isRunning());
let Ks = !1;
const ur = {};
function rg(e = "data-swal-template") {
  ur[e] = this, Ks || (document.body.addEventListener("click", sg), Ks = !0);
}
const sg = (e) => {
  for (let t = e.target; t && t !== document; t = t.parentNode)
    for (const n in ur) {
      const o = t.getAttribute(n);
      if (o) {
        ur[n].fire({
          template: o
        });
        return;
      }
    }
};
class ag {
  constructor() {
    this.events = {};
  }
  /**
   * @param {string} eventName
   * @returns {EventHandlers}
   */
  _getHandlersByEventName(t) {
    return typeof this.events[t] > "u" && (this.events[t] = []), this.events[t];
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  on(t, n) {
    const o = this._getHandlersByEventName(t);
    o.includes(n) || o.push(n);
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  once(t, n) {
    const o = (...r) => {
      this.removeListener(t, o), n.apply(this, r);
    };
    this.on(t, o);
  }
  /**
   * @param {string} eventName
   * @param {Array} args
   */
  emit(t, ...n) {
    this._getHandlersByEventName(t).forEach(
      /**
       * @param {EventHandler} eventHandler
       */
      (o) => {
        try {
          o.apply(this, n);
        } catch (r) {
          console.error(r);
        }
      }
    );
  }
  /**
   * @param {string} eventName
   * @param {EventHandler} eventHandler
   */
  removeListener(t, n) {
    const o = this._getHandlersByEventName(t), r = o.indexOf(n);
    r > -1 && o.splice(r, 1);
  }
  /**
   * @param {string} eventName
   */
  removeAllListeners(t) {
    this.events[t] !== void 0 && (this.events[t].length = 0);
  }
  reset() {
    this.events = {};
  }
}
U.eventEmitter = new ag();
const ig = (e, t) => {
  U.eventEmitter.on(e, t);
}, lg = (e, t) => {
  U.eventEmitter.once(e, t);
}, cg = (e, t) => {
  if (!e) {
    U.eventEmitter.reset();
    return;
  }
  t ? U.eventEmitter.removeListener(e, t) : U.eventEmitter.removeAllListeners(e);
};
var ug = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  argsToParams: Zh,
  bindClickHandler: rg,
  clickCancel: Zp,
  clickConfirm: Hi,
  clickDeny: Xp,
  enableLoading: dn,
  fire: Jh,
  getActions: Bn,
  getCancelButton: vn,
  getCloseButton: jr,
  getConfirmButton: gt,
  getContainer: Fe,
  getDenyButton: Jt,
  getFocusableElements: Yr,
  getFooter: Oi,
  getHtmlContainer: Vr,
  getIcon: bn,
  getIconContent: np,
  getImage: Ni,
  getInputLabel: op,
  getLoader: yn,
  getPopup: te,
  getProgressSteps: Hr,
  getTimerLeft: eg,
  getTimerProgressBar: Lo,
  getTitle: Ti,
  getValidationMessage: Ao,
  increaseTimer: ng,
  isDeprecatedParameter: cl,
  isLoading: sp,
  isTimerRunning: og,
  isUpdatableParameter: ll,
  isValidParameter: il,
  isVisible: Gp,
  mixin: Qh,
  off: cg,
  on: ig,
  once: lg,
  resumeTimer: pl,
  showLoading: dn,
  stopTimer: wl,
  toggleTimer: tg
});
class dg {
  /**
   * @param {() => void} callback
   * @param {number} delay
   */
  constructor(t, n) {
    this.callback = t, this.remaining = n, this.running = !1, this.start();
  }
  /**
   * @returns {number}
   */
  start() {
    return this.running || (this.running = !0, this.started = /* @__PURE__ */ new Date(), this.id = setTimeout(this.callback, this.remaining)), this.remaining;
  }
  /**
   * @returns {number}
   */
  stop() {
    return this.started && this.running && (this.running = !1, clearTimeout(this.id), this.remaining -= (/* @__PURE__ */ new Date()).getTime() - this.started.getTime()), this.remaining;
  }
  /**
   * @param {number} n
   * @returns {number}
   */
  increase(t) {
    const n = this.running;
    return n && this.stop(), this.remaining += t, n && this.start(), this.remaining;
  }
  /**
   * @returns {number}
   */
  getTimerLeft() {
    return this.running && (this.stop(), this.start()), this.remaining;
  }
  /**
   * @returns {boolean}
   */
  isRunning() {
    return this.running;
  }
}
const hl = ["swal-title", "swal-html", "swal-footer"], mg = (e) => {
  const t = typeof e.template == "string" ? (
    /** @type {HTMLTemplateElement} */
    document.querySelector(e.template)
  ) : e.template;
  if (!t)
    return {};
  const n = t.content;
  return yg(n), Object.assign(fg(n), wg(n), pg(n), hg(n), gg(n), bg(n), vg(n, hl));
}, fg = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-param")).forEach((o) => {
    Kt(o, ["name", "value"]);
    const r = (
      /** @type {keyof SweetAlertOptions} */
      o.getAttribute("name")
    ), s = o.getAttribute("value");
    !r || !s || (typeof rn[r] == "boolean" ? t[r] = s !== "false" : typeof rn[r] == "object" ? t[r] = JSON.parse(s) : t[r] = s);
  }), t;
}, wg = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-function-param")).forEach((o) => {
    const r = (
      /** @type {keyof SweetAlertOptions} */
      o.getAttribute("name")
    ), s = o.getAttribute("value");
    !r || !s || (t[r] = new Function(`return ${s}`)());
  }), t;
}, pg = (e) => {
  const t = {};
  return Array.from(e.querySelectorAll("swal-button")).forEach((o) => {
    Kt(o, ["type", "color", "aria-label"]);
    const r = o.getAttribute("type");
    !r || !["confirm", "cancel", "deny"].includes(r) || (t[`${r}ButtonText`] = o.innerHTML, t[`show${Br(r)}Button`] = !0, o.hasAttribute("color") && (t[`${r}ButtonColor`] = o.getAttribute("color")), o.hasAttribute("aria-label") && (t[`${r}ButtonAriaLabel`] = o.getAttribute("aria-label")));
  }), t;
}, hg = (e) => {
  const t = {}, n = e.querySelector("swal-image");
  return n && (Kt(n, ["src", "width", "height", "alt"]), n.hasAttribute("src") && (t.imageUrl = n.getAttribute("src") || void 0), n.hasAttribute("width") && (t.imageWidth = n.getAttribute("width") || void 0), n.hasAttribute("height") && (t.imageHeight = n.getAttribute("height") || void 0), n.hasAttribute("alt") && (t.imageAlt = n.getAttribute("alt") || void 0)), t;
}, gg = (e) => {
  const t = {}, n = e.querySelector("swal-icon");
  return n && (Kt(n, ["type", "color"]), n.hasAttribute("type") && (t.icon = n.getAttribute("type")), n.hasAttribute("color") && (t.iconColor = n.getAttribute("color")), t.iconHtml = n.innerHTML), t;
}, bg = (e) => {
  const t = {}, n = e.querySelector("swal-input");
  n && (Kt(n, ["type", "label", "placeholder", "value"]), t.input = n.getAttribute("type") || "text", n.hasAttribute("label") && (t.inputLabel = n.getAttribute("label")), n.hasAttribute("placeholder") && (t.inputPlaceholder = n.getAttribute("placeholder")), n.hasAttribute("value") && (t.inputValue = n.getAttribute("value")));
  const o = Array.from(e.querySelectorAll("swal-input-option"));
  return o.length && (t.inputOptions = {}, o.forEach((r) => {
    Kt(r, ["value"]);
    const s = r.getAttribute("value");
    if (!s)
      return;
    const a = r.innerHTML;
    t.inputOptions[s] = a;
  })), t;
}, vg = (e, t) => {
  const n = {};
  for (const o in t) {
    const r = t[o], s = e.querySelector(r);
    s && (Kt(s, []), n[r.replace(/^swal-/, "")] = s.innerHTML.trim());
  }
  return n;
}, yg = (e) => {
  const t = hl.concat(["swal-param", "swal-function-param", "swal-button", "swal-image", "swal-icon", "swal-input", "swal-input-option"]);
  Array.from(e.children).forEach((n) => {
    const o = n.tagName.toLowerCase();
    t.includes(o) || Re(`Unrecognized element <${o}>`);
  });
}, Kt = (e, t) => {
  Array.from(e.attributes).forEach((n) => {
    t.indexOf(n.name) === -1 && Re([`Unrecognized attribute "${n.name}" on <${e.tagName.toLowerCase()}>.`, `${t.length ? `Allowed attributes are: ${t.join(", ")}` : "To set the value, use HTML within the element."}`]);
  });
}, gl = 10, _g = (e) => {
  const t = Fe(), n = te();
  typeof e.willOpen == "function" && e.willOpen(n), U.eventEmitter.emit("willOpen", n);
  const r = window.getComputedStyle(document.body).overflowY;
  xg(t, n, e), setTimeout(() => {
    Eg(t, n);
  }, gl), Wr() && (kg(t, e.scrollbarPadding, r), sh()), !To() && !U.previousActiveElement && (U.previousActiveElement = document.activeElement), typeof e.didOpen == "function" && setTimeout(() => e.didOpen(n)), U.eventEmitter.emit("didOpen", n);
}, po = (e) => {
  const t = te();
  if (e.target !== t)
    return;
  const n = Fe();
  t.removeEventListener("animationend", po), t.removeEventListener("transitionend", po), n.style.overflowY = "auto", rt(n, v["no-transition"]);
}, Eg = (e, t) => {
  $i(t) ? (e.style.overflowY = "hidden", t.addEventListener("animationend", po), t.addEventListener("transitionend", po)) : e.style.overflowY = "auto";
}, kg = (e, t, n) => {
  ah(), t && n !== "hidden" && fh(n), setTimeout(() => {
    e.scrollTop = 0;
  });
}, xg = (e, t, n) => {
  re(e, n.showClass.backdrop), n.animation ? (t.style.setProperty("opacity", "0", "important"), Ne(t, "grid"), setTimeout(() => {
    re(t, n.showClass.popup), t.style.removeProperty("opacity");
  }, gl)) : Ne(t, "grid"), re([document.documentElement, document.body], v.shown), n.heightAuto && n.backdrop && !n.toast && re([document.documentElement, document.body], v["height-auto"]);
};
var Gs = {
  /**
   * @param {string} string
   * @param {string} [validationMessage]
   * @returns {Promise<string | void>}
   */
  email: (e, t) => /^[a-zA-Z0-9.+_'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z0-9-]+$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid email address"),
  /**
   * @param {string} string
   * @param {string} [validationMessage]
   * @returns {Promise<string | void>}
   */
  url: (e, t) => /^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-z]{2,63}\b([-a-zA-Z0-9@:%_+.~#?&/=]*)$/.test(e) ? Promise.resolve() : Promise.resolve(t || "Invalid URL")
};
function Cg(e) {
  e.inputValidator || (e.input === "email" && (e.inputValidator = Gs.email), e.input === "url" && (e.inputValidator = Gs.url));
}
function Ag(e) {
  (!e.target || typeof e.target == "string" && !document.querySelector(e.target) || typeof e.target != "string" && !e.target.appendChild) && (Re('Target parameter is not valid, defaulting to "body"'), e.target = "body");
}
function Lg(e) {
  Cg(e), e.showLoaderOnConfirm && !e.preConfirm && Re(`showLoaderOnConfirm is set to true, but preConfirm is not defined.
showLoaderOnConfirm should be used together with preConfirm, see usage example:
https://sweetalert2.github.io/#ajax-request`), Ag(e), typeof e.title == "string" && (e.title = e.title.split(`
`).join("<br />")), gp(e);
}
let ft;
var qn = /* @__PURE__ */ new WeakMap();
class Ee {
  /**
   * @param {...(SweetAlertOptions | string)} args
   * @this {SweetAlert}
   */
  constructor(...t) {
    if (Kw(this, qn, void 0), typeof window > "u")
      return;
    ft = this;
    const n = Object.freeze(this.constructor.argsToParams(t));
    this.params = n, this.isAwaitingPromise = !1, Gw(qn, this, this._main(ft.params));
  }
  _main(t, n = {}) {
    if (ul(Object.assign({}, n, t)), U.currentInstance) {
      const s = un.swalPromiseResolve.get(U.currentInstance), {
        isAwaitingPromise: a
      } = U.currentInstance;
      U.currentInstance._destroy(), a || s({
        isDismissed: !0
      }), Wr() && Wi();
    }
    U.currentInstance = ft;
    const o = Ng(t, n);
    Lg(o), Object.freeze(o), U.timeout && (U.timeout.stop(), delete U.timeout), clearTimeout(U.restoreFocusTimeout);
    const r = Og(ft);
    return Vi(ft, o), ue.innerParams.set(ft, o), Tg(ft, r, o);
  }
  // `catch` cannot be the name of a module export, so we define our thenable methods here instead
  then(t) {
    return Fs(qn, this).then(t);
  }
  finally(t) {
    return Fs(qn, this).finally(t);
  }
}
const Tg = (e, t, n) => new Promise((o, r) => {
  const s = (a) => {
    e.close({
      isDismissed: !0,
      dismiss: a,
      isConfirmed: !1,
      isDenied: !1
    });
  };
  un.swalPromiseResolve.set(e, o), un.swalPromiseReject.set(e, r), t.confirmButton.onclick = () => {
    Oh(e);
  }, t.denyButton.onclick = () => {
    Ph(e);
  }, t.cancelButton.onclick = () => {
    Ih(e, s);
  }, t.closeButton.onclick = () => {
    s(_n.close);
  }, Yh(n, t, s), Jp(U, n, s), _h(e, n), _g(n), Pg(U, n, s), Ig(t, n), setTimeout(() => {
    t.container.scrollTop = 0;
  });
}), Ng = (e, t) => {
  const n = mg(e), o = Object.assign({}, rn, t, n, e);
  return o.showClass = Object.assign({}, rn.showClass, o.showClass), o.hideClass = Object.assign({}, rn.hideClass, o.hideClass), o.animation === !1 && (o.showClass = {
    backdrop: "swal2-noanimation"
  }, o.hideClass = {}), o;
}, Og = (e) => {
  const t = {
    popup: te(),
    container: Fe(),
    actions: Bn(),
    confirmButton: gt(),
    denyButton: Jt(),
    cancelButton: vn(),
    loader: yn(),
    closeButton: jr(),
    validationMessage: Ao(),
    progressSteps: Hr()
  };
  return ue.domCache.set(e, t), t;
}, Pg = (e, t, n) => {
  const o = Lo();
  De(o), t.timer && (e.timeout = new dg(() => {
    n("timer"), delete e.timeout;
  }, t.timer), t.timerProgressBar && (Ne(o), ze(o, t, "timerProgressBar"), setTimeout(() => {
    e.timeout && e.timeout.running && zr(t.timer);
  })));
}, Ig = (e, t) => {
  if (!t.toast) {
    if (!Co(t.allowEnterKey)) {
      Li("allowEnterKey"), Dg();
      return;
    }
    $g(e) || Sg(e, t) || cr(-1, 1);
  }
}, $g = (e) => {
  const t = Array.from(e.popup.querySelectorAll("[autofocus]"));
  for (const n of t)
    if (n instanceof HTMLElement && je(n))
      return n.focus(), !0;
  return !1;
}, Sg = (e, t) => t.focusDeny && je(e.denyButton) ? (e.denyButton.focus(), !0) : t.focusCancel && je(e.cancelButton) ? (e.cancelButton.focus(), !0) : t.focusConfirm && je(e.confirmButton) ? (e.confirmButton.focus(), !0) : !1, Dg = () => {
  document.activeElement instanceof HTMLElement && typeof document.activeElement.blur == "function" && document.activeElement.blur();
};
Ee.prototype.disableButtons = nl;
Ee.prototype.enableButtons = tl;
Ee.prototype.getInput = Ji;
Ee.prototype.disableInput = rl;
Ee.prototype.enableInput = ol;
Ee.prototype.hideLoading = fo;
Ee.prototype.disableLoading = fo;
Ee.prototype.showValidationMessage = sl;
Ee.prototype.resetValidationMessage = al;
Ee.prototype.close = It;
Ee.prototype.closePopup = It;
Ee.prototype.closeModal = It;
Ee.prototype.closeToast = It;
Ee.prototype.rejectPromise = Ki;
Ee.prototype.update = dl;
Ee.prototype._destroy = ml;
Object.assign(Ee, ug);
Object.keys(jh).forEach((e) => {
  Ee[e] = function(...t) {
    return ft && ft[e] ? ft[e](...t) : null;
  };
});
Ee.DismissReason = _n;
Ee.version = "11.26.10";
const jt = Ee;
jt.default = jt;
typeof document < "u" && function(e, t) {
  var n = e.createElement("style");
  if (e.getElementsByTagName("head")[0].appendChild(n), n.styleSheet) n.styleSheet.disabled || (n.styleSheet.cssText = t);
  else try {
    n.innerHTML = t;
  } catch {
    n.innerText = t;
  }
}(document, ':root{--swal2-outline: 0 0 0 3px rgba(100, 150, 200, 0.5);--swal2-container-padding: 0.625em;--swal2-backdrop: rgba(0, 0, 0, 0.4);--swal2-backdrop-transition: background-color 0.15s;--swal2-width: 32em;--swal2-padding: 0 0 1.25em;--swal2-border: none;--swal2-border-radius: 0.3125rem;--swal2-background: white;--swal2-color: #545454;--swal2-show-animation: swal2-show 0.3s;--swal2-hide-animation: swal2-hide 0.15s forwards;--swal2-icon-zoom: 1;--swal2-icon-animations: true;--swal2-title-padding: 0.8em 1em 0;--swal2-html-container-padding: 1em 1.6em 0.3em;--swal2-input-border: 1px solid #d9d9d9;--swal2-input-border-radius: 0.1875em;--swal2-input-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px transparent;--swal2-input-background: transparent;--swal2-input-transition: border-color 0.2s, box-shadow 0.2s;--swal2-input-hover-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px transparent;--swal2-input-focus-border: 1px solid #b4dbed;--swal2-input-focus-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.06), 0 0 0 3px rgba(100, 150, 200, 0.5);--swal2-progress-step-background: #add8e6;--swal2-validation-message-background: #f0f0f0;--swal2-validation-message-color: #666;--swal2-footer-border-color: #eee;--swal2-footer-background: transparent;--swal2-footer-color: inherit;--swal2-timer-progress-bar-background: rgba(0, 0, 0, 0.3);--swal2-close-button-position: initial;--swal2-close-button-inset: auto;--swal2-close-button-font-size: 2.5em;--swal2-close-button-color: #ccc;--swal2-close-button-transition: color 0.2s, box-shadow 0.2s;--swal2-close-button-outline: initial;--swal2-close-button-box-shadow: inset 0 0 0 3px transparent;--swal2-close-button-focus-box-shadow: inset var(--swal2-outline);--swal2-close-button-hover-transform: none;--swal2-actions-justify-content: center;--swal2-actions-width: auto;--swal2-actions-margin: 1.25em auto 0;--swal2-actions-padding: 0;--swal2-actions-border-radius: 0;--swal2-actions-background: transparent;--swal2-action-button-transition: background-color 0.2s, box-shadow 0.2s;--swal2-action-button-hover: black 10%;--swal2-action-button-active: black 10%;--swal2-confirm-button-box-shadow: none;--swal2-confirm-button-border-radius: 0.25em;--swal2-confirm-button-background-color: #7066e0;--swal2-confirm-button-color: #fff;--swal2-deny-button-box-shadow: none;--swal2-deny-button-border-radius: 0.25em;--swal2-deny-button-background-color: #dc3741;--swal2-deny-button-color: #fff;--swal2-cancel-button-box-shadow: none;--swal2-cancel-button-border-radius: 0.25em;--swal2-cancel-button-background-color: #6e7881;--swal2-cancel-button-color: #fff;--swal2-toast-show-animation: swal2-toast-show 0.5s;--swal2-toast-hide-animation: swal2-toast-hide 0.1s forwards;--swal2-toast-border: none;--swal2-toast-box-shadow: 0 0 1px hsl(0deg 0% 0% / 0.075), 0 1px 2px hsl(0deg 0% 0% / 0.075), 1px 2px 4px hsl(0deg 0% 0% / 0.075), 1px 3px 8px hsl(0deg 0% 0% / 0.075), 2px 4px 16px hsl(0deg 0% 0% / 0.075)}[data-swal2-theme=dark]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white);--swal2-timer-progress-bar-background: rgba(255, 255, 255, 0.7)}@media(prefers-color-scheme: dark){[data-swal2-theme=auto]{--swal2-dark-theme-black: #19191a;--swal2-dark-theme-white: #e1e1e1;--swal2-background: var(--swal2-dark-theme-black);--swal2-color: var(--swal2-dark-theme-white);--swal2-footer-border-color: #555;--swal2-input-background: color-mix(in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10%);--swal2-validation-message-background: color-mix( in srgb, var(--swal2-dark-theme-black), var(--swal2-dark-theme-white) 10% );--swal2-validation-message-color: var(--swal2-dark-theme-white);--swal2-timer-progress-bar-background: rgba(255, 255, 255, 0.7)}}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow:hidden}body.swal2-height-auto{height:auto !important}body.swal2-no-backdrop .swal2-container{background-color:rgba(0,0,0,0) !important;pointer-events:none}body.swal2-no-backdrop .swal2-container .swal2-popup{pointer-events:all}body.swal2-no-backdrop .swal2-container .swal2-modal{box-shadow:0 0 10px var(--swal2-backdrop)}body.swal2-toast-shown .swal2-container{box-sizing:border-box;width:360px;max-width:100%;background-color:rgba(0,0,0,0);pointer-events:none}body.swal2-toast-shown .swal2-container.swal2-top{inset:0 auto auto 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-top-end,body.swal2-toast-shown .swal2-container.swal2-top-right{inset:0 0 auto auto}body.swal2-toast-shown .swal2-container.swal2-top-start,body.swal2-toast-shown .swal2-container.swal2-top-left{inset:0 auto auto 0}body.swal2-toast-shown .swal2-container.swal2-center-start,body.swal2-toast-shown .swal2-container.swal2-center-left{inset:50% auto auto 0;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-center{inset:50% auto auto 50%;transform:translate(-50%, -50%)}body.swal2-toast-shown .swal2-container.swal2-center-end,body.swal2-toast-shown .swal2-container.swal2-center-right{inset:50% 0 auto auto;transform:translateY(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-start,body.swal2-toast-shown .swal2-container.swal2-bottom-left{inset:auto auto 0 0}body.swal2-toast-shown .swal2-container.swal2-bottom{inset:auto auto 0 50%;transform:translateX(-50%)}body.swal2-toast-shown .swal2-container.swal2-bottom-end,body.swal2-toast-shown .swal2-container.swal2-bottom-right{inset:auto 0 0 auto}@media print{body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown){overflow-y:scroll !important}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown)>[aria-hidden=true]{display:none}body.swal2-shown:not(.swal2-no-backdrop,.swal2-toast-shown) .swal2-container{position:static !important}}div:where(.swal2-container){display:grid;position:fixed;z-index:1060;inset:0;box-sizing:border-box;grid-template-areas:"top-start     top            top-end" "center-start  center         center-end" "bottom-start  bottom-center  bottom-end";grid-template-rows:minmax(min-content, auto) minmax(min-content, auto) minmax(min-content, auto);height:100%;padding:var(--swal2-container-padding);overflow-x:hidden;transition:var(--swal2-backdrop-transition);-webkit-overflow-scrolling:touch}div:where(.swal2-container).swal2-backdrop-show,div:where(.swal2-container).swal2-noanimation{background:var(--swal2-backdrop)}div:where(.swal2-container).swal2-backdrop-hide{background:rgba(0,0,0,0) !important}div:where(.swal2-container).swal2-top-start,div:where(.swal2-container).swal2-center-start,div:where(.swal2-container).swal2-bottom-start{grid-template-columns:minmax(0, 1fr) auto auto}div:where(.swal2-container).swal2-top,div:where(.swal2-container).swal2-center,div:where(.swal2-container).swal2-bottom{grid-template-columns:auto minmax(0, 1fr) auto}div:where(.swal2-container).swal2-top-end,div:where(.swal2-container).swal2-center-end,div:where(.swal2-container).swal2-bottom-end{grid-template-columns:auto auto minmax(0, 1fr)}div:where(.swal2-container).swal2-top-start>.swal2-popup{align-self:start}div:where(.swal2-container).swal2-top>.swal2-popup{grid-column:2;place-self:start center}div:where(.swal2-container).swal2-top-end>.swal2-popup,div:where(.swal2-container).swal2-top-right>.swal2-popup{grid-column:3;place-self:start end}div:where(.swal2-container).swal2-center-start>.swal2-popup,div:where(.swal2-container).swal2-center-left>.swal2-popup{grid-row:2;align-self:center}div:where(.swal2-container).swal2-center>.swal2-popup{grid-column:2;grid-row:2;place-self:center center}div:where(.swal2-container).swal2-center-end>.swal2-popup,div:where(.swal2-container).swal2-center-right>.swal2-popup{grid-column:3;grid-row:2;place-self:center end}div:where(.swal2-container).swal2-bottom-start>.swal2-popup,div:where(.swal2-container).swal2-bottom-left>.swal2-popup{grid-column:1;grid-row:3;align-self:end}div:where(.swal2-container).swal2-bottom>.swal2-popup{grid-column:2;grid-row:3;place-self:end center}div:where(.swal2-container).swal2-bottom-end>.swal2-popup,div:where(.swal2-container).swal2-bottom-right>.swal2-popup{grid-column:3;grid-row:3;place-self:end end}div:where(.swal2-container).swal2-grow-row>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-column:1/4;width:100%}div:where(.swal2-container).swal2-grow-column>.swal2-popup,div:where(.swal2-container).swal2-grow-fullscreen>.swal2-popup{grid-row:1/4;align-self:stretch}div:where(.swal2-container).swal2-no-transition{transition:none !important}div:where(.swal2-container)[popover]{width:auto;border:0}div:where(.swal2-container) div:where(.swal2-popup){display:none;position:relative;box-sizing:border-box;grid-template-columns:minmax(0, 100%);width:var(--swal2-width);max-width:100%;padding:var(--swal2-padding);border:var(--swal2-border);border-radius:var(--swal2-border-radius);background:var(--swal2-background);color:var(--swal2-color);font-family:inherit;font-size:1rem;container-name:swal2-popup}div:where(.swal2-container) div:where(.swal2-popup):focus{outline:none}div:where(.swal2-container) div:where(.swal2-popup).swal2-loading{overflow-y:hidden}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable{cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-draggable div:where(.swal2-icon){cursor:grab}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging{cursor:grabbing}div:where(.swal2-container) div:where(.swal2-popup).swal2-dragging div:where(.swal2-icon){cursor:grabbing}div:where(.swal2-container) h2:where(.swal2-title){position:relative;max-width:100%;margin:0;padding:var(--swal2-title-padding);color:inherit;font-size:1.875em;font-weight:600;text-align:center;text-transform:none;overflow-wrap:break-word;cursor:initial}div:where(.swal2-container) div:where(.swal2-actions){display:flex;z-index:1;box-sizing:border-box;flex-wrap:wrap;align-items:center;justify-content:var(--swal2-actions-justify-content);width:var(--swal2-actions-width);margin:var(--swal2-actions-margin);padding:var(--swal2-actions-padding);border-radius:var(--swal2-actions-border-radius);background:var(--swal2-actions-background)}div:where(.swal2-container) div:where(.swal2-loader){display:none;align-items:center;justify-content:center;width:2.2em;height:2.2em;margin:0 1.875em;animation:swal2-rotate-loading 1.5s linear 0s infinite normal;border-width:.25em;border-style:solid;border-radius:100%;border-color:#2778c4 rgba(0,0,0,0) #2778c4 rgba(0,0,0,0)}div:where(.swal2-container) button:where(.swal2-styled){margin:.3125em;padding:.625em 1.1em;transition:var(--swal2-action-button-transition);border:none;box-shadow:0 0 0 3px rgba(0,0,0,0);font-weight:500}div:where(.swal2-container) button:where(.swal2-styled):not([disabled]){cursor:pointer}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm){border-radius:var(--swal2-confirm-button-border-radius);background:initial;background-color:var(--swal2-confirm-button-background-color);box-shadow:var(--swal2-confirm-button-box-shadow);color:var(--swal2-confirm-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):hover{background-color:color-mix(in srgb, var(--swal2-confirm-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-confirm):active{background-color:color-mix(in srgb, var(--swal2-confirm-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny){border-radius:var(--swal2-deny-button-border-radius);background:initial;background-color:var(--swal2-deny-button-background-color);box-shadow:var(--swal2-deny-button-box-shadow);color:var(--swal2-deny-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):hover{background-color:color-mix(in srgb, var(--swal2-deny-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-deny):active{background-color:color-mix(in srgb, var(--swal2-deny-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel){border-radius:var(--swal2-cancel-button-border-radius);background:initial;background-color:var(--swal2-cancel-button-background-color);box-shadow:var(--swal2-cancel-button-box-shadow);color:var(--swal2-cancel-button-color);font-size:1em}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):hover{background-color:color-mix(in srgb, var(--swal2-cancel-button-background-color), var(--swal2-action-button-hover))}div:where(.swal2-container) button:where(.swal2-styled):where(.swal2-cancel):active{background-color:color-mix(in srgb, var(--swal2-cancel-button-background-color), var(--swal2-action-button-active))}div:where(.swal2-container) button:where(.swal2-styled):focus-visible{outline:none;box-shadow:var(--swal2-action-button-focus-box-shadow)}div:where(.swal2-container) button:where(.swal2-styled)[disabled]:not(.swal2-loading){opacity:.4}div:where(.swal2-container) button:where(.swal2-styled)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-footer){margin:1em 0 0;padding:1em 1em 0;border-top:1px solid var(--swal2-footer-border-color);background:var(--swal2-footer-background);color:var(--swal2-footer-color);font-size:1em;text-align:center;cursor:initial}div:where(.swal2-container) .swal2-timer-progress-bar-container{position:absolute;right:0;bottom:0;left:0;grid-column:auto !important;overflow:hidden;border-bottom-right-radius:var(--swal2-border-radius);border-bottom-left-radius:var(--swal2-border-radius)}div:where(.swal2-container) div:where(.swal2-timer-progress-bar){width:100%;height:.25em;background:var(--swal2-timer-progress-bar-background)}div:where(.swal2-container) img:where(.swal2-image){max-width:100%;margin:2em auto 1em;cursor:initial}div:where(.swal2-container) button:where(.swal2-close){position:var(--swal2-close-button-position);inset:var(--swal2-close-button-inset);z-index:2;align-items:center;justify-content:center;width:1.2em;height:1.2em;margin-top:0;margin-right:0;margin-bottom:-1.2em;padding:0;overflow:hidden;transition:var(--swal2-close-button-transition);border:none;border-radius:var(--swal2-border-radius);outline:var(--swal2-close-button-outline);background:rgba(0,0,0,0);color:var(--swal2-close-button-color);font-family:monospace;font-size:var(--swal2-close-button-font-size);cursor:pointer;justify-self:end}div:where(.swal2-container) button:where(.swal2-close):hover{transform:var(--swal2-close-button-hover-transform);background:rgba(0,0,0,0);color:#f27474}div:where(.swal2-container) button:where(.swal2-close):focus-visible{outline:none;box-shadow:var(--swal2-close-button-focus-box-shadow)}div:where(.swal2-container) button:where(.swal2-close)::-moz-focus-inner{border:0}div:where(.swal2-container) div:where(.swal2-html-container){z-index:1;justify-content:center;margin:0;padding:var(--swal2-html-container-padding);overflow:auto;color:inherit;font-size:1.125em;font-weight:normal;line-height:normal;text-align:center;overflow-wrap:break-word;word-break:break-word;cursor:initial}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea),div:where(.swal2-container) select:where(.swal2-select),div:where(.swal2-container) div:where(.swal2-radio),div:where(.swal2-container) label:where(.swal2-checkbox){margin:1em 2em 3px}div:where(.swal2-container) input:where(.swal2-input),div:where(.swal2-container) input:where(.swal2-file),div:where(.swal2-container) textarea:where(.swal2-textarea){box-sizing:border-box;width:auto;transition:var(--swal2-input-transition);border:var(--swal2-input-border);border-radius:var(--swal2-input-border-radius);background:var(--swal2-input-background);box-shadow:var(--swal2-input-box-shadow);color:inherit;font-size:1.125em}div:where(.swal2-container) input:where(.swal2-input).swal2-inputerror,div:where(.swal2-container) input:where(.swal2-file).swal2-inputerror,div:where(.swal2-container) textarea:where(.swal2-textarea).swal2-inputerror{border-color:#f27474 !important;box-shadow:0 0 2px #f27474 !important}div:where(.swal2-container) input:where(.swal2-input):hover,div:where(.swal2-container) input:where(.swal2-file):hover,div:where(.swal2-container) textarea:where(.swal2-textarea):hover{box-shadow:var(--swal2-input-hover-box-shadow)}div:where(.swal2-container) input:where(.swal2-input):focus,div:where(.swal2-container) input:where(.swal2-file):focus,div:where(.swal2-container) textarea:where(.swal2-textarea):focus{border:var(--swal2-input-focus-border);outline:none;box-shadow:var(--swal2-input-focus-box-shadow)}div:where(.swal2-container) input:where(.swal2-input)::placeholder,div:where(.swal2-container) input:where(.swal2-file)::placeholder,div:where(.swal2-container) textarea:where(.swal2-textarea)::placeholder{color:#ccc}div:where(.swal2-container) .swal2-range{margin:1em 2em 3px;background:var(--swal2-background)}div:where(.swal2-container) .swal2-range input{width:80%}div:where(.swal2-container) .swal2-range output{width:20%;color:inherit;font-weight:600;text-align:center}div:where(.swal2-container) .swal2-range input,div:where(.swal2-container) .swal2-range output{height:2.625em;padding:0;font-size:1.125em;line-height:2.625em}div:where(.swal2-container) .swal2-input{height:2.625em;padding:0 .75em}div:where(.swal2-container) .swal2-file{width:75%;margin-right:auto;margin-left:auto;background:var(--swal2-input-background);font-size:1.125em}div:where(.swal2-container) .swal2-textarea{height:6.75em;padding:.75em}div:where(.swal2-container) .swal2-select{min-width:50%;max-width:100%;padding:.375em .625em;background:var(--swal2-input-background);color:inherit;font-size:1.125em}div:where(.swal2-container) .swal2-radio,div:where(.swal2-container) .swal2-checkbox{align-items:center;justify-content:center;background:var(--swal2-background);color:inherit}div:where(.swal2-container) .swal2-radio label,div:where(.swal2-container) .swal2-checkbox label{margin:0 .6em;font-size:1.125em}div:where(.swal2-container) .swal2-radio input,div:where(.swal2-container) .swal2-checkbox input{flex-shrink:0;margin:0 .4em}div:where(.swal2-container) label:where(.swal2-input-label){display:flex;justify-content:center;margin:1em auto 0}div:where(.swal2-container) div:where(.swal2-validation-message){align-items:center;justify-content:center;margin:1em 0 0;padding:.625em;overflow:hidden;background:var(--swal2-validation-message-background);color:var(--swal2-validation-message-color);font-size:1em;font-weight:300}div:where(.swal2-container) div:where(.swal2-validation-message)::before{content:"!";display:inline-block;width:1.5em;min-width:1.5em;height:1.5em;margin:0 .625em;border-radius:50%;background-color:#f27474;color:#fff;font-weight:600;line-height:1.5em;text-align:center}div:where(.swal2-container) .swal2-progress-steps{flex-wrap:wrap;align-items:center;max-width:100%;margin:1.25em auto;padding:0;background:rgba(0,0,0,0);font-weight:600}div:where(.swal2-container) .swal2-progress-steps li{display:inline-block;position:relative}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step{z-index:20;flex-shrink:0;width:2em;height:2em;border-radius:2em;background:#2778c4;color:#fff;line-height:2em;text-align:center}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step{background:#2778c4}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step{background:var(--swal2-progress-step-background);color:#fff}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step~.swal2-progress-step-line{background:var(--swal2-progress-step-background)}div:where(.swal2-container) .swal2-progress-steps .swal2-progress-step-line{z-index:10;flex-shrink:0;width:2.5em;height:.4em;margin:0 -1px;background:#2778c4}div:where(.swal2-icon){position:relative;box-sizing:content-box;justify-content:center;width:5em;height:5em;margin:2.5em auto .6em;zoom:var(--swal2-icon-zoom);border:.25em solid rgba(0,0,0,0);border-radius:50%;border-color:#000;font-family:inherit;line-height:5em;cursor:default;user-select:none}div:where(.swal2-icon) .swal2-icon-content{display:flex;align-items:center;font-size:3.75em}div:where(.swal2-icon).swal2-error{border-color:#f27474;color:#f27474}div:where(.swal2-icon).swal2-error .swal2-x-mark{position:relative;flex-grow:1}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line]{display:block;position:absolute;top:2.3125em;width:2.9375em;height:.3125em;border-radius:.125em;background-color:#f27474}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=left]{left:1.0625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-error [class^=swal2-x-mark-line][class$=right]{right:1em;transform:rotate(-45deg)}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-error.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-error.swal2-icon-show .swal2-x-mark{animation:swal2-animate-error-x-mark .5s}}div:where(.swal2-icon).swal2-warning{border-color:#f8bb86;color:#f8bb86}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-warning.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-warning.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .5s}}div:where(.swal2-icon).swal2-info{border-color:#3fc3ee;color:#3fc3ee}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-info.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-info.swal2-icon-show .swal2-icon-content{animation:swal2-animate-i-mark .8s}}div:where(.swal2-icon).swal2-question{border-color:#87adbd;color:#87adbd}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-question.swal2-icon-show{animation:swal2-animate-error-icon .5s}div:where(.swal2-icon).swal2-question.swal2-icon-show .swal2-icon-content{animation:swal2-animate-question-mark .8s}}div:where(.swal2-icon).swal2-success{border-color:#a5dc86;color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line]{position:absolute;width:3.75em;height:7.5em;border-radius:50%}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.4375em;left:-2.0635em;transform:rotate(-45deg);transform-origin:3.75em 3.75em;border-radius:7.5em 0 0 7.5em}div:where(.swal2-icon).swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.6875em;left:1.875em;transform:rotate(-45deg);transform-origin:0 3.75em;border-radius:0 7.5em 7.5em 0}div:where(.swal2-icon).swal2-success .swal2-success-ring{position:absolute;z-index:2;top:-0.25em;left:-0.25em;box-sizing:content-box;width:100%;height:100%;border:.25em solid rgba(165,220,134,.3);border-radius:50%}div:where(.swal2-icon).swal2-success .swal2-success-fix{position:absolute;z-index:1;top:.5em;left:1.625em;width:.4375em;height:5.625em;transform:rotate(-45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line]{display:block;position:absolute;z-index:2;height:.3125em;border-radius:.125em;background-color:#a5dc86}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=tip]{top:2.875em;left:.8125em;width:1.5625em;transform:rotate(45deg)}div:where(.swal2-icon).swal2-success [class^=swal2-success-line][class$=long]{top:2.375em;right:.5em;width:2.9375em;transform:rotate(-45deg)}@container swal2-popup style(--swal2-icon-animations:true){div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-animate-success-line-tip .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-animate-success-line-long .75s}div:where(.swal2-icon).swal2-success.swal2-icon-show .swal2-success-circular-line-right{animation:swal2-rotate-success-circular-line 4.25s ease-in}}[class^=swal2]{-webkit-tap-highlight-color:rgba(0,0,0,0)}.swal2-show{animation:var(--swal2-show-animation)}.swal2-hide{animation:var(--swal2-hide-animation)}.swal2-noanimation{transition:none}.swal2-scrollbar-measure{position:absolute;top:-9999px;width:50px;height:50px;overflow:scroll}.swal2-rtl .swal2-close{margin-right:initial;margin-left:0}.swal2-rtl .swal2-timer-progress-bar{right:0;left:auto}.swal2-toast{box-sizing:border-box;grid-column:1/4 !important;grid-row:1/4 !important;grid-template-columns:min-content auto min-content;padding:1em;overflow-y:hidden;border:var(--swal2-toast-border);background:var(--swal2-background);box-shadow:var(--swal2-toast-box-shadow);pointer-events:all}.swal2-toast>*{grid-column:2}.swal2-toast h2:where(.swal2-title){margin:.5em 1em;padding:0;font-size:1em;text-align:initial}.swal2-toast .swal2-loading{justify-content:center}.swal2-toast input:where(.swal2-input){height:2em;margin:.5em;font-size:1em}.swal2-toast .swal2-validation-message{font-size:1em}.swal2-toast div:where(.swal2-footer){margin:.5em 0 0;padding:.5em 0 0;font-size:.8em}.swal2-toast button:where(.swal2-close){grid-column:3/3;grid-row:1/99;align-self:center;width:.8em;height:.8em;margin:0;font-size:2em}.swal2-toast div:where(.swal2-html-container){margin:.5em 1em;padding:0;overflow:initial;font-size:1em;text-align:initial}.swal2-toast div:where(.swal2-html-container):empty{padding:0}.swal2-toast .swal2-loader{grid-column:1;grid-row:1/99;align-self:center;width:2em;height:2em;margin:.25em}.swal2-toast .swal2-icon{grid-column:1;grid-row:1/99;align-self:center;width:2em;min-width:2em;height:2em;margin:0 .5em 0 0}.swal2-toast .swal2-icon .swal2-icon-content{display:flex;align-items:center;font-size:1.8em;font-weight:bold}.swal2-toast .swal2-icon.swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line]{top:.875em;width:1.375em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=left]{left:.3125em}.swal2-toast .swal2-icon.swal2-error [class^=swal2-x-mark-line][class$=right]{right:.3125em}.swal2-toast div:where(.swal2-actions){justify-content:flex-start;height:auto;margin:0;margin-top:.5em;padding:0 .5em}.swal2-toast button:where(.swal2-styled){margin:.25em .5em;padding:.4em .6em;font-size:1em}.swal2-toast .swal2-success{border-color:#a5dc86}.swal2-toast .swal2-success [class^=swal2-success-circular-line]{position:absolute;width:1.6em;height:3em;border-radius:50%}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=left]{top:-0.8em;left:-0.5em;transform:rotate(-45deg);transform-origin:2em 2em;border-radius:4em 0 0 4em}.swal2-toast .swal2-success [class^=swal2-success-circular-line][class$=right]{top:-0.25em;left:.9375em;transform-origin:0 1.5em;border-radius:0 4em 4em 0}.swal2-toast .swal2-success .swal2-success-ring{width:2em;height:2em}.swal2-toast .swal2-success .swal2-success-fix{top:0;left:.4375em;width:.4375em;height:2.6875em}.swal2-toast .swal2-success [class^=swal2-success-line]{height:.3125em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=tip]{top:1.125em;left:.1875em;width:.75em}.swal2-toast .swal2-success [class^=swal2-success-line][class$=long]{top:.9375em;right:.1875em;width:1.375em}@container swal2-popup style(--swal2-icon-animations:true){.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-tip{animation:swal2-toast-animate-success-line-tip .75s}.swal2-toast .swal2-success.swal2-icon-show .swal2-success-line-long{animation:swal2-toast-animate-success-line-long .75s}}.swal2-toast.swal2-show{animation:var(--swal2-toast-show-animation)}.swal2-toast.swal2-hide{animation:var(--swal2-toast-hide-animation)}@keyframes swal2-show{0%{transform:translate3d(0, -50px, 0) scale(0.9);opacity:0}100%{transform:translate3d(0, 0, 0) scale(1);opacity:1}}@keyframes swal2-hide{0%{transform:translate3d(0, 0, 0) scale(1);opacity:1}100%{transform:translate3d(0, -50px, 0) scale(0.9);opacity:0}}@keyframes swal2-animate-success-line-tip{0%{top:1.1875em;left:.0625em;width:0}54%{top:1.0625em;left:.125em;width:0}70%{top:2.1875em;left:-0.375em;width:3.125em}84%{top:3em;left:1.3125em;width:1.0625em}100%{top:2.8125em;left:.8125em;width:1.5625em}}@keyframes swal2-animate-success-line-long{0%{top:3.375em;right:2.875em;width:0}65%{top:3.375em;right:2.875em;width:0}84%{top:2.1875em;right:0;width:3.4375em}100%{top:2.375em;right:.5em;width:2.9375em}}@keyframes swal2-rotate-success-circular-line{0%{transform:rotate(-45deg)}5%{transform:rotate(-45deg)}12%{transform:rotate(-405deg)}100%{transform:rotate(-405deg)}}@keyframes swal2-animate-error-x-mark{0%{margin-top:1.625em;transform:scale(0.4);opacity:0}50%{margin-top:1.625em;transform:scale(0.4);opacity:0}80%{margin-top:-0.375em;transform:scale(1.15)}100%{margin-top:0;transform:scale(1);opacity:1}}@keyframes swal2-animate-error-icon{0%{transform:rotateX(100deg);opacity:0}100%{transform:rotateX(0deg);opacity:1}}@keyframes swal2-rotate-loading{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}@keyframes swal2-animate-question-mark{0%{transform:rotateY(-360deg)}100%{transform:rotateY(0)}}@keyframes swal2-animate-i-mark{0%{transform:rotateZ(45deg);opacity:0}25%{transform:rotateZ(-25deg);opacity:.4}50%{transform:rotateZ(15deg);opacity:.8}75%{transform:rotateZ(-5deg);opacity:1}100%{transform:rotateX(0);opacity:1}}@keyframes swal2-toast-show{0%{transform:translateY(-0.625em) rotateZ(2deg)}33%{transform:translateY(0) rotateZ(-2deg)}66%{transform:translateY(0.3125em) rotateZ(2deg)}100%{transform:translateY(0) rotateZ(0deg)}}@keyframes swal2-toast-hide{100%{transform:rotateZ(1deg);opacity:0}}@keyframes swal2-toast-animate-success-line-tip{0%{top:.5625em;left:.0625em;width:0}54%{top:.125em;left:.125em;width:0}70%{top:.625em;left:-0.25em;width:1.625em}84%{top:1.0625em;left:.75em;width:.5em}100%{top:1.125em;left:.1875em;width:.75em}}@keyframes swal2-toast-animate-success-line-long{0%{top:1.625em;right:1.375em;width:0}65%{top:1.25em;right:.9375em;width:0}84%{top:.9375em;right:0;width:1.125em}100%{top:.9375em;right:.1875em;width:1.375em}}');
const Mg = {
  key: 0,
  class: "fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm"
}, Rg = { class: "bg-white rounded-3xl w-full max-w-md shadow-2xl overflow-hidden animate-in fade-in zoom-in duration-200" }, Bg = { class: "p-6 border-b border-gray-100 flex justify-between items-center bg-gray-50" }, Fg = { class: "p-6 space-y-5" }, Ug = {
  key: 0,
  class: "bg-red-50 border border-red-200 rounded-2xl p-4 flex flex-col gap-1"
}, Vg = { class: "text-sm text-red-600 font-medium" }, Hg = {
  key: 0,
  class: "bg-red-100 px-1.5 py-0.5 rounded mr-1"
}, jg = {
  key: 0,
  class: "text-xs text-red-500 mt-1 font-medium"
}, Yg = { class: "relative" }, Wg = {
  key: 0,
  class: "absolute right-3 top-1/2 -translate-y-1/2"
}, qg = { class: "p-6 bg-gray-50 flex gap-3" }, zg = ["disabled"], Kg = ["disabled"], Gg = /* @__PURE__ */ $t({
  __name: "InvoiceModal",
  props: {
    isOpen: { type: Boolean },
    payment: {},
    queryCompanyName: { type: Function },
    createInvoice: { type: Function },
    voidPayment: { type: Function }
  },
  emits: ["close", "success"],
  setup(e, { emit: t }) {
    const n = e, o = t, r = Ve(!1), s = Ve(!1), a = Ve(""), i = Zs({
      CarrierNum: "",
      CustomerIdentifier: "",
      CustomerName: "",
      CustomerAddr: "台北市信義區忠孝東路五段",
      CustomerPhone: "0912345678",
      CustomerEmail: "test@example.com"
    });
    Yo(() => n.isOpen, (k) => {
      k || (i.CarrierNum = "", i.CustomerIdentifier = "", i.CustomerName = "", a.value = "");
    });
    const l = async (k) => {
      const d = k.target, w = tw(d.value);
      if (d.value = w.value, i.CustomerIdentifier = w.value, a.value = w.error, w.isReady) {
        s.value = !0;
        try {
          const N = await n.queryCompanyName(w.value);
          N && N.Company_Name ? i.CustomerName = N.Company_Name : a.value = "查無此統一編號的公司名稱";
        } catch {
          a.value = "系統查詢名稱失敗，請手動輸入公司名稱";
        } finally {
          s.value = !1;
        }
      }
    }, p = async () => {
      var k, d;
      if (n.payment) {
        if (i.CustomerIdentifier.length === 8 && !i.CustomerName.trim()) {
          jt.fire({ title: "請輸入買受人名稱（公司全名）", timer: 1e3, showConfirmButton: !1 });
          return;
        }
        r.value = !0;
        try {
          const w = i.CustomerIdentifier.length === 8, N = {
            relate_number: n.payment.merchant_trade_no,
            customer_id: "",
            customer_addr: i.CustomerAddr,
            customer_phone: i.CustomerPhone,
            customer_email: i.CustomerEmail,
            print: i.CarrierNum ? "0" : "1",
            donation: "0",
            carrier_type: !w && i.CarrierNum ? "3" : "",
            carrier_num: w ? "" : i.CarrierNum,
            customer_identifier: i.CustomerIdentifier,
            customer_name: i.CustomerName || "消費者",
            tax_type: "1",
            sales_amount: Number(n.payment.trade_amt),
            items: [{
              item_name: "交易商品",
              item_count: 1,
              item_word: "件",
              item_price: Number(n.payment.trade_amt),
              item_amount: Number(n.payment.trade_amt)
            }]
          };
          await n.createInvoice(N), jt.fire({ title: "發票開立成功！", timer: 1e3, showConfirmButton: !1 }), o("success");
        } catch (w) {
          jt.fire({ title: `發票開立失敗: ${((d = (k = w.response) == null ? void 0 : k.data) == null ? void 0 : d.message) || w.message}`, icon: "error", timer: 3e3 });
        } finally {
          r.value = !1;
        }
      }
    }, y = async () => {
      var k, d;
      if (n.payment && confirm("確定要作廢此筆交易嗎？此操作將會把訂單狀態重置為新訂單。")) {
        r.value = !0;
        try {
          await n.voidPayment({
            merchant_trade_no: n.payment.merchant_trade_no,
            ids: n.payment.order_ids || [],
            merchant_id: n.payment.merchant_id
          }), alert("交易已成功作廢，訂單已重置。"), o("success");
        } catch (w) {
          jt.fire({ title: `作廢失敗: ${((d = (k = w.response) == null ? void 0 : k.data) == null ? void 0 : d.message) || w.message}`, icon: "error", timer: 3e3 });
        } finally {
          r.value = !1;
        }
      }
    };
    return (k, d) => {
      var w, N, h, T, m, g;
      return e.isOpen ? (X(), ee("div", Mg, [
        _("div", Rg, [
          _("div", Bg, [
            d[6] || (d[6] = _("h3", { class: "text-xl font-black text-gray-700" }, "開立電子發票", -1)),
            _("button", {
              onClick: d[0] || (d[0] = (C) => o("close")),
              class: "text-gray-400 hover:text-gray-600 transition-colors"
            }, [...d[5] || (d[5] = [
              _("svg", {
                class: "w-6 h-6",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor"
              }, [
                _("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M6 18L18 6M6 6l12 12"
                })
              ], -1)
            ])])
          ]),
          _("div", Fg, [
            ((N = (w = e.payment) == null ? void 0 : w.invoice_transaction) == null ? void 0 : N.status) === "failed" && (e.payment.invoice_transaction.error_message || e.payment.invoice_transaction.error_code) ? (X(), ee("div", Ug, [
              d[7] || (d[7] = _("div", { class: "flex items-center gap-1.5 text-red-700" }, [
                _("svg", {
                  class: "w-4 h-4",
                  fill: "none",
                  viewBox: "0 0 24 24",
                  stroke: "currentColor"
                }, [
                  _("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  })
                ]),
                _("p", { class: "text-xs font-black uppercase tracking-wider" }, "上次開立失敗")
              ], -1)),
              _("p", Vg, [
                e.payment.invoice_transaction.error_code ? (X(), ee("span", Hg, "[" + j(e.payment.invoice_transaction.error_code) + "]", 1)) : Ue("", !0),
                Lt(" " + j(e.payment.invoice_transaction.error_message), 1)
              ])
            ])) : Ue("", !0),
            _("div", null, [
              d[8] || (d[8] = _("label", { class: "block text-xs font-bold text-gray-700 uppercase tracking-wider mb-2" }, "手機條碼 (CarrierNum)", -1)),
              Io(_("input", {
                "onUpdate:modelValue": d[1] || (d[1] = (C) => i.CarrierNum = C),
                type: "text",
                maxlength: "8",
                placeholder: "/ABC1234",
                class: "w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-blue-700 focus:ring-2 focus:ring-blue-700/20 transition-all outline-none font-mono"
              }, null, 512), [
                [$o, i.CarrierNum]
              ]),
              d[9] || (d[9] = _("p", { class: "text-[10px] text-gray-700 opacity-50 mt-1.5 ml-1" }, "* 第一碼必須為斜線 /", -1))
            ]),
            _("div", null, [
              d[10] || (d[10] = _("label", { class: "block text-xs font-bold text-gray-700 uppercase tracking-wider mb-2" }, "買受人統編 (CustomerIdentifier)", -1)),
              Io(_("input", {
                "onUpdate:modelValue": d[2] || (d[2] = (C) => i.CustomerIdentifier = C),
                onInput: l,
                type: "text",
                maxlength: "8",
                placeholder: "8 位數字統編",
                class: "w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-blue-700 focus:ring-2 focus:ring-blue-700/20 transition-all outline-none font-mono"
              }, null, 544), [
                [$o, i.CustomerIdentifier]
              ]),
              a.value ? (X(), ee("p", jg, j(a.value), 1)) : Ue("", !0)
            ]),
            _("div", null, [
              d[12] || (d[12] = _("label", { class: "block text-xs font-bold text-gray-700 uppercase tracking-wider mb-2" }, "買受人名稱 (CustomerName)", -1)),
              _("div", Yg, [
                Io(_("input", {
                  "onUpdate:modelValue": d[3] || (d[3] = (C) => i.CustomerName = C),
                  type: "text",
                  placeholder: "公司全名",
                  class: "w-full px-4 py-3 rounded-xl border border-gray-200 focus:border-blue-700 focus:ring-2 focus:ring-blue-700/20 transition-all outline-none"
                }, null, 512), [
                  [$o, i.CustomerName]
                ]),
                s.value ? (X(), ee("div", Wg, [...d[11] || (d[11] = [
                  _("div", { class: "animate-spin rounded-full h-4 w-4 border-2 border-blue-700 border-t-transparent" }, null, -1)
                ])])) : Ue("", !0)
              ])
            ])
          ]),
          _("div", qg, [
            _("button", {
              onClick: d[4] || (d[4] = (C) => o("close")),
              class: "px-4 py-3 rounded-2xl border border-gray-200 text-gray-700 font-bold hover:bg-white transition-colors"
            }, " 取消 "),
            _("button", {
              onClick: y,
              disabled: r.value,
              class: "flex-1 px-4 py-3 rounded-2xl border border-red-200 text-red-700 font-bold hover:bg-red-50 disabled:opacity-50 transition-all"
            }, j(r.value ? "處理中..." : "作廢交易"), 9, zg),
            _("button", {
              onClick: p,
              disabled: r.value || ((T = (h = e.payment) == null ? void 0 : h.invoice_transaction) == null ? void 0 : T.status) === "issued",
              class: "flex-1 px-4 py-3 rounded-2xl bg-blue-700 text-white font-bold hover:bg-blue-800 disabled:opacity-50 disabled:cursor-not-allowed transition-all shadow-lg shadow-blue-700/20"
            }, j(r.value ? "處理中..." : ((g = (m = e.payment) == null ? void 0 : m.invoice_transaction) == null ? void 0 : g.status) === "issued" ? "發票已開立" : "確認開立"), 9, Kg)
          ])
        ])
      ])) : Ue("", !0);
    };
  }
}), Xg = { class: "p-4 sm:p-6 max-w-3xl mx-auto bg-gray-100 min-h-screen" }, Zg = { class: "mb-6" }, Jg = { class: "text-2xl sm:text-3xl font-black text-gray-700" }, Qg = { class: "text-gray-700 mt-1 opacity-70 text-sm sm:text-base" }, eb = { class: "mb-4 flex gap-2" }, tb = ["disabled"], nb = {
  key: 0,
  class: "text-center py-20"
}, ob = { class: "mt-4 text-blue-700 font-bold" }, rb = {
  key: 1,
  class: "bg-red-100 text-red-700 p-4 rounded-2xl border border-red-700 shadow-sm"
}, sb = {
  key: 2,
  class: "flex flex-col gap-6"
}, ab = { class: "flex flex-col sm:flex-row items-center justify-between gap-4 bg-white px-6 py-4 rounded-2xl border border-gray-100 shadow-xs mt-2" }, ib = { class: "text-sm text-gray-500" }, lb = { class: "font-bold text-blue-600" }, cb = { class: "font-bold text-gray-800" }, ub = { class: "flex items-center gap-3" }, db = ["disabled"], mb = ["disabled"], fb = {
  key: 3,
  class: "text-center py-20 text-gray-700 bg-white rounded-3xl border border-gray-100 shadow-sm"
}, wb = { class: "mt-4 font-medium" }, gb = /* @__PURE__ */ $t({
  __name: "EcpayPaymentPage",
  props: {
    ecpayApi: {}
  },
  setup(e) {
    const { t } = fn(), n = e, {
      isLoading: o,
      paymentError: r,
      paymentsList: s,
      filterRtnCode: a,
      pagination: i,
      stats: l,
      loadPaymentInfo: p,
      changeFilter: y,
      createInvoice: k,
      queryCompanyName: d,
      voidPayment: w
    } = nw(n.ecpayApi), N = Ve(!1), h = Ve(null), T = (C) => {
      var f;
      String(C.rtn_code) === "1" && ((f = C.invoice_transaction) != null && f.print_html ? window.open(C.invoice_transaction.print_html, "_blank") : (h.value = C, N.value = !0));
    }, m = () => {
      N.value = !1, h.value = null;
    }, g = async () => {
      m(), await p(i.currentPage);
    };
    return dr(async () => {
      await p(1);
    }), (C, f) => (X(), ee("div", Xg, [
      _("header", Zg, [
        _("h1", Jg, j(K(t)("ecpay.title") || "交易紀錄管理"), 1),
        _("p", Qg, j(K(t)("ecpay.subtitle") || "檢視您系統中的所有綠界付款單據"), 1)
      ]),
      _("div", eb, [
        _("button", {
          onClick: f[0] || (f[0] = (A) => K(y)(void 0)),
          class: tn(["px-4 py-2 rounded-xl font-bold text-sm transition-all", K(a) === void 0 ? "bg-blue-700 text-white shadow-lg shadow-blue-700/20" : "bg-white text-gray-700 border border-gray-200 hover:bg-gray-50"])
        }, " 顯示全部 ", 2),
        _("button", {
          onClick: f[1] || (f[1] = (A) => K(y)("-1")),
          class: tn(["px-4 py-2 rounded-xl font-bold text-sm transition-all", K(a) === "-1" ? "bg-blue-700 text-white shadow-lg shadow-blue-700/20" : "bg-white text-gray-700 border border-gray-200 hover:bg-gray-50"])
        }, " 只顯示作廢 ", 2),
        _("button", {
          onClick: f[2] || (f[2] = (A) => K(p)(K(i).currentPage)),
          disabled: K(o),
          class: "px-4 py-2 rounded-xl font-bold text-sm transition-all bg-white text-gray-700 border border-gray-200 hover:bg-gray-50 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
        }, [...f[5] || (f[5] = [
          _("svg", {
            class: "inline-block w-4 h-4 mr-1",
            fill: "none",
            viewBox: "0 0 24 24",
            stroke: "currentColor"
          }, [
            _("path", {
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
            })
          ], -1),
          Lt(" 重新整理 ", -1)
        ])], 8, tb)
      ]),
      K(o) ? (X(), ee("div", nb, [
        f[6] || (f[6] = _("div", { class: "inline-block animate-spin rounded-full h-8 w-8 border-4 border-blue-700 border-t-transparent" }, null, -1)),
        _("p", ob, j(K(t)("common.loading") || "載入資料中..."), 1)
      ])) : K(r) ? (X(), ee("div", rb, j(K(r)), 1)) : K(s).length > 0 ? (X(), ee("div", sb, [
        Wo(mw, xl(Cl(K(l))), null, 16),
        (X(!0), ee(Nn, null, mr(K(s), (A) => (X(), Al(qw, {
          key: A.id,
          payment: A,
          onClickCard: T
        }, null, 8, ["payment"]))), 128)),
        _("div", ab, [
          _("p", ib, [
            f[7] || (f[7] = Lt(" 目前在第 ", -1)),
            _("span", lb, j(K(i).currentPage), 1),
            f[8] || (f[8] = Lt(" 頁 / 共 ", -1)),
            _("span", cb, j(K(i).totalPages), 1),
            f[9] || (f[9] = Lt(" 頁 ", -1))
          ]),
          _("div", ub, [
            _("button", {
              disabled: K(i).currentPage <= 1,
              onClick: f[3] || (f[3] = (A) => K(p)(K(i).currentPage - 1)),
              class: "inline-flex items-center rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm font-bold text-gray-700 transition hover:bg-gray-50 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
            }, " 上一頁 ", 8, db),
            _("button", {
              disabled: K(i).currentPage >= K(i).totalPages,
              onClick: f[4] || (f[4] = (A) => K(p)(K(i).currentPage + 1)),
              class: "inline-flex items-center rounded-xl border border-gray-200 bg-white px-4 py-2 text-sm font-bold text-gray-700 transition hover:bg-gray-50 disabled:bg-gray-100 disabled:text-gray-400 disabled:border-gray-200 disabled:cursor-not-allowed"
            }, " 下一頁 ", 8, mb)
          ])
        ])
      ])) : (X(), ee("div", fb, [
        f[10] || (f[10] = _("svg", {
          class: "mx-auto h-12 w-12 text-gray-700",
          fill: "none",
          viewBox: "0 0 24 24",
          stroke: "currentColor"
        }, [
          _("path", {
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-width": "2",
            d: "M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2"
          })
        ], -1)),
        _("p", wb, j(K(t)("ecpay.noData") || "暫無任何交易紀錄"), 1)
      ])),
      Wo(Gg, {
        "is-open": N.value,
        payment: h.value,
        "query-company-name": K(d),
        "create-invoice": K(k),
        "void-payment": K(w),
        onClose: m,
        onSuccess: g
      }, null, 8, ["is-open", "payment", "query-company-name", "create-invoice", "void-payment"])
    ]));
  }
});
export {
  gb as EcpayPaymentPage,
  hb as RevenueReportPage
};
